webpackJsonp([1],{

/***/ "+3+u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+667":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Loader'
});

/***/ }),

/***/ "+H/O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-ext"},[_c('div',{staticClass:"page-header"},[_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col-10 text-left pl-0"},[_c('h2',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t('registration.tabs.tabImageExtractor')))])]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"row title justify-content-center"},[_c('button',{staticClass:"btn btn-default",on:{"click":_vm.prevDoc}},[_c('i',{staticClass:"mdi mdi-chevron-left"})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":_vm.nextDoc}},[_c('i',{staticClass:"mdi mdi-chevron-right"})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8 pl-0"},[_c('div',{staticClass:"imgcss",style:({ backgroundImage: 'url(' + _vm.imagePath + ')',  backgroundSize: '600px 800px', backgroundRepeat: 'no-repeat' }),attrs:{"id":"container"}})]),_vm._v(" "),_c('form',{staticClass:"col-4 bg-grey-form",attrs:{"action":"POST","data-vv-scope":"form-1"},on:{"submit":function($event){$event.preventDefault();_vm.save('form-1')}}},[(_vm.questionList.length < 1)?_c('div'):_vm._e(),_vm._v(" "),_vm._l((_vm.questionList),function(que,index){return _c('div',{key:index},[_c('div',{staticClass:"wrap-cb mt-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col align-self-center"},[_c('label',{staticClass:"c-wrap"},[_vm._v(" "+_vm._s(que.title)+" "),_vm._m(1,true)])])]),_vm._v(" "),_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col align-self-center"},[_c('div',{staticClass:"form-group custom-input col-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(que.value),expression:"que.value"},{name:"validate",rawName:"v-validate",value:({'required' : true,'regex': que.regex}),expression:"{'required' : true,'regex': que.regex}"}],staticClass:"form-control-alt col-12 ",class:{'form-error': _vm.errors.has('form-1.'+que.title),'input': true, 'is-danger': _vm.errors.has('form-1.'+que.title) },attrs:{"type":"text","id":que.title,"name":que.title,"placeholder":que.placeholder},domProps:{"value":(que.value)},on:{"input":function($event){if($event.target.composing){ return; }que.value=$event.target.value}}})])])])])])})],2)]),_vm._v(" "),_c('div',{staticClass:" row text-center p-3"},[_c('button',{staticClass:"btn btn btn-info-alt mr-3",attrs:{"type":"button"},on:{"click":_vm.prevTabFunc}},[_vm._v(" "+_vm._s(_vm.$t('button.back')))]),_vm._v(" "),_c('button',{staticClass:"btn btn btn-orange ml-auto",attrs:{"type":"button"},on:{"click":_vm.nextTabFunc}},[_vm._v(" "+_vm._s(_vm.$t('button.next')))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2 lighten text-right"},[_c('h2',{staticClass:"page-title"},[_vm._v("85%")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])}]


/***/ }),

/***/ "/9U9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/AnM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


__WEBPACK_IMPORTED_MODULE_0_axios___default.a.default.baseURL = '';
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Entry',
  data: function data() {
    return {
      instructions: {}
    };
  },
  mounted: function mounted() {
    this.getTermCondition();
  },

  methods: {
    getTermCondition: function getTermCondition() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('r/getGeneralInstructions/' + 'TermCondition').then(function (responses) {
        if (responses.status === 200) {
          _this.instructions = responses.data;
        }
      }).catch(function (e) {
        console.log(e);
      });
    }
  }
});

/***/ }),

/***/ "/FpJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edu-details"},[_c('div',{staticClass:"page-header"},[_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col-10 text-left"},[_c('h2',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t('registration.tabs.tabEducationDetails')))])]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('form',{staticClass:"row justify-content-center",attrs:{"action":"POST","data-vv-scope":"educationForm"},on:{"submit":function($event){$event.preventDefault();_vm.saveDetails('educationForm')}}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group custom-input"},[(_vm.qualification === null || _vm.qualification.qualificationTypeID !== 8)?_c('div',[_c('div',{staticClass:"para"},[_vm._v(_vm._s(_vm.$t('candidateProfile.educationDetails.lblPassedOrAppeared')))]),_vm._v(" "),_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|not_in:Select'),expression:"'required|not_in:Select'"}],class:{'form-error': _vm.errors.has('qualification status')},attrs:{"v-on:change":_vm.changeStatusSelection(_vm.qualificationStatus),"label":"name","options":_vm.qualificationStatusList,"error-messages":_vm.errors.collect('qualificationStatus'),"data-vv-name":"qualification status","name":"name","placeholder":_vm.$t('candidateProfile.educationDetails.plceQualificationStatus'),"required":""},model:{value:(_vm.qualificationStatus),callback:function ($$v) {_vm.qualificationStatus=$$v},expression:"qualificationStatus"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(_vm._s(_vm.$t('candidateProfile.educationDetails.lblIn')))]),_vm._v(" "),_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|not_in:Select'),expression:"'required|not_in:Select'"}],class:{'form-error': _vm.errors.has('qualification details')},attrs:{"v-on:change":_vm.changeSelection(_vm.qualification),"label":"name","options":_vm.filterQualificationList,"error-messages":_vm.errors.collect('qualification'),"data-vv-name":"qualification details","name":"name","placeholder":_vm.$t('candidateProfile.educationDetails.plceQualification'),"required":""},model:{value:(_vm.qualification),callback:function ($$v) {_vm.qualification=$$v},expression:"qualification"}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(_vm._s(_vm.$t('candidateProfile.educationDetails.lblExam')))])],1):_vm._e(),_vm._v(" "),(_vm.qualification !== null && _vm.qualification.qualificationTypeID === 8)?_c('div',[_c('div',{staticClass:"para"},[_vm._v("I ")]),_vm._v(" "),_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|not_in:Select'),expression:"'required|not_in:Select'"}],class:{'form-error': _vm.errors.has('qualification details')},attrs:{"label":"name","v-on:change":_vm.changeSelection(_vm.qualification),"options":_vm.qualificationList,"error-messages":_vm.errors.collect('qualification'),"data-vv-name":"qualification details","name":"name","placeholder":_vm.$t('candidateProfile.educationDetails.plceQualification'),"required":""},model:{value:(_vm.qualification),callback:function ($$v) {_vm.qualification=$$v},expression:"qualification"}}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(_vm._s(_vm.$t('candidateProfile.educationDetails.lblHscOrDiploma'))+" ")])],1):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:" row text-center p-3"},[_c('button',{staticClass:"btn btn btn-info-alt mr-3",attrs:{"type":"button"},on:{"click":_vm.prevTabFunc}},[_vm._v(" "+_vm._s(_vm.$t('button.back')))]),_vm._v(" "),_c('button',{staticClass:"btn btn btn-orange ml-auto",attrs:{"type":"button"},on:{"click":_vm.nextTabFunc}},[_vm._v(" "+_vm._s(_vm.$t('button.next')))])]),_vm._v(" "),(_vm.showModal)?_c('modal',{staticClass:"sm hide-header",on:{"close":function($event){_vm.showModal = false}}},[_c('h5',{staticClass:"text-center",slot:"header"},[_vm._v(_vm._s(_vm.$t('candidateProfile.educationDetails.lblConfiramtion')))]),_vm._v(" "),_c('p',{staticClass:"green",slot:"body"},[_c('span',{staticClass:"red"},[_vm._v(_vm._s(_vm.$t('candidateProfile.educationDetails.lblNote'))+" ")]),_vm._v(" "+_vm._s(_vm.$t('candidateProfile.educationDetails.lblName'))+"\n  ")]),_vm._v(" "),_c('div',{slot:"footer"},[_c('b-link',{staticClass:"btn btn-success-alt mr-3",attrs:{"to":"agreement"}},[_vm._v(_vm._s(_vm.$t('button.yes')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-info-alt",attrs:{"type":"button"},on:{"click":function($event){_vm.showModal = false}}},[_vm._v(_vm._s(_vm.$t('button.no')))])],1)]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2 lighten text-right"},[_c('h2',{staticClass:"page-title"},[_vm._v("51%")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])}]


/***/ }),

/***/ "/aqT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/c/L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    required: false,
    value: {
      required: true
    },
    option: {
      type: Object,
      default: function _default() {
        return {
          type: 'day',
          SundayFirst: false,
          week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
          month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          format: 'YYYY-MM-DD',
          color: {
            checked: '#F50057',
            header: '#3f51b5',
            headerText: '#fff'
          },
          wrapperClass: '',
          inputClass: '',
          dateBodyClass: '',
          inputStyle: {
            'display': 'inline-block',
            'padding': '6px',
            'line-height': '22px',
            'font-size': '16px',
            'border': '2px solid #fff',
            'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
            'border-radius': '2px',
            'color': '#5F5F5F'
          },
          placeholder: 'when?',
          buttons: {
            ok: 'OK',
            cancel: 'Cancel'
          },
          overlayOpacity: 0.5,
          dismissible: true
        };
      }
    },
    limit: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    function hours() {
      var list = [];
      var hour = 24;
      while (hour > 0) {
        hour--;
        list.push({
          checked: false,
          value: hour < 10 ? '0' + hour : hour
        });
      }
      return list;
    }
    function mins() {
      var list = [];
      var min = 60;
      while (min > 0) {
        min--;
        list.push({
          checked: false,
          value: min < 10 ? '0' + min : min
        });
      }
      return list;
    }
    return {
      hours: hours(),
      mins: mins(),
      showInfo: {
        hour: false,
        day: false,
        month: false,
        year: false,
        check: false
      },
      displayInfo: {
        month: ''
      },
      library: {
        week: this.option.week,
        month: this.option.month,
        year: []
      },
      checked: {
        oldtime: '',
        currentMoment: null,
        year: '',
        month: '',
        day: '',
        hour: '00',
        min: '00'
      },
      dayList: [],
      selectedDays: []
    };
  },


  methods: {
    pad: function pad(n) {
      n = Math.floor(n);
      return n < 10 ? '0' + n : n;
    },
    nextMonth: function nextMonth(type) {
      var next = null;
      type === 'next' ? next = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).add(1, 'M') : next = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).add(-1, 'M');
      this.showDay(next);
    },
    showDay: function showDay(time) {
      if (time === undefined || !__WEBPACK_IMPORTED_MODULE_2_moment___default()(time, this.option.format).isValid()) {
        this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      } else {
        this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(time, this.option.format);
      }
      this.showOne('day');
      this.checked.year = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format('YYYY');
      this.checked.month = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format('MM');
      this.checked.day = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format('DD');
      this.displayInfo.month = this.library.month[__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).month()];
      var days = [];
      var currentMoment = this.checked.currentMoment;
      var firstDay = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).date(1).day();
      // gettting previous and next month
      // let currentMonth = moment(currentMoment)
      var previousMonth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment);
      var nextMonth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment);
      nextMonth.add(1, 'months');
      previousMonth.subtract(1, 'months');
      var monthDays = __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).daysInMonth();
      var oldtime = this.checked.oldtime;
      for (var i = 1; i <= monthDays; ++i) {
        days.push({
          value: i,
          inMonth: true,
          unavailable: false,
          checked: false,
          moment: __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).date(i)
        });
        if (i === Math.ceil(__WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).format('D')) && __WEBPACK_IMPORTED_MODULE_2_moment___default()(oldtime, this.option.format).year() === __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).year() && __WEBPACK_IMPORTED_MODULE_2_moment___default()(oldtime, this.option.format).month() === __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).month()) {
          days[i - 1].checked = true;
        }
        this.checkBySelectDays(i, days);
      }
      if (firstDay === 0) firstDay = 7;
      for (var _i = 0; _i < firstDay - (this.option.SundayFirst ? 0 : 1); _i++) {
        var passiveDay = {
          value: previousMonth.daysInMonth() - _i,
          inMonth: false,
          action: 'previous',
          unavailable: false,
          checked: false,
          moment: __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).date(1).subtract(_i + 1, 'days')
        };
        days.unshift(passiveDay);
      }
      var passiveDaysAtFinal = 42 - days.length;
      for (var _i2 = 1; _i2 <= passiveDaysAtFinal; _i2++) {
        var _passiveDay = {
          value: _i2,
          inMonth: false,
          action: 'next',
          unavailable: false,
          checked: false,
          moment: __WEBPACK_IMPORTED_MODULE_2_moment___default()(currentMoment).add(1, 'months').date(_i2)
        };
        days.push(_passiveDay);
      }
      if (this.limit.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.limit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var li = _step.value;

            switch (li.type) {
              case 'fromto':
                days = this.limitFromTo(li, days);
                break;
              case 'weekday':
                days = this.limitWeekDay(li, days);
                break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      this.dayList = days;
    },
    checkBySelectDays: function checkBySelectDays(d, days) {
      var _this = this;

      this.selectedDays.forEach(function (day) {
        if (_this.checked.year === __WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('YYYY') && _this.checked.month === __WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('MM') && d === Math.ceil(__WEBPACK_IMPORTED_MODULE_2_moment___default()(day).format('D'))) {
          days[d - 1].checked = true;
        }
      });
    },
    limitWeekDay: function limitWeekDay(limit, days) {
      days.map(function (day) {
        if (limit.available.indexOf(Math.floor(day.moment.format('d'))) === -1) {
          day.unavailable = true;
        }
      });
      return days;
    },
    limitFromTo: function limitFromTo(limit, days) {
      var _this2 = this;

      if (limit.from || limit.to) {
        days.map(function (day) {
          if (_this2.getLimitCondition(limit, day)) {
            day.unavailable = true;
          }
        });
      }
      return days;
    },
    getLimitCondition: function getLimitCondition(limit, day) {
      var tmpMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(day.moment.year() + '-' + this.pad(day.moment.month() + 1) + '-' + this.pad(day.value));
      if (limit.from && !limit.to) {
        return !tmpMoment.isAfter(limit.from);
      } else if (!limit.from && limit.to) {
        return !tmpMoment.isBefore(limit.to);
      } else {
        return !tmpMoment.isBetween(limit.from, limit.to);
      }
    },
    checkDay: function checkDay(obj) {
      if (obj.unavailable || obj.value === '') {
        return false;
      }
      if (!obj.inMonth) {
        this.nextMonth(obj.action);
      }
      if (this.option.type === 'day' || this.option.type === 'min') {
        this.dayList.forEach(function (x) {
          x.checked = false;
        });
        this.checked.day = this.pad(obj.value);
        obj.checked = true;
      } else {
        var day = this.pad(obj.value);
        var ctime = this.checked.year + '-' + this.checked.month + '-' + day;
        if (obj.checked === true) {
          obj.checked = false;
          this.selectedDays.$remove(ctime);
        } else {
          this.selectedDays.push(ctime);
          obj.checked = true;
        }
      }
      switch (this.option.type) {
        case 'day':
          this.picked();
          break;
        case 'min':
          this.showOne('hour');
          // shift activated time items to visible position.
          this.shiftActTime();
          break;
      }
    },
    showYear: function showYear() {
      var _this3 = this;

      var year = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).year();
      this.library.year = [];
      var yearTmp = [];
      for (var i = year - 100; i < year + 5; ++i) {
        yearTmp.push(i);
      }
      this.library.year = yearTmp;
      this.showOne('year');
      this.$nextTick(function () {
        var listDom = document.getElementById('yearList');
        listDom.scrollTop = listDom.scrollHeight - 100;
        _this3.addYear();
      });
    },
    showOne: function showOne(type) {
      switch (type) {
        case 'year':
          this.showInfo.hour = false;
          this.showInfo.day = false;
          this.showInfo.year = true;
          this.showInfo.month = false;
          break;
        case 'month':
          this.showInfo.hour = false;
          this.showInfo.day = false;
          this.showInfo.year = false;
          this.showInfo.month = true;
          break;
        case 'day':
          this.showInfo.hour = false;
          this.showInfo.day = true;
          this.showInfo.year = false;
          this.showInfo.month = false;
          break;
        case 'hour':
          this.showInfo.hour = true;
          this.showInfo.day = false;
          this.showInfo.year = false;
          this.showInfo.month = false;
          break;
        default:
          this.showInfo.day = true;
          this.showInfo.year = false;
          this.showInfo.month = false;
          this.showInfo.hour = false;
      }
    },
    showMonth: function showMonth() {
      this.showOne('month');
    },
    addYear: function addYear() {
      var _this4 = this;

      var listDom = document.getElementById('yearList');
      listDom.addEventListener('scroll', function (e) {
        if (listDom.scrollTop < listDom.scrollHeight - 100) {
          var len = _this4.library.year.length;
          var lastYear = _this4.library.year[len - 1];
          _this4.library.year.push(lastYear + 1);
        }
      }, false);
    },
    setYear: function setYear(year) {
      this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(year + '-' + this.checked.month + '-' + this.checked.day);
      this.showDay(this.checked.currentMoment);
    },
    setMonth: function setMonth(month) {
      var mo = this.library.month.indexOf(month) + 1;
      if (mo < 10) {
        mo = '0' + '' + mo;
      }
      this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.year + '-' + mo + '-' + this.checked.day);
      this.showDay(this.checked.currentMoment);
    },
    showCheck: function showCheck() {
      if (this.value === '') {
        this.showDay();
      } else {
        if (this.option.type === 'day' || this.option.type === 'min') {
          this.checked.oldtime = this.value;
          this.showDay(this.value);
        } else {
          this.selectedDays = JSON.parse(this.value);
          if (this.selectedDays.length) {
            this.checked.oldtime = this.selectedDays[0];
            this.showDay(this.selectedDays[0]);
          } else {
            this.showDay();
          }
        }
      }
      this.showInfo.check = true;
    },
    setTime: function setTime(type, obj, list) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          item.checked = false;
          if (item.value === obj.value) {
            item.checked = true;
            this.checked[type] = item.value;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    picked: function picked() {
      var selected_date;
      if (this.option.type === 'day' || this.option.type === 'min') {
        var ctime = this.checked.year + '-' + this.checked.month + '-' + this.checked.day + ' ' + this.checked.hour + ':' + this.checked.min;
        this.checked.currentMoment = __WEBPACK_IMPORTED_MODULE_2_moment___default()(ctime, 'YYYY-MM-DD HH:mm');
        selected_date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.checked.currentMoment).format(this.option.format);
      } else {
        selected_date = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedDays);
      }
      this.showInfo.check = false;
      this.$emit('input', selected_date);
      this.$emit('change', selected_date);
    },
    dismiss: function dismiss(evt) {
      if (evt.target.className === 'datepicker-overlay') {
        if (this.option.dismissible === undefined || this.option.dismissible) {
          this.showInfo.check = false;
          this.$emit('cancel');
        }
      }
    },
    shiftActTime: function shiftActTime() {
      // shift activated time items to visible position.
      this.$nextTick(function () {
        if (!document.querySelector('.hour-item.active')) {
          return false;
        }
        document.querySelector('.hour-box').scrollTop = (document.querySelector('.hour-item.active').offsetTop || 0) - 250;
        document.querySelector('.min-box').scrollTop = (document.querySelector('.min-item.active').offsetTop || 0) - 250;
      });
    }
  }
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0jZp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__("hiCB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_max_safe_integer__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'picture-input',
  props: {
    width: {
      type: [String, Number],
      default: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_max_safe_integer___default.a
    },
    height: {
      type: [String, Number],
      default: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_max_safe_integer___default.a
    },
    margin: {
      type: [String, Number],
      default: 0
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    size: {
      type: [String, Number],
      default: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_max_safe_integer___default.a
    },
    name: {
      type: String,
      default: null
    },
    id: {
      type: [String, Number],
      default: null
    },
    buttonClass: {
      type: String,
      default: 'btn btn-primary button'
    },
    removeButtonClass: {
      type: String,
      default: 'btn btn-secondary button secondary'
    },
    aspectButtonClass: {
      type: String,
      default: 'btn btn-secondary button secondary'
    },
    prefill: {
      type: [String, File],
      default: ''
    },
    prefillOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    crop: {
      type: Boolean,
      default: true
    },
    radius: {
      type: [String, Number],
      default: 0
    },
    removable: {
      type: Boolean,
      default: false
    },
    hideChangeButton: {
      type: Boolean,
      default: false
    },
    autoToggleAspectRatio: {
      type: Boolean,
      default: false
    },
    toggleAspectRatio: {
      type: Boolean,
      default: false
    },
    changeOnClick: {
      type: Boolean,
      default: true
    },
    plain: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default: 10000
    },
    alertOnError: {
      type: Boolean,
      default: true
    },
    customStrings: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    prefill: function prefill() {
      if (this.prefill) {
        this.preloadImage(this.prefill, this.prefillOptions);
      } else {
        this.removeImage();
      }
    }
  },
  data: function data() {
    return {
      imageSelected: false,
      previewHeight: 0,
      previewWidth: 0,
      draggingOver: false,
      canvasWidth: 0,
      canvasHeight: 0,
      strings: {
        upload: '<p>Your device does not support file uploading.</p>',
        drag: 'Drag an image or <br>click here to select a file',
        tap: 'Tap here to select a photo <br>from your gallery',
        change: 'Change Photo',
        aspect: 'Landscape/Portrait',
        remove: 'Remove Photo',
        select: 'Select a Photo',
        selected: '<p>Photo successfully selected!</p>',
        fileSize: 'The file size exceeds the limit',
        fileType: 'This file type is not supported.'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.updateStrings();
    if (this.prefill) {
      this.preloadImage(this.prefill, this.prefillOptions);
    }

    this.$nextTick(function () {
      window.addEventListener('resize', _this.onResize);
      _this.onResize();
    });
    if (this.supportsPreview) {
      this.pixelRatio = Math.round(window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI);
      var canvas = this.$refs.previewCanvas;
      if (canvas.getContext) {
        this.context = canvas.getContext('2d');
        this.context.scale(this.pixelRatio, this.pixelRatio);
      }
    }
    if (this.accept !== 'image/*') {
      this.fileTypes = this.accept.split(',');
      this.fileTypes = this.fileTypes.map(function (s) {
        return s.trim();
      });
    }

    this.canvasWidth = this.width;
    this.canvasHeight = this.height;

    this.$on('error', this.onError);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    this.$off('error', this.onError);
  },

  methods: {
    updateStrings: function updateStrings() {
      for (var s in this.customStrings) {
        if (s in this.strings && typeof this.customStrings[s] === 'string') {
          this.strings[s] = this.customStrings[s];
        }
      }
    },
    onClick: function onClick() {
      if (!this.imageSelected) {
        this.selectImage();
        return;
      }

      if (this.changeOnClick) {
        this.selectImage();
      }

      this.$emit('click');
    },
    onResize: function onResize() {
      this.resizeCanvas();

      if (this.imageObject) {
        this.drawImage(this.imageObject);
      }
    },
    onDragStart: function onDragStart() {
      if (!this.supportsDragAndDrop) {
        return;
      }
      this.draggingOver = true;
    },
    onDragStop: function onDragStop() {
      if (!this.supportsDragAndDrop) {
        return;
      }
      this.draggingOver = false;
    },
    onFileDrop: function onFileDrop(e) {
      this.onDragStop();
      this.onFileChange(e);
    },
    onFileChange: function onFileChange(e, prefill) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      if (files[0].size <= 0 || files[0].size > this.size * 1024 * 1024) {
        this.$emit('error', {
          type: 'fileSize',
          fileSize: files[0].size,
          fileType: files[0].type,
          fileName: files[0].name,
          message: this.strings.fileSize + ' (' + this.size + 'MB)'
        });
        return;
      }
      if (files[0].name === this.fileName && files[0].size === this.fileSize && this.fileModified === files[0].lastModified) {
        return;
      }

      this.file = files[0];
      this.fileName = files[0].name;
      this.fileSize = files[0].size;
      this.fileModified = files[0].lastModified;
      this.fileType = files[0].type;

      if (this.accept === 'image/*') {
        if (files[0].type.substr(0, 6) !== 'image/') {
          return;
        }
      } else {
        if (this.fileTypes.indexOf(files[0].type) === -1) {
          this.$emit('error', {
            type: 'fileType',
            fileSize: files[0].size,
            fileType: files[0].type,
            fileName: files[0].name,
            message: this.strings.fileType
          });
          return;
        }
      }
      this.imageSelected = true;
      this.image = '';
      if (this.supportsPreview) {
        this.loadImage(files[0], prefill || false);
      } else {
        if (prefill) {
          this.$emit('prefill');
        } else {
          this.$emit('change', this.image);
        }
      }
    },
    onError: function onError(error) {
      if (this.alertOnError) {
        alert(error.message);
      }
    },
    loadImage: function loadImage(file, prefill) {
      var _this2 = this;

      this.getEXIFOrientation(file, function (orientation) {
        _this2.setOrientation(orientation);
        var reader = new FileReader();
        reader.onload = function (e) {
          _this2.image = e.target.result;
          if (prefill) {
            _this2.$emit('prefill');
          } else {
            _this2.$emit('change', _this2.image);
          }
          _this2.imageObject = new Image();
          _this2.imageObject.onload = function () {
            if (_this2.autoToggleAspectRatio) {
              var canvasOrientation = _this2.getOrientation(_this2.canvasWidth, _this2.canvasHeight);
              var imageOrientation = _this2.getOrientation(_this2.imageObject.width, _this2.imageObject.height);
              if (canvasOrientation !== imageOrientation) {
                _this2.rotateCanvas();
              }
            }
            _this2.drawImage(_this2.imageObject);
          };
          _this2.imageObject.src = _this2.image;
        };
        reader.readAsDataURL(file);
      });
    },
    drawImage: function drawImage(image) {
      this.imageWidth = image.width;
      this.imageHeight = image.height;
      this.imageRatio = image.width / image.height;
      var offsetX = 0;
      var offsetY = 0;
      var scaledWidth = this.previewWidth;
      var scaledHeight = this.previewHeight;
      var previewRatio = this.previewWidth / this.previewHeight;
      if (this.crop) {
        if (this.imageRatio >= previewRatio) {
          scaledWidth = scaledHeight * this.imageRatio;
          offsetX = (this.previewWidth - scaledWidth) / 2;
        } else {
          scaledHeight = scaledWidth / this.imageRatio;
          offsetY = (this.previewHeight - scaledHeight) / 2;
        }
      } else {
        if (this.imageRatio >= previewRatio) {
          scaledHeight = scaledWidth / this.imageRatio;
          offsetY = (this.previewHeight - scaledHeight) / 2;
        } else {
          scaledWidth = scaledHeight * this.imageRatio;
          offsetX = (this.previewWidth - scaledWidth) / 2;
        }
      }
      var canvas = this.$refs.previewCanvas;
      canvas.style.background = 'none';
      canvas.width = this.previewWidth * this.pixelRatio;
      canvas.height = this.previewHeight * this.pixelRatio;
      this.context.setTransform(1, 0, 0, 1, 0, 0);
      this.context.clearRect(0, 0, canvas.width, canvas.height);
      if (this.rotate) {
        this.context.translate(offsetX * this.pixelRatio, offsetY * this.pixelRatio);
        this.context.translate(scaledWidth / 2 * this.pixelRatio, scaledHeight / 2 * this.pixelRatio);
        this.context.rotate(this.rotate);
        offsetX = -scaledWidth / 2;
        offsetY = -scaledHeight / 2;
      }
      this.context.drawImage(image, offsetX * this.pixelRatio, offsetY * this.pixelRatio, scaledWidth * this.pixelRatio, scaledHeight * this.pixelRatio);
    },
    selectImage: function selectImage() {
      this.$refs.fileInput.click();
    },
    removeImage: function removeImage() {
      this.$refs.fileInput.value = '';
      this.$refs.fileInput.type = '';
      this.$refs.fileInput.type = 'file';
      this.fileName = '';
      this.fileType = '';
      this.fileSize = 0;
      this.fileModified = 0;
      this.imageSelected = false;
      this.image = '';
      this.file = null;
      this.imageObject = null;
      this.$refs.previewCanvas.style.backgroundColor = 'rgba(200,200,200,.25)';
      this.$refs.previewCanvas.width = this.previewWidth * this.pixelRatio;
      this.$emit('remove');
    },
    rotateImage: function rotateImage() {
      this.rotateCanvas();

      if (this.imageObject) {
        this.drawImage(this.imageObject);
      }

      var newOrientation = this.getOrientation(this.canvasWidth, this.canvasHeight);
      this.$emit('aspectratiochange', newOrientation);
    },
    resizeCanvas: function resizeCanvas() {
      var previewRatio = this.canvasWidth / this.canvasHeight;
      var newWidth = this.$refs.container.clientWidth;
      if (!this.toggleAspectRatio && newWidth === this.containerWidth) {
        return;
      }
      this.containerWidth = newWidth;
      this.previewWidth = Math.min(this.containerWidth - this.margin * 2, this.canvasWidth);
      this.previewHeight = this.previewWidth / previewRatio;
    },
    getOrientation: function getOrientation(width, height) {
      var orientation = 'square';

      if (width > height) {
        orientation = 'landscape';
      } else if (width < height) {
        orientation = 'portrait';
      }

      return orientation;
    },
    switchCanvasOrientation: function switchCanvasOrientation() {
      var canvasWidth = this.canvasWidth;
      var canvasHeight = this.canvasHeight;

      this.canvasWidth = canvasHeight;
      this.canvasHeight = canvasWidth;
    },
    rotateCanvas: function rotateCanvas() {
      this.switchCanvasOrientation();
      this.resizeCanvas();
    },
    setOrientation: function setOrientation(orientation) {
      this.rotate = false;
      if (orientation === 8) {
        this.rotate = -Math.PI / 2;
      } else if (orientation === 6) {
        this.rotate = Math.PI / 2;
      } else if (orientation === 3) {
        this.rotate = -Math.PI;
      }
    },
    getEXIFOrientation: function getEXIFOrientation(file, callback) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var view = new DataView(e.target.result);
        if (view.getUint16(0, false) !== 0xFFD8) {
          return callback(-2);
        }
        var length = view.byteLength;
        var offset = 2;
        while (offset < length) {
          var marker = view.getUint16(offset, false);
          offset += 2;
          if (marker === 0xFFE1) {
            if (view.getUint32(offset += 2, false) !== 0x45786966) {
              return callback(-1);
            }
            var little = view.getUint16(offset += 6, false) === 0x4949;
            offset += view.getUint32(offset + 4, little);
            var tags = view.getUint16(offset, little);
            offset += 2;
            for (var i = 0; i < tags; i++) {
              if (view.getUint16(offset + i * 12, little) === 0x0112) {
                return callback(view.getUint16(offset + i * 12 + 8, little));
              }
            }
          } else if ((marker & 0xFF00) !== 0xFF00) {
            break;
          } else {
            offset += view.getUint16(offset, false);
          }
        }
        return callback(-1);
      };
      reader.readAsArrayBuffer(file.slice(0, 65536));
    },
    preloadImage: function preloadImage(source, options) {
      var _this3 = this;

      options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, options);
      if ((typeof source === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(source)) === 'object') {
        this.imageSelected = true;
        this.image = '';
        if (this.supportsPreview) {
          this.loadImage(source, true);
        } else {
          this.$emit('prefill');
        }
        return;
      }
      var headers = new Headers();
      headers.append('Accept', 'image/*');
      fetch(source, {
        method: 'GET',
        mode: 'cors',
        headers: headers
      }).then(function (response) {
        return response.blob();
      }).then(function (imageBlob) {
        var e = { target: { files: [] } };
        var fileName = options.fileName || source.split('/').slice(-1)[0];
        var mediaType = options.mediaType || 'image/' + (options.fileType || fileName.split('.').slice(-1)[0]);
        mediaType = mediaType.replace('jpg', 'jpeg');
        e.target.files[0] = new File([imageBlob], fileName, { type: mediaType });
        _this3.onFileChange(e, true);
      }).catch(function (err) {
        _this3.$emit('error', {
          type: 'failedPrefill',
          message: 'Failed loading prefill image: ' + err
        });
      });
    }
  },
  computed: {
    supportsUpload: function supportsUpload() {
      if (navigator.userAgent.match(/(Android (1.0|1.1|1.5|1.6|2.0|2.1))|(Windows Phone (OS 7|8.0))|(XBLWP)|(ZuneWP)|(w(eb)?OSBrowser)|(webOS)|(Kindle\/(1.0|2.0|2.5|3.0))/)) {
        return false;
      }
      var el = document.createElement('input');
      el.type = 'file';
      return !el.disabled;
    },
    supportsPreview: function supportsPreview() {
      return window.FileReader && !!window.CanvasRenderingContext2D;
    },
    supportsDragAndDrop: function supportsDragAndDrop() {
      var div = document.createElement('div');
      return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && !('ontouchstart' in window || navigator.msMaxTouchPoints);
    },
    computedClasses: function computedClasses() {
      var classObject = {};
      classObject['dragging-over'] = this.draggingOver;
      return classObject;
    },
    fontSize: function fontSize() {
      return Math.min(0.04 * this.previewWidth, 21) + 'px';
    }
  }
});

/***/ }),

/***/ "1Ft2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2+hT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2f0p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PictureInput_vue__ = __webpack_require__("0jZp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_420f052a_hasScoped_true_buble_transforms_vue_loader_lib_selector_type_template_index_0_PictureInput_vue__ = __webpack_require__("emyr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("JfE9")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-420f052a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PictureInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_420f052a_hasScoped_true_buble_transforms_vue_loader_lib_selector_type_template_index_0_PictureInput_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_420f052a_hasScoped_true_buble_transforms_vue_loader_lib_selector_type_template_index_0_PictureInput_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "33HN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-header"},[_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col-10 text-left"},[_c('h2',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t('registration.tabs.tabPersonalDetails')))])]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('form',{staticClass:"row justify-content-center p-details",attrs:{"action":"POST","data-vv-scope":"form-1"},on:{"submit":function($event){$event.preventDefault();_vm.save('form-1')}}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group custom-input"},[_c('div',{staticClass:"wrap-cb"},[_c('label',{staticClass:"c-wrap pad-left-35"},[_vm._v(_vm._s(_vm.$t('candidateProfile.personalDetails.msgScanAadhar'))+"\n            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.scanAadhar),expression:"scanAadhar"}],attrs:{"type":"checkbox","checked":"checked"},domProps:{"checked":Array.isArray(_vm.scanAadhar)?_vm._i(_vm.scanAadhar,null)>-1:(_vm.scanAadhar)},on:{"__c":function($event){var $$a=_vm.scanAadhar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.scanAadhar=$$a.concat($$v))}else{$$i>-1&&(_vm.scanAadhar=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.scanAadhar=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"alert alert-success"},[_c('small',[_vm._v(_vm._s(_vm.$t('candidateProfile.personalDetails.noteAadhar'))+" ")])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.scanAadhar)?_c('div',[_c('div',{staticClass:"para",attrs:{"for":"msg"}},[_vm._v(_vm._s(_vm.$t('candidateProfile.personalDetails.lblAadhar'))+" ")]),_vm._v(" "),_c('qrcode-reader',{staticClass:"qrClass",attrs:{"video":{ facingMode: 'user' }},on:{"init":_vm.onInit,"decode":_vm.onDecode}}),_vm._v(" "),_c('br'),_c('br')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(" "+_vm._s(_vm.$t('candidateProfile.personalDetails.lblName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.personalDetail.fullName),expression:"personalDetail.fullName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces'),expression:"'required|alpha_spaces'"}],staticClass:"form-control-alt uppercase col-4",class:{'form-error': _vm.errors.has('form-1.FullName'),'input': true, 'is-danger': _vm.errors.has('form-1.FullName') },attrs:{"name":"FullName","id":"fullname","type":"text","placeholder":_vm.$t('candidateProfile.personalDetails.plceHoFullName')},domProps:{"value":(_vm.personalDetail.fullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.personalDetail.fullName=$event.target.value}}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(" "+_vm._s(_vm.$t('candidateProfile.personalDetails.lblFatherName'))+"   ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.personalDetail.fatherName),expression:"personalDetail.fatherName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces'),expression:"'required|alpha_spaces'"}],staticClass:"form-control-alt uppercase col-3",class:{'form-error': _vm.errors.has('form-1.Father Name'),'input': true, 'is-danger': _vm.errors.has('form-1.Father Name') },attrs:{"name":"Father Name","id":"namefathername","type":"text","placeholder":_vm.$t('candidateProfile.personalDetails.plceFatherName')},domProps:{"value":(_vm.personalDetail.fatherName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.personalDetail.fatherName=$event.target.value}}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(" "+_vm._s(_vm.$t('candidateProfile.personalDetails.lblMotherName'))+"   ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.personalDetail.motherName),expression:"personalDetail.motherName"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces'),expression:"'required|alpha_spaces'"}],staticClass:"form-control-alt uppercase col-3",class:{'form-error': _vm.errors.has('form-1.Mother Name'),'input': true, 'is-danger': _vm.errors.has('form-1.Mother Name') },attrs:{"name":"Mother Name","id":"namemothername","type":"text","placeholder":_vm.$t('candidateProfile.personalDetails.plceMotherName')},domProps:{"value":(_vm.personalDetail.motherName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.personalDetail.motherName=$event.target.value}}}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(_vm._s(_vm.$t('candidateProfile.personalDetails.lblGender'))+" ")]),_vm._v(" "),_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|not_in:Select'),expression:"'required|not_in:Select'"}],class:{'form-error': _vm.errors.has('gender')},attrs:{"label":"name","options":_vm.genderList,"error-messages":_vm.errors.collect('gender'),"data-vv-name":"gender","name":"gender","placeholder":_vm.$t('candidateProfile.personalDetails.plceHoGender'),"required":""},model:{value:(_vm.personalDetail.gender),callback:function ($$v) {_vm.personalDetail.gender=$$v},expression:"personalDetail.gender"}}),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(" "+_vm._s(_vm.$t('candidateProfile.personalDetails.lblDob'))+"\n         "),_vm._v(" "),_c('date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-error': _vm.errors.has('DOB'),'input': true, 'is-danger': _vm.errors.collect('DOB') },attrs:{"confirm":"","name":"DOB","option":_vm.option,"limit":_vm.limit,"data-vv-name":"DOB","data-vv-validate-on":"change","lang":"en"},on:{"change":function($event){_vm.dateValidation()}},model:{value:(_vm.startTime),callback:function ($$v) {_vm.startTime=$$v},expression:"startTime"}})],1),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(" "+_vm._s(_vm.$t('candidateProfile.personalDetails.lblMotherTongue'))+" ")]),_vm._v(" "),_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|not_in:Select'),expression:"'required|not_in:Select'"}],class:{'form-error': _vm.errors.has('mother Tongue')},attrs:{"label":"name","options":_vm.motherTongueList,"error-messages":_vm.errors.collect('motherTongue'),"data-vv-name":"mother Tongue","name":"motherTongue","placeholder":_vm.$t('candidateProfile.personalDetails.plceHoMotherTongue'),"required":""},model:{value:(_vm.personalDetail.motherTongue),callback:function ($$v) {_vm.personalDetail.motherTongue=$$v},expression:"personalDetail.motherTongue"}}),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(" "+_vm._s(_vm.$t('candidateProfile.personalDetails.lblMotherTongueSpeak')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(" "+_vm._s(_vm.$t('candidateProfile.personalDetails.lblMarritalStatus'))+" ")]),_vm._v(" "),_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|not_in:Select'),expression:"'required|not_in:Select'"}],class:{'form-error': _vm.errors.has('marital Status')},attrs:{"label":"name","options":_vm.maritalStatusList,"error-messages":_vm.errors.collect('maritalStatus'),"data-vv-name":"marital Status","name":"maritalStatus","placeholder":_vm.$t('candidateProfile.personalDetails.plceHoMaritalStatus'),"required":""},model:{value:(_vm.personalDetail.maritalStatus),callback:function ($$v) {_vm.personalDetail.maritalStatus=$$v},expression:"personalDetail.maritalStatus"}}),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(" "+_vm._s(_vm.$t('candidateProfile.personalDetails.lblNameOnLeavingCertificate'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.personalDetail.nameOnLeavingCertificate),expression:"personalDetail.nameOnLeavingCertificate"},{name:"validate",rawName:"v-validate",value:('required|alpha_spaces'),expression:"'required|alpha_spaces'"}],staticClass:"form-control-alt col-6 uppercase",class:{'form-error': _vm.errors.has('form-1.Name On Leaving Certificate'),'input': true, 'is-danger': _vm.errors.has('form-1.Name On Leaving Certificate') },attrs:{"name":"Name On Leaving Certificate","id":"namelc","type":"text","placeholder":_vm.$t('candidateProfile.personalDetails.plceHoNameOnCert')},domProps:{"value":(_vm.personalDetail.nameOnLeavingCertificate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.personalDetail.nameOnLeavingCertificate=$event.target.value}}}),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(" "+_vm._s(_vm.$t('candidateProfile.personalDetails.lblAadharNumber'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.personalDetail.aadhaarNumber),expression:"personalDetail.aadhaarNumber"},{name:"validate",rawName:"v-validate",value:('digits:12'),expression:"'digits:12'"}],staticClass:"form-control-alt uppercase",class:{'form-error': _vm.errors.has('form-1.Aadhar Number'),'input': true, 'is-danger': _vm.errors.has('form-1.Aadhar Number') },attrs:{"name":"Aadhar Number","id":"aadhar","maxlength":"12","type":"text","placeholder":_vm.$t('candidateProfile.personalDetails.plceHoAadhaarNo')},domProps:{"value":(_vm.personalDetail.aadhaarNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.personalDetail.aadhaarNumber=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"para"},[_c('b',[_vm._v(_vm._s(_vm.$t('candidateProfile.personalDetails.lblOr'))+"    ")]),_vm._v(" "+_vm._s(_vm.$t('candidateProfile.personalDetails.lblEnrolmentNumber'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.personalDetail.enrolmentNumber),expression:"personalDetail.enrolmentNumber"},{name:"validate",rawName:"v-validate",value:('alpha_num'),expression:"'alpha_num'"}],staticClass:"form-control-alt uppercase",class:{'form-error': _vm.errors.has('form-1.Enrolment Number'),'input': true, 'is-danger': _vm.errors.has('form-1.Enrolment Number') },attrs:{"name":"Enrolment Number","id":"enrolment","maxlength":"16","type":"text","placeholder":_vm.$t('candidateProfile.personalDetails.plceHoEnrolmentNo')},domProps:{"value":(_vm.personalDetail.enrolmentNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.personalDetail.enrolmentNumber=$event.target.value}}}),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(" "+_vm._s(_vm.$t('candidateProfile.personalDetails.lblPanNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.personalDetail.panNumber),expression:"personalDetail.panNumber"}],staticClass:"form-control-alt uppercase",class:{'form-error': _vm.errors.has('form-1.PAN Number'),'input': true, 'is-danger': _vm.errors.has('form-1.PAN Number') },attrs:{"name":"PAN Number","id":"panNo","maxlength":"10","type":"text","placeholder":_vm.$t('candidateProfile.personalDetails.plceHoPanNo')},domProps:{"value":(_vm.personalDetail.panNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.personalDetail.panNumber=$event.target.value}}})],1)])]),_vm._v(" "),_c('div',{staticClass:" row text-center p-3"},[_c('button',{staticClass:"btn btn btn-info-alt mr-3",attrs:{"type":"button"},on:{"click":_vm.prevTabFunc}},[_vm._v(" "+_vm._s(_vm.$t('button.back')))]),_vm._v(" "),_c('button',{staticClass:"btn btn btn-orange ml-auto",attrs:{"type":"button"},on:{"click":_vm.nextTabFunc}},[_vm._v(" "+_vm._s(_vm.$t('button.next')))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2 lighten text-right"},[_c('h2',{staticClass:"page-title"},[_vm._v("17%")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])}]


/***/ }),

/***/ "3EJc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3J2B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3NHr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"reg",attrs:{"id":"registration"}},[_c('div',{staticClass:"card-alt mt-0"},[_c('div',{staticClass:"card-alt-body"},[_c('router-view')],1)])])}
var staticRenderFns = []


/***/ }),

/***/ "3PZQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_vue__ = __webpack_require__("Kguq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37d34d8a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_vue__ = __webpack_require__("jtc2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("ZNIs")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37d34d8a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37d34d8a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3kQO":
/***/ (function(module, exports) {

module.exports = {"selectLanguage":"Select Language","footerBar":{"lblOrgnization":"2018 Maharashtra Knowledge Corporation Limited","lblPowerdBy":"Powered by MKCL's Core Platform v1.0.1"},"headerBar":{"lblLangEng":"English","lblLangMar":"Marathi","lblHello":"Hello,","lblUserMenu":"User Menu","lblLogout":"Logout","tostrLogout":"Logout Successfully."},"sideBar":{"lblRegistration":"Registration","lblLogout":"Logout","lblCopyRights":"2018 Maharashtra Knowledge Corporation Limited. All Rights Reserved.","tostrLogout":"Logout Successfully.","lblTermCondition":"Terms and Conditions"},"login":{"lblHeading1":"Application Portal for Work-based Degree Programs","lblHeading2":"Welcome, Please Login here","lblApplicant":"Applicant / Student","lblIP":"Industry Partner","lblASC":"Admission Support Center"},"instructions":{"lblInstruction":"Instructions:","btnPDF":"Download pdf","btnAudio":"Play Audio","btnVideo":"Play Video","lblAudioInstruction":"Listen audio instruction carefully","lblVideoInstruction":"Watch the steps followed in the video carefully."},"candidateProfile":{"agreement":{"lblCandidateAgreement1":"This is an agreement between the student or candidate and the ","lblCandidateAgreement2":" which is entered into by virtue of the candidate for admission clicking on “I Agree” button on the online admission portal at the time of admission to a program using online admission process. In this agreement the term “candidate” is used to mean the person who proposes to take admission to a program in ","lblCandidateAgreement3":" and the term “student” is used to mean a person who has been admitted to a program of the ","lblCandidateAgreement4":" after fulfilling all the conditions thereof..","lblUndertakes":"The candidate undertakes that - ","lblRulesAgree":"I have read the Candidate/Student Agreement about admission, thus clicking the below  'I Agree' button","btnIAgree":"I Agree"},"personalDetails":{"plceHoFullName":"Enter your fullname","plceFatherName":"Enter your father name","plceMotherName":"Enter your mother name","plceHoNameOnCert":"Enter name as on Leaving Certifcate/Marksheet","plceHoGender":"Select gender","plceHoDOB":"Enter DOB","plceHoMaritalStatus":"Select marital status","plceHoMotherTongue":"Select mother tongue","plceHoAadhaarNo":"Enter aadhaar number","plceHoEnrolmentNo":"Enter enrollment no.","plceHoPanNo":"Enter PAN number","lblOr":"Or ","toastrDeneidCameraAccess":"It seems, your application do not have permission to access camera","toastrNotSuitableCameraDevice":"Do not worry if the browser does not have required features, you can fill the Aadhaar card details manually.","toastrPageIsNotServed":"Page is not served over HTTPS (or localhost)","toastrCameraAlereadyInUse":"It seems, like camera is already in use by other application","toastrDontMatchAnyCamera":"Passed constraints don't match any camera.","toastrBrowserLackingFeatures":"Browser is probably lacking features (WebRTC, Canvas).","toastrEnterValidPanDetails":"Please Enter Valid Pan number","toastrAadhaarMustBe12Digits":"Aadhaar Number must be of 12 Digits","toastrEnterAadhaarDetails":"Please Enter Aadhaar number","toastrEnterNameOnLeavingCertificate":"Please Enter Name as on Leavning Ceriticate","toastrSelectMaritalStatus":"Please Select Marital Status","toastrSelectMotherTongue":"Please Select Mother Tongue","toastrEnterValidDOB":"Please Enter Valid Date of Birth","toastrSelectGender":"Please Select Gender","toastrEnterValidFullName":"Please Enter Valid Full Name","toastrEnterValidAadhaarDetails":"Please Enter Valid Aadhaar Number","toastrNotValidDOB":"You must be at least 17 years old to apply for MFS Programs.","toastrSelectAadharOrEnrolement":"Please select Aadhaar/Enrollment number.","msgScanAadhar":"I would like to scan my aadhaar card for adding information","noteAadhar":"Aadhaar card should not be laminated. You can download digital copy from the official website of UIDAI and scan the QR code via mobile. Scanning aadhaar card is not mandatory, you can fill below details manually too.","lblAadhar":"Scan aadhaar card","lblName":"My name is","lblMotherName":"and ","lblFatherName":"Son/Daughter of ","lblGender":". I am a","lblDob":"I was born on","lblMotherTongue":"I speak","lblMotherTongueSpeak":"language at home,","lblMarritalStatus":"Currently I am","lblNameOnLeavingCertificate":"The name on my leaving certificate is","lblAadharNumber":"My aadhaar number is ","lblEnrolmentNumber":"Aadhaar enrollment number is ","lblPanNumber":"and PAN card number is  ","toastrAadhaarAlreadyExists":"Aadhaar Number already exists","toastrEnterMotherName":"Please Enter Mother Name","toastrEnterFatherName":"Please Enter Father Name"},"contactDetails":{"lblCorrespondenceAddressPIN":"My correspondence address's pincode is","lblCorrespondancetehsilDistrictState":"& the tehsil, district & state of my correspondence address is","lblPermanenttehsilDistrictState":"& the tehsil, district & state of my permanent address is","lblPermanentAddressPIN":"My permanent address's pincode is","plceAddressPIN":"PIN Code","lblContactDetails":"Contact Details","lblEmailID":"Contact me on my verified email address","plceEmailID":"Email ID","lblMobileNumber":"and mobile number","plceMobileNumber":"Mobile Number","lblSkypeID":"My skype ID is","plceSkypeID":"Skype ID","tooltipSkypeID":"Your Skype ID is required so that you can give the interview or join the sessions conducted by experts later on.","toastrEnterCorrespondanceAddress":"Please Enter Correspondence Address Pincode","toastrCorrespondancePinDigits":"Correspondence Address PIN must have 6 digits","toastrEnterPermanentAddress":"Please Enter Permanent Address Pincode","toastrPermanentPinDigits":"Permanent Address must have 6 digits","toastrEnterEmailID":"Please Enter Email ID","toastrInvalidEmailID":"Email ID is Invalid...Please Enter Valid Email ID","toastrEnterMobileNumber":"Please Enter Mobile Number","toastrMobileNumberDigits":"Mobile Number Must have 10 Digits","toastrSelectPermanentTehsil":"Please select Tehsil-District-State For Permanent Address","toastrSelectCorrespondanceTehsil":"Please select Tehsil-District-State For correspondance Address"},"educationDetails":{"lblPassedOrAppeared":"I","lblIn":"In","lblExam":"exam","lblNote":"Note:","lblConfiramtion":"Do you want to edit the educational details ?","lblName":"To continue further  the minimum eligibility  criteria is passed/appeared in HSC/Diploma.","lblHscOrDiploma":"in HSC / Diploma","plceQualification":"Qualification","plceQualificationStatus":"Qualification Status","toastrSelectQualification":"Please Select Any One Qualification","toastrSelectQualificationStatus":"Please Select Qualification Status","lblNoneOfAbove":"None of the above","lblHsc":"HSC","lblSelectHSCResult":"Select your HSC Result","lblDiplomaTicketDoc":"Diploma Hall Ticket","lblHSCHallTicketDoc":"HSC Hall Ticket","lblAppearing":"Appearing","lblPassed":"Passed","lblOr":"OR","lblDiploma":"Diploma","lblSelectDiplomaResult":"Select your Diploma Result","lblAnyOfAbove":"Have you completed any of the above?","lblNo":"No","lblHSCAppeared":"HSC Appeared","lblDiplomaAppeared":"Diploma Appeared"},"qualificationDetails":{"lblDocument":"Document","lblMarksheet":"Marksheet","lblDetails":"Details","lblHSCHallTicketDetails":"HSC Hall Ticket","lblDiplomaHallTicketDetails":"Diploma Hall Ticket","lblDateOfExam":"On date","plceHoDateOfExam":"On date","lblIHaveCompleted":"I have completed","lblFrom":"from","plceHoSelectBoard":"Select Board","lblRollSeatNo":"having Roll / Seat No.","plceHoRollSeatNo":"Roll / Seat No.","lblMarksheetNo":"and Marksheet No.","plceHoMarksheetNo":"Marksheet No.","lblWith":"with","plceHoWith":"Marks Obtained","lblOutOf":"Out of","plceHoOutOf":"Marks Out Of","tooltipViewDoc":"View Marklist / Hallticket","toastrInvalidData":"Please Enter All Details.","toastrMarkNotValid":"Invalid marks, Obtained marks should be less than total marks.","lblNote":"Note : ","noteMarksheet":"If you have only passing month and year on your marksheet then select 1st date of passing month. Ex. YYYY-MM-DD","noteHSCHallticket":"If you are having the HSC Hall ticket, then once your HSC result is declared you need to submit the copy of your HSC mark sheet as & when demanded by the authorities.","noteDiplomaHallticket":"If you are having the Diploma Hall ticket, then once your Diploma result is declared you need to submit the copy of your Diploma mark sheet as & when demanded by the authorities."},"certification":{"lblCertificationCompleted":"I have completed my IT literacy certification in","lblLearnerCode":"Learner Code","lblLearnerCodeIs":"and my learner code is","lblNotCompletedCertification":"I have not completed any IT literacy certifications like MS-CIT, BS-CIT, HS-CIT, OS-CIT, KLiC IT.","lblAnyCertificate":"Do you have completed any of following certification?","lblReferralAlc":"I am applying through MKCL's MS-CIT/KLiC Center.","lblReferralCode":"Referral code","lblAlcCode":"MKCL Center Code","plceHoReferralCode":"Enter MKCL center Code","plceCareerCounsellorCode":"Enter Referral Code","plceHoAlcCode":"Enter MKCL center Code","plceHoLearnerCode":"Enter your learner code","plceHoITCertification":"MS-CIT","toastrErrorFetchingCertificationList":"Error While Fetching Certification List","toastrSelectCertification":"Please Complete IT Certification Details.","toastrErrorALCcodeRequired":"Please Enter ALC/Referral Code to Complete IT Certification Details.","toastrCounsellorCodeRequired":"Please Enter Referral Code to Complete IT Certification Details.","toastrLearnerCodeInvalid":"Please Enter Valid Learner Code.","toastrEnterLearnerCode":"Please Enter Learner code","lblCounsellor":"I am applying through Career Adviser.","toastrInvalidALCCode":"Please enter valid ALC Code"},"profileSummary":{"lblPersonalDetails":"Personal Details","lblName":" Hi, my name is ","lblFatherName":"Son/Daughter of ","lblGender":"I am a","lblDOB":"born on","lblMotherTounge":"My mother tongue is","lblAnd":"and","lblMaritalStatus":"I am currently","btnEditDetails":"Edit Details","lblContactDetails":"Contact Details ","lblMartialStatus":"Martial Status","lblAadharNo":"Aadhar No","lblPanNo":"Pan No","lblNameOnLeaving":"Name on leaving certificate","lblMobileNumber":"My verified mobile number is ","lblEmailID":"and email id is ","lblSkypeId":"My Skype id is","lblCorrespondanceAddress":"My correspondence address is ","lblPermanentAddress":"and permanent address is","lblRespectively":"respectively.","lblITCertification":"IT Literacy Certification","lblCompletedITCertification":"I have completed my IT certification in","lblLearnerCode":"My learner code is ","lblSkil":"I am skilled in","lblReferalCode":"I am applying through Career adviser with referral code ","lblAlcCode":"I am applying through MKCL center with center code ","lblPreviousExperience":"My previous experience includes","lblITCertficationTechnology":"IT Technologies respectively.","lblKnownTechnologies":"Known Technological Languages","lblEducationDetails":"Educational Details","lblSSC":"SSC","lblHSC":"HSC","lblDiploma":"Diploma","lblDegree":"Degree","lblMarksheet":"Marksheet","lblCertificationNotCompleted":"I have not completed any Certification","lblNotEligible":"Since you have not Appeared/Passed HSC or Degree you are not eligible for this program.","toastrPermanentPinCodeNotFound":"Permanent Address For Given Pincode Not Found!","toastrcorrespondancePinCodeNotFound":"Correpondence Address For Given Pincode Not Found!","toastrFillAllSections":"Please Fill details in all sections"},"imageExtracter":{"toastrMessageAppender":"Please Enter ","toastrCertificationDetailsFeatchError":"Error while fetching certificate details","toastrCertificationListFeatchError":"Error while fetching certificate list'","lblCrop":"Crop","toastrImageNotAvailable":"Image Not Available"},"documentUpload":{"lblProfilePhoto":"Profile Photo","lblSscDoc":"SSC Documents","lblHscDoc":"HSC Documents","lblDiplomaDoc":"Diploma Documents","toastrFileAlreadyExists":"File Already Present on CDN","toastrNoResponse":"No response from CDN","toastrDocumentsUploadSuccess":" saved successfully.","toastrFileDeleted":"File Deleted Successfully.","toastrDataNotPresent":"Data Not Present in DB","toastrDocumentsUploadedSuccess":"Documents uploaded successfully.","toastrDocumentsUploadError":"Please Upload All Documents.","toastrDocumentsUploadSizeError":"Please Upload file less than 1MB."}},"registration":{"lblStartReg":"Candidate Registration will be starting from ","lblGoingReg":"Candidate Registration will be closed on ","lblEndReg":"Candidate Registration has been closed on ","fullName":"Full Name","dob":"DOB","email":"Email","confirmEmail":"Confirm Email","mobile":"Mobile","otp":"OTP","username":"Username","password":"Password","lblMFSAdmissionCell":"MFS Admission Cell","lblSignUpToContinue":"Sign up to continue","lblSuggestedUsernames":"Suggested user names :","msgSignUpNote":"By signing up you agree to our Terms and Conditons","otpResendNote":"Wait.., Resend OTP after","toastrPleaseEnterValidFullName":"Please Enter Valid Full Name","toastrUsernameRequired":"Please Enter Username","toastrPasswordRequired":"Please Enter Password","toastrEmailRequired":"Please Enter Email ID","toastrPleaseEnterValidEmail":"Please Enter Valid Email ID","toastrPleaseEnterValidConfirmEmail":"Please Enter Valid Confirm Email ID","toastrMobileRequired":"Please Enter Mobile No.","toastrPleaseEnterValidMobile":"Please Enter Valid Mobile No. Must have 10 digits","toastrOTPRequired":"Please Enter OTP.","toastrInvalidOTP":"Please Enter Valid OTP. Must have 6 digits","toastrVerifyMobileNumber":"Please Verify Mobile No.","buttonType":{"register":"Register","cancel":"Cancel","verifyOTP":"Verify OTP","sendOTP":"Send OTP","resendOTP":"Resend OTP"},"placeholder":{"fullname":"Full Name","mobile":"Mobile Number","username":"Username","password":"Password","confirmEmail":"Confirm Email","email":"Email"},"alerts":{"DATA_NOT_VALID":"Please Properly fill the data","REGISTRATION_FAIL":"Sorry, Your Registration Failed. Please try again.","REGISTRATION_SUCCESS":"Your Registration Done Successfully.","FAIL_TO_FIND_USERNAME_AVAILABILITY":"Sorry, Failed to find username availability","USERNAME_NOT_AVAILABLE":"Username is Not Available","EMAIL_NOT_MATCHED":"Email ID and Confirm Email ID Not Matched","USERNAME_NOT_VALID":"Email ID is Not Valid","USERNAME_ALREADY_EXIST":"Email ID already exist, Please try another one.","OTP_SEND_SUCCESS":"OTP is sent to your mobile no. Please register to verify your mobile no.","OTP_Send_Fail":"Fail to send OTP check Mobile Number/Email","ENTER_VALID_DETAILS":"Please Enter Valid Details","OTP_VERIFY_SUCCESS":"OTP verified Successfully","OTP_INVALID":"Please Enter Valid OTP.","MOBILE_NUMBER_CHANGED":"You changed mobile no. Please Resend OTP to given Mobile Number.","OTP_VERIFY_FAIL":"Fail To verify because of You changed Mobile no./Email"},"tabs":{"tabITLiteracy":"IT Literacy Certification","tabPersonalDetails":"Personal details","tabContactDetails":"Contact Details","tabEducationDetails":"Educational Details","tabDocumentUpload":"Documents Upload","tabProfileSummary":"Profile Summary","tabImageExtractor":"Qualification Details"}},"candidateApplications":{"title":"Course Selection","plceHoSearchBox":"Search Course/University","erorNotMatchFound":"There is no matching found.","confirmText":"Are you sure to confirm following application ?","atlbl":"at ","toastrAppAlreadyExist":"You have already applied for this Application.","instruction":"Instruction :","instruction1":"You can appy for only one course application at the same time."},"workPlace":{"toastrAddedInCart":"added in your list.","toastrExistData":"This preferred workplace location already selected.","plceHoWorkPlace":"Search preferred workplace location","toastrDelete":"removed from your list.","toastrSaveData":"Your Application Saved Successfully.","toastrWarningForSelection":"Please select preferred workplace location .","lblWorkPlace":"Select your preferred workplace location","erorNotMatchFound":"There is no matching found.","lblSelectedWorkPlace":"Selected workplace locations","infoStatment1":"You have selected","infoStatment2":"as course at","erorNotSelected":"There is no preferred workplace location selected.","lblInstruction":"Instructions:","instruction1":"Please check the below list of locations where various Industry Partners are available.","instruction2":"Select your preferred workplace location where you would like to work.","instruction3":"While selecting preferred workplace location, please arrange them in the order of your preference.","instruction4":"After selecting all your preferred workplace locations, you can also select “Any where in Maharashtra” option."},"entry":{"confirmText":"Terms and Conditions","candidateAgreement":"Candidate / Student Agreement","toastrSelectAtLeastOne":"Please check at least one instruction","lblcheckedTermCondition":"I Agree all terms and conditions."},"button":{"apply":"Apply","select":"Select","view":"View","save":"Save","update":"Update","delete":"Delete","remove":"Remove","Finish":"Confirm & Proceed","signUp":"Sign Up","login":"Login","back":"Back","next":"Next","cancel":"Cancel","confirm":"Confirm","yes":"Yes","no":"No","confirm_proceed":"Confirm & Proceed"},"toastr":{"toastrPersonalDetailsSaved":"Personal Details Saved Successfully.","toastrAddressDetailsSaved":"Address Details Saved Successfully.","toastrContactDetailsSaved":"Contact Details Saved Successfully.","toastrEducationalDetailsSaved":"Educational Details Saved Successfully.","toastrCertificationDetailsSaved":"Certification Details Saved Successfully.","toastrSomethingWentWrong":"Ooops…Something Went Wrong!!, Please Login again.","toastrSomethingWentWrongs":"Ooops…Something Went Wrong!!, Please Login again.","toastrDetailsSaved":" Details Saved Successfully.","toastrAadhaarScanSuccess":"Aadhaar Scan Successfully.","toastrProfileCompleted":"Profile Completed Successfully.","toastrIntrustionsSaved":"Instructions Saved Successfully.","toastrTermConditionSaved":"Terms and Conditions Saved Successfully."}}

/***/ }),

/***/ "3rUF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");


var state = {
  profileUser: ''
};
var getters = {
  getProfileUser: function getProfileUser(state) {
    return state.profileUser;
  }
};
var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* STORE_PROFILE_USER */], function (state, data) {
  state.profileUser = data;
});
var actions = {};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "47bd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__ = __webpack_require__("bpFM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2cc9dcc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__ = __webpack_require__("NO0o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("ob0k")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2cc9dcc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2cc9dcc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4ZrY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Zg9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-header"},[_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col-10 text-left"},[_c('h2',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t('registration.tabs.tabITLiteracy')))])]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('form',{staticClass:"row justify-content-center",attrs:{"action":"POST","data-vv-scope":"certificationForm"},on:{"submit":function($event){$event.preventDefault();_vm.validateLearnerCode('certificationForm')}}},[(_vm.screenConfig.visible )?_c('div',{staticClass:"col-12"},[(_vm.isVisible('certificationName'))?_c('div',{staticClass:"form-group custom-input"},[(!_vm.noneOfAbove)?_c('div',[_c('div',{staticClass:"para"},[_vm._v(_vm._s(_vm.$t('candidateProfile.certification.lblCertificationCompleted'))+" ")]),_vm._v(" "),_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|not_in:Select'),expression:"'required|not_in:Select'"}],class:{'form-error': _vm.errors.has('certificationName')},attrs:{"label":"certificationName","on-change":_vm.certificationSelect(_vm.certificationDetails.itCertification),"options":_vm.certificationList,"error-messages":_vm.errors.collect('certificationName'),"data-vv-name":"certificationName","name":"certificationName","placeholder":_vm.$t('candidateProfile.certification.plceHoITCertification'),"required":""},on:{"update:options":function($event){_vm.certificationList=$event}},model:{value:(_vm.certificationDetails.itCertification),callback:function ($$v) {_vm.certificationDetails.itCertification=$$v},expression:"certificationDetails.itCertification"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),(_vm.noneOfAbove === false && (_vm.certificationDetails.itCertification != null && _vm.certificationDetails.itCertification != undefined))?_c('div',[_c('div',{staticClass:"para"},[_vm._v(_vm._s(_vm.$t('candidateProfile.certification.lblLearnerCodeIs'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.certificationDetails.learnerCode),expression:"certificationDetails.learnerCode"},{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],staticClass:"form-control-alt uppercase col-5",class:{'form-error': _vm.errors.has('certificationForm.learnercode'),'input': true, 'is-danger': _vm.errors.has('certificationForm.learnercode') },attrs:{"minlength":"10","maxlength":"16","oninput":"this.value=this.value.slice(0,this.maxLength||1/1);this.value=(this.value   < 0) ? (1/1) : this.value;","name":"learnercode","id":"learnerCode","type":"number","placeholder":_vm.$t('candidateProfile.certification.plceHoLearnerCode')},domProps:{"value":(_vm.certificationDetails.learnerCode)},on:{"keyup":function($event){_vm.learnerCodeVerified = false},"input":function($event){if($event.target.composing){ return; }_vm.certificationDetails.learnerCode=$event.target.value}}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p')]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wrap-cb"},[_c('label',{staticClass:"c-wrap pad-left-35"},[_vm._v(_vm._s(_vm.$t('candidateProfile.certification.lblNotCompletedCertification'))+"\n            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.noneOfAbove),expression:"noneOfAbove"}],attrs:{"type":"checkbox","id":"checkIT"},domProps:{"value":true,"checked":Array.isArray(_vm.noneOfAbove)?_vm._i(_vm.noneOfAbove,true)>-1:(_vm.noneOfAbove)},on:{"change":function($event){_vm.certificationDetails.itCertification = null; _vm.certificationDetails.learnerCode = '';_vm.certificationDetails.certificationCompleted = false},"__c":function($event){var $$a=_vm.noneOfAbove,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.noneOfAbove=$$a.concat($$v))}else{$$i>-1&&(_vm.noneOfAbove=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.noneOfAbove=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])])]):_vm._e(),_vm._v(" "),_c('p'),_vm._v(" "),(_vm.isVisible('alcCode'))?_c('div',{staticClass:"form-group custom-input col-12"},[_c('div',{staticClass:"wrap-cb"},[_c('label',{staticClass:"c-wrap pad-left-35"},[_vm._v(_vm._s(_vm.$t('candidateProfile.certification.lblReferralAlc'))+"\n            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.referralAlc),expression:"referralAlc"}],attrs:{"type":"checkbox","id":"referralAlc"},domProps:{"value":true,"checked":Array.isArray(_vm.referralAlc)?_vm._i(_vm.referralAlc,true)>-1:(_vm.referralAlc)},on:{"change":function($event){_vm.counsellor = false;_vm.certificationDetails.alcCode = ''; _vm.certificationDetails.referralCode = ''},"__c":function($event){var $$a=_vm.referralAlc,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.referralAlc=$$a.concat($$v))}else{$$i>-1&&(_vm.referralAlc=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.referralAlc=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_c('p'),_vm._v(" "),(_vm.referralAlc)?_c('div',[_c('div',{staticClass:"para"},[_vm._v(" "+_vm._s(_vm.$t('candidateProfile.certification.lblAlcCode')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.certificationDetails.alcCode),expression:"certificationDetails.alcCode"},{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],staticClass:"form-control-alt col-3",class:{'form-error': _vm.errors.has('certificationForm.alcCode'),'input': true, 'is-danger': _vm.errors.has('certificationForm.alcCode') },attrs:{"minlength":"7","maxlength":"10","oninput":"this.value=this.value.slice(0,this.maxLength||1/1);this.value=(this.value   < 0) ? (1/1) : this.value;","name":"alcCode","id":"alcCode","type":"number","placeholder":_vm.$t('candidateProfile.certification.plceHoAlcCode')},domProps:{"value":(_vm.certificationDetails.alcCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.certificationDetails.alcCode=$event.target.value}}}),_vm._v(" "),_vm._m(3)]):_vm._e()]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.isVisible('referralCode'))?_c('div',{staticClass:"form-group custom-input"},[_c('div',{staticClass:"wrap-cb"},[_c('label',{staticClass:"c-wrap pad-left-35"},[_vm._v(_vm._s(_vm.$t('candidateProfile.certification.lblCounsellor'))+"\n            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.counsellor),expression:"counsellor"}],attrs:{"type":"checkbox","id":"counsellor"},domProps:{"value":true,"checked":Array.isArray(_vm.counsellor)?_vm._i(_vm.counsellor,true)>-1:(_vm.counsellor)},on:{"change":function($event){_vm.referralAlc = false;_vm.certificationDetails.alcCode = ''; _vm.certificationDetails.referralCode = ''},"__c":function($event){var $$a=_vm.counsellor,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.counsellor=$$a.concat($$v))}else{$$i>-1&&(_vm.counsellor=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.counsellor=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]),_vm._v(" "),_c('p'),_vm._v(" "),(_vm.counsellor)?_c('div',[_c('div',{staticClass:"para"},[_vm._v(" "+_vm._s(_vm.$t('candidateProfile.certification.lblReferralCode')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.certificationDetails.referralCode),expression:"certificationDetails.referralCode"},{name:"validate",rawName:"v-validate",value:('required|alpha_num'),expression:"'required|alpha_num'"}],staticClass:"form-control-alt uppercase",class:{'form-error': _vm.errors.has('certificationForm.referralCode'),'input': true, 'is-danger': _vm.errors.has('certificationForm.referralCode') },attrs:{"minlength":"5","maxlength":"20","oninput":"this.value=this.value.slice(0,this.maxLength||1/1);this.value=(this.value   < 0) ? (1/1) : this.value;","name":"referralCode","id":"referralCode","type":"text","placeholder":_vm.$t('candidateProfile.certification.plceCareerCounsellorCode')},domProps:{"value":(_vm.certificationDetails.referralCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.certificationDetails.referralCode=$event.target.value}}}),_vm._v(" "),_vm._m(4)]):_vm._e()]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('button',{staticClass:"btn  btn btn-orange",attrs:{"type":"button"},on:{"click":_vm.nextTabFunc}},[_vm._v(" "+_vm._s(_vm.$t('button.next')))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2 lighten text-right"},[_c('h2',{staticClass:"page-title"},[_vm._v("0%")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])}]


/***/ }),

/***/ "61xj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  files: [],
  includedFiles: [],
  url: '',
  isPrevious: false
};

var getters = {
  getIsPrevious: function getIsPrevious(state) {
    return state.isPrevious;
  },
  getURL: function getURL(state) {
    return state.url;
  },
  getIncludedFiles: function getIncludedFiles(state) {
    return state.includedFiles;
  },
  getFiles: function getFiles(state) {
    return state.files;
  }
};

var mutations = {
  setIncludedFiles: function setIncludedFiles(state, data) {
    state.includedFiles = data;
  },
  setFiles: function setFiles(state, data) {
    state.files = data;
  },
  setURL: function setURL(state, data) {
    state.url = data;
  },
  setIsPrevious: function setIsPrevious(state, data) {
    state.isPrevious = data;
  }
};

var actions = {
  setURL: function setURL(context, data) {
    context.commit('setURL', data);
  },
  setFiles: function setFiles(context, data) {
    context.commit('setFiles', data);
  },
  setIncludedFiles: function setIncludedFiles(context, data) {
    context.commit('setIncludedFiles', data);
  },
  setIsPrevious: function setIsPrevious(context, data) {
    context.commit('setIsPrevious', data);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "7H/g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8/Kq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"workPlaceSelection",attrs:{"id":"workPlaceSelection"}},[_c('div',{},[_c('div',{staticClass:"plyr__video-embed",attrs:{"id":"player"}},[_c('video-player',{ref:"videoPlayer",staticClass:"video-player-box",attrs:{"options":_vm.playerOptions,"playsinline":true,"customEventName":"customstatechangedeventname"},on:{"play":function($event){_vm.onPlayerPlay($event)},"pause":function($event){_vm.onPlayerPause($event)},"ended":function($event){_vm.onPlayerEnded($event)},"waiting":function($event){_vm.onPlayerWaiting($event)},"playing":function($event){_vm.onPlayerPlaying($event)},"loadeddata":function($event){_vm.onPlayerLoadeddata($event)},"timeupdate":function($event){_vm.onPlayerTimeupdate($event)},"canplay":function($event){_vm.onPlayerCanplay($event)},"canplaythrough":function($event){_vm.onPlayerCanplaythrough($event)},"statechanged":function($event){_vm.playerStateChanged($event)},"ready":_vm.playerReadied}})],1)])])}
var staticRenderFns = []


/***/ }),

/***/ "8KH/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_modal_vue__ = __webpack_require__("yN8m");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'candidateApplication',
  components: { modal: __WEBPACK_IMPORTED_MODULE_1__components_common_modal_vue__["a" /* default */] },
  data: function data() {
    return {
      courseUnivList: [],
      searchBox: '',
      courseObj: {},
      showConfirmation: false
    };
  },

  computed: {
    filterCourseUnivList: function filterCourseUnivList() {
      var self = this;
      return self.courseUnivList.filter(function (user) {
        var searchRegex = new RegExp(self.searchBox, 'i');
        return searchRegex.test(user.uniName) || searchRegex.test(user.courseName);
      });
    }
  },
  methods: {
    getLogoUrl: function getLogoUrl(abbr) {
      return 'static/assets/images/' + abbr + '.png';
    },

    getAllData: function getAllData() {
      var _this = this;

      // Get course and university mapping List.
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('r/candidateApplication/getCourseUnivList').then(function (response) {
        _this.courseUnivList = response.data;
      }).catch(function (e) {
        console.log(e);
      });
    },
    // This method get exist status of application in candidate_application collection(mongoDB).
    apply: function apply(applicationObj) {
      var _this2 = this;

      var userName = this.$store.state.candidateProfile.profileUser;
      var courseID = applicationObj.courseID;
      var universityID = applicationObj.uniID;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('r/candidateApplication/existStatusOfApplication/' + userName + '/' + courseID + '/' + universityID).then(function (response) {
        if (response.data === true) {
          _this2.$toasted.info(_this2.$t('candidateApplications.toastrAppAlreadyExist'));
          _this2.showConfirmation = false;
          return false;
        } else {
          _this2.$router.push({ path: '/workPlace/' + courseID + '/' + universityID });
          // this.$router.push({name: 'workPlace', params: {userName: userName, courseID: courseID, universityID: universityID}})
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    fetchUserDetails: function fetchUserDetails() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/r/entry/getUserApplicationStatus/' + this.$store.state.candidateProfile.profileUser).then(function (response) {
        if (response.data !== null && response.data.appStatus) {
          _this3.$store.commit('STORE_CONFIRM_STATUS', true);
          window.MKCLAPI.switchAppWithSingleSignOn(_this3.MFS_CLIENT_ID);
        } else {
          _this3.getAllData();
        }
      }).catch(function (e) {
        console.error(e);
      });
    }
  },
  created: function created() {
    this.fetchUserDetails();
  }
});

/***/ }),

/***/ "8Y/r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8imL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{staticClass:"row justify-content-center p-details",attrs:{"action":"POST","data-vv-scope":"form-1"},on:{"submit":function($event){$event.preventDefault();_vm.save('form-1')}}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group custom-input"},[_c('div',{staticClass:"para"},[_vm._v("I have completed hsc ")]),_vm._v(" "),_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|not_in:Select'),expression:"'required|not_in:Select'"}],class:{'form-error': _vm.errors.has('board')},attrs:{"label":"boardName","options":_vm.boardList,"error-messages":_vm.errors.collect('board'),"data-vv-name":"board","name":"board","placeholder":"Select Board","required":""},model:{value:(_vm.selectedBoard),callback:function ($$v) {_vm.selectedBoard=$$v},expression:"selectedBoard"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v("On date")]),_vm._v(" "),_c('date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-error': _vm.errors.has('dateofResult'),'input': true, 'is-danger': _vm.errors.collect('dateofResult') },attrs:{"name":"dateofResult","option":_vm.option,"limit":_vm.limit,"data-vv-name":"dateofResult","data-vv-validate-on":"change"},model:{value:(_vm.startTime),callback:function ($$v) {_vm.startTime=$$v},expression:"startTime"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(" having RollNo / Seat No ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.educationDetails.seatNumber),expression:"educationDetails.seatNumber"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control-alt col-6",class:{'form-error': _vm.errors.has('form-1.Seat No'),'input': true, 'is-danger': _vm.errors.has('form-1.Seat No') },attrs:{"name":"Seat No","id":"namelc","type":"text","placeholder":"Roll/Seat No"},domProps:{"value":(_vm.educationDetails.seatNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.educationDetails.seatNumber=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(".Completed HSC with ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.educationDetails.totalMarksObtained),expression:"educationDetails.totalMarksObtained"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control-alt",class:{'form-error': _vm.errors.has('form-1.Total Mark'),'input': true, 'is-danger': _vm.errors.has('form-1.Total Mark') },attrs:{"name":"Total Mark","id":"totalMark","type":"text","placeholder":"Mark Obtained"},domProps:{"value":(_vm.educationDetails.totalMarksObtained)},on:{"input":function($event){if($event.target.composing){ return; }_vm.educationDetails.totalMarksObtained=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v("Out of")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.educationDetails.outOf),expression:"educationDetails.outOf"}],staticClass:"form-control-alt",class:{'form-error': _vm.errors.has('form-1.Out Of'),'input': true, 'is-danger': _vm.errors.has('form-1.Out Of') },attrs:{"name":"Out Of","id":"outOf","type":"text","placeholder":"Out Of"},domProps:{"value":(_vm.educationDetails.outOf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.educationDetails.outOf=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v("Marksheet No")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.educationDetails.marksheetNo),expression:"educationDetails.marksheetNo"}],staticClass:"form-control-alt",class:{'form-error': _vm.errors.has('form-1.Marksheet No'),'input': true, 'is-danger': _vm.errors.has('form-1.Marksheet No') },attrs:{"name":"Marksheet No","id":"panNo","type":"text","placeholder":"Marksheet No"},domProps:{"value":(_vm.educationDetails.marksheetNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.educationDetails.marksheetNo=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success-alt text-center",attrs:{"type":"button"},on:{"click":_vm.saveHSCDetails}},[_vm._v("Save")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])}]


/***/ }),

/***/ "8mG2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9w64":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Af9h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_educationalDetails_vue__ = __webpack_require__("vsuI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_beb34b5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_educationalDetails_vue__ = __webpack_require__("/FpJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("3EJc")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_educationalDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_beb34b5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_educationalDetails_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_beb34b5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_educationalDetails_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BGXO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ITCertification',
  components: {},
  data: function data() {
    return {
      selected: '',
      certificationList: [],
      certificationDetails: { certificationCompleted: false, itCertification: null, referralCode: '' },
      isCertified: false,
      defaultObj: { 'certificationID': 0, 'certificationName': 'None Of The above' },
      learnerData: {},
      learnerCodeVerified: false,
      noneOfAbove: false,
      screenConfig: {},
      referralAlc: false,
      counsellor: false
    };
  },

  methods: {
    isVisible: function isVisible(fieldName) {
      for (var i in this.screenConfig.attributes) {
        if (this.screenConfig.attributes[i].name === fieldName && this.screenConfig.attributes[i].visible) {
          return true;
        }
      }
    },
    nextTabFunc: function nextTabFunc() {
      this.validateALCCode();
      // this.save()
    },
    validateALCCode: function validateALCCode() {
      var self = this;
      if (this.referralAlc && (this.certificationDetails.alcCode === undefined || this.certificationDetails.alcCode === '')) {
        this.$toasted.error(self.$t('candidateProfile.certification.toastrErrorALCcodeRequired'));
        return false;
      }
      if (this.counsellor && (this.certificationDetails.referralCode === undefined || this.certificationDetails.referralCode === '')) {
        this.$toasted.error(self.$t('candidateProfile.certification.toastrCounsellorCodeRequired'));
        return false;
      }
      if (this.referralAlc && this.certificationDetails.alcCode !== undefined && this.certificationDetails.alcCode !== '') {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('r/itCertificationDetails/validateALCCode/' + this.certificationDetails.alcCode).then(function (response) {
          if (response.data) {
            self.save();
          } else {
            self.$toasted.error(self.$t('candidateProfile.certification.toastrInvalidALCCode'));
          }
        }).catch(function (e) {
          console.error(e);
          self.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'));
        });
      } else {
        self.save();
      }
    },
    certificationSelect: function certificationSelect(itCertification) {
      if (this.noneOfAbove === false) {
        this.certificationDetails.certificationCompleted = true;
      } else {
        this.certificationDetails.learnerCode = '';
        this.certificationDetails.certificationCompleted = false;
        this.certificationDetails.itCertification = null;
      }
    },
    getCertificationMaster: function getCertificationMaster() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('r/itCertificationDetails/certificates').then(function (response) {
        if (response.status === 200) {
          self.certificationList = response.data;
          // self.certificationList.push(self.defaultObj)
        }
      }).catch(function () {
        self.$toasted.error(self.$t('candidateProfile.certification.toastrErrorFetchingCertificationList'));
      });
    },

    fetchUserDetails: function fetchUserDetails() {
      var _this = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/r/entry/getUserApplicationStatus/' + this.$store.state.candidateProfile.profileUser).then(function (response) {
        if (response.data !== null) {
          var profileStatus = response.data.profileStatus;
          if (!profileStatus.personalDetails) {
            _this.$router.push({ name: 'personalDetails' });
          } else if (!profileStatus.contactDetails) {
            _this.$router.push({ name: 'address' });
          } else if (!profileStatus.educationDetails) {
            _this.$router.push({ name: 'educationalDetails' });
          } else if (!profileStatus.documentDetails) {
            _this.$router.push({ name: 'documentsupload' });
          } else if (!profileStatus.qualificationDetails) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('r/projectConfig/getAllProjectConfig').then(function (responses) {
              if (responses.data.ocrConfig.required) {
                _this.$router.push({ name: 'imageExtracter' });
              } else {
                _this.$router.push({ name: 'qualificationDetails' });
              }
            }).catch(function (e) {
              console.log(e);
            });
          } else {
            _this.$router.push({ name: 'profileSummary' });
          }
        }
      }).catch(function (e) {
        _this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: _this.TOASTR_TIME
        });
        console.error(e);
      });
    },
    getCertificationDetails: function getCertificationDetails() {
      var profileUser = this.$store.state.candidateProfile.profileUser;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('r/itCertificationDetails/getCertificationDetails/' + profileUser).then(function (response) {
        if (response.status === 200) {
          var responseData = response.data;
          if (responseData.certificationCompleted === false && responseData.itCertification.certificationName !== '') {
            self.noneOfAbove = false;
            self.certificationDetails = response.data;
            // self.certificationDetails.itCertification = self.defaultObj
          } else if (responseData.learnerCode !== '') {
            self.learnerCodeVerified = true;
            self.certificationDetails = response.data;
          }
          if (responseData.itCertification !== undefined) {
            if (responseData.itCertification.certificationID === 0 && responseData.itCertification.certificationName !== '') {
              self.noneOfAbove = true;
              document.getElementById('checkIT').setAttribute('checked', 'checked');
            }
          }
          if (responseData.referralCode !== undefined && responseData.referralCode !== '') {
            self.certificationDetails.referralCode = responseData.referralCode;
            self.counsellor = true;
            document.getElementById('counsellor').setAttribute('checked', 'checked');
          }
          if (responseData.alcCode !== undefined && responseData.alcCode !== '') {
            self.certificationDetails.alcCode = responseData.alcCode;
            self.referralAlc = true;
            document.getElementById('referralAlc').setAttribute('checked', 'checked');
          }
        }
      }).catch(function (e) {
        console.error(e);
        self.$toasted.error(self.$t('candidateProfile.certification.toastrErrorFetchingCertificationList'));
      });
    },

    save: function save() {
      var _this2 = this;

      var self = this;
      if (this.certificationDetails.alcCode) {
        this.certificationDetails.alcCode = this.certificationDetails.alcCode.toUpperCase();
      }
      if (this.certificationDetails.referralCode) {
        this.certificationDetails.referralCode = this.certificationDetails.referralCode.toUpperCase();
      }
      var profileUser = this.$store.state.candidateProfile.profileUser;
      if (this.noneOfAbove) {
        this.certificationDetails.itCertification = this.defaultObj;
      }
      return this.$validator.validate().then(function (result) {
        if (result) {
          return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('r/itCertificationDetails/updateCertifications/' + profileUser, self.certificationDetails).then(function (response) {
            if (response.status === 200) {
              if (_this2.screenConfig.visible) {
                _this2.$toasted.success(self.$t('toastr.toastrCertificationDetailsSaved'));
              }
              _this2.fetchUserDetails();
              // this.$router.push('personalDetails')
              return true;
            }
          }).catch(function (e) {
            _this2.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'));
            return false;
          });
        } else {
          _this2.$toasted.error(self.$t('candidateProfile.certification.toastrSelectCertification'));
        }
        return false;
      }).catch(function (e) {
        _this2.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'));
        return false;
      });
    },
    validateLearnerCode: function validateLearnerCode(scope) {
      var _this3 = this;

      if (this.certificationDetails.certificationCompleted === false || this.certificationDetails.itCertification === null) {
        return this.save();
      } else {
        var self = this;
        return this.$validator.validate().then(function (result) {
          if (result) {
            return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/r/itCertificationDetails/getlearnerdetailsusinglearnercode/' + _this3.certificationDetails.learnerCode + '/' + _this3.$store.state.candidateProfile.profileUser).then(function (response) {
              if (response.data !== null) {
                if (response.data === 'false') {
                  _this3.$toasted.error(self.$t('candidateProfile.certification.toastrLearnerCodeInvalid'));
                  return false;
                } else {
                  _this3.learnerCodeVerified = true;
                  return _this3.save();
                }
              }
            }).catch(function (e) {
              _this3.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'));
              console.error(e);
              return false;
            });
          } else {
            _this3.$toasted.error(self.$t('candidateProfile.certification.toastrEnterLearnerCode'));
            return false;
          }
        }).catch(function (e) {
          _this3.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'));
          return false;
        });
      }
    },
    getProjectConfig: function getProjectConfig() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('o/screenConfig/getScreenConfigByID/' + 'IT_CERTIFICATION').then(function (response) {
        _this4.screenConfig = response.data;
        if (_this4.screenConfig.visible === false) {
          _this4.noneOfAbove = true;
          _this4.nextTabFunc();
        } else {
          _this4.getCertificationDetails();
        }
      }).catch(function (e) {
        console.error(e);
      });
    }
  },
  created: function created() {
    if (this.$store.state.user.userDetails.confirmStatus) {
      this.$router.push({ name: 'entry' });
    } else {
      this.getProjectConfig();
      this.getCertificationMaster();
    }
  }
});

/***/ }),

/***/ "BGyx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_diplomaDetails_vue__ = __webpack_require__("LRRy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01f8fff8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_diplomaDetails_vue__ = __webpack_require__("MsRS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("omub")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_diplomaDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01f8fff8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_diplomaDetails_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01f8fff8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_diplomaDetails_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Bfae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_picture_input__ = __webpack_require__("2f0p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__ = __webpack_require__("VrvJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_xmltojson__ = __webpack_require__("IMsm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_xmltojson___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_xmltojson__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_aadhaar_validator__ = __webpack_require__("mMRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_aadhaar_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_aadhaar_validator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* import myDatepicker from 'vue-datepicker2' */

/* import datepicker from 'vuejs-datepicker' */




// import candidateProfile from '../../store/modules/candidateProfile';
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PersonalDetails',
  components: {
    PictureInput: __WEBPACK_IMPORTED_MODULE_3_vue_picture_input__["a" /* default */],
    'date-picker': __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default.a
    /*  datepicker: datepicker */
  },
  data: function data() {
    return {
      days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
      placeholder: {
        date: 'Select Date',
        dateRange: 'Select Date Range'
      },
      start: new Date(1960, 2, 1),
      end: new Date(2001, 8, 1),
      startTime: '',
      scanAadhar: false,
      disabledDates: {
        to: new Date(2001, 8, 1),
        from: new Date(1960, 2, 1)
        /* daysOfMonth: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] */
      },
      candidateProfile: { personalDetails: {}, contactDetails: {} },
      personalDetail: {},
      aadhaarData: {},
      aadhaarValid: false,
      genderList: [{ genderID: 1, name: 'Male' }, { genderID: 2, name: 'Female' }, { genderID: 3, name: 'Transgender' }],
      maritalStatusList: [{ maritalStatusID: 1, name: 'Single' }, { maritalStatusID: 2, name: 'Married' }, { maritalStatusID: 3, name: 'Divorced' }, { maritalStatusID: 4, name: 'Widowed' }, { maritalStatusID: 5, name: 'Separated' }],
      motherTongueList: [],
      drpDwn: false,
      endtime: {
        time: ''
      },
      date: {
        time: ''
      },
      limit: [{
        type: 'fromto',
        from: '1960-02-01',
        to: '2001-08-01'
      }],
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'Select Date Of Birth',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          border: '2px solid #fff',
          'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
          'border-radius': '2px',
          color: '#5F5F5F'
        },
        color: {
          header: '#ccc',
          headerText: '#f00'
        },
        buttons: {
          ok: 'Ok',
          cancel: 'Cancel'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      timeoption: {
        type: 'min',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'DD-MM-YYYY HH:mm'
      },
      multiOption: {
        type: 'multi-day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'DD-MM-YYYY HH:mm'
      }
    };
  },

  methods: {
    fetchUserDetails: function fetchUserDetails() {
      var _this = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('/r/entry/getUserApplicationStatus/' + this.$store.state.candidateProfile.profileUser).then(function (response) {
        if (response.data !== null) {
          var profileStatus = response.data.profileStatus;
          if (!profileStatus.personalDetails) {
            _this.$router.push({ name: 'personalDetails' });
          } else if (!profileStatus.contactDetails) {
            _this.$router.push({ name: 'address' });
          } else if (!profileStatus.educationDetails) {
            _this.$router.push({ name: 'educationalDetails' });
          } else if (!profileStatus.documentDetails) {
            _this.$router.push({ name: 'documentsupload' });
          } else if (!profileStatus.qualificationDetails) {
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('r/projectConfig/getAllProjectConfig').then(function (responses) {
              if (responses.data.ocrConfig.required) {
                _this.$router.push({ name: 'imageExtracter' });
              } else {
                _this.$router.push({ name: 'qualificationDetails' });
              }
            }).catch(function (e) {
              console.log(e);
            });
          } else {
            _this.$router.push({ name: 'profileSummary' });
          }
        }
      }).catch(function (e) {
        _this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: _this.TOASTR_TIME
        });
        console.error(e);
      });
    },
    nextTabFunc: function nextTabFunc() {
      if ((this.personalDetail.aadhaarNumber === undefined || this.personalDetail.aadhaarNumber === null || this.personalDetail.aadhaarNumber === '') && (this.personalDetail.enrolmentNumber === undefined || this.personalDetail.enrolmentNumber === null || this.personalDetail.enrolmentNumber === '')) {
        this.$toasted.error(this.$t('candidateProfile.personalDetails.toastrSelectAadharOrEnrolement'));
        return false;
      } else if (this.personalDetail.aadhaarNumber !== undefined && this.personalDetail.aadhaarNumber !== null && this.personalDetail.aadhaarNumber !== '') {
        this.checkAadhaarValidity();
      } else {
        this.save();
      }
    },
    prevTabFunc: function prevTabFunc() {
      this.$router.push('itCertification');
    },
    dateValidation: function dateValidation() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('o/personalDetails/getvalidateDOBRoute', new Date(__WEBPACK_IMPORTED_MODULE_6_moment___default()(String(this.startTime)).format('YYYY-MM-DD'))).then(function (response) {
        if (response.data === false) {
          _this2.startTime = '';
          _this2.$toasted.error(_this2.$t('candidateProfile.personalDetails.toastrNotValidDOB'));
        }
      }).catch(function (e) {
        console.error(e);
      });
    },
    onInit: function onInit(promise) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var self;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this3;
                // show loading indicato

                _context.prev = 1;
                _context.next = 4;
                return promise;

              case 4:
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](1);

                console.log(_context.t0);
                if (_context.t0.name === 'NotAllowedError') {
                  // user denied camera access permisson
                  // this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrDeneidCameraAccess'), {
                  _this3.$toasted.error(self.$t('candidateProfile.personalDetails.toastrNotSuitableCameraDevice'));
                  _this3.scanAadhar = false;
                } else if (_context.t0.name === 'NotFoundError') {
                  // no suitable camera device installed
                  _this3.$toasted.error(self.$t('candidateProfile.personalDetails.toastrNotSuitableCameraDevice'));
                  _this3.scanAadhar = false;
                } else if (_context.t0.name === 'NotSupportedError') {
                  // page is not served over HTTPS (or localhost)
                  // this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrPageIsNotServed'), {
                  _this3.$toasted.error(self.$t('candidateProfile.personalDetails.toastrNotSuitableCameraDevice'));
                  _this3.scanAadhar = false;
                } else if (_context.t0.name === 'NotReadableError') {
                  // maybe camera is already in use
                  // this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrCameraAlereadyInUse'), {
                  _this3.$toasted.error(self.$t('candidateProfile.personalDetails.toastrNotSuitableCameraDevice'));
                  _this3.scanAadhar = false;
                } else if (_context.t0.name === 'OverconstrainedError') {
                  // passed constraints don't match any camera. Did you requested the front camera although there is none?
                  // this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrDontMatchAnyCamera'), {
                  _this3.$toasted.error(self.$t('candidateProfile.personalDetails.toastrNotSuitableCameraDevice'));
                  _this3.scanAadhar = false;
                } else {
                  // browser is probably lacking features (WebRTC, Canvas)
                  // this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrBrowserLackingFeatures'), {
                  _this3.$toasted.error(self.$t('candidateProfile.personalDetails.toastrNotSuitableCameraDevice'));
                  _this3.scanAadhar = false;
                }

              case 10:
                _context.prev = 10;
                return _context.finish(10);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[1, 6, 10, 12]]);
      }))();
    },
    onDecode: function onDecode(content) {
      content = content.slice(content.indexOf('?>') + 3, content.length);
      var result = __WEBPACK_IMPORTED_MODULE_7_xmltojson___default.a.parseString(content);
      this.personalDetail.aadhaarNumber = result.PrintLetterBarcodeData[0]._attr.uid._value.toString();
      this.aadhaarData.aadhaarNumber = result.PrintLetterBarcodeData[0]._attr.uid._value.toString();
      this.personalDetail.fullName = result.PrintLetterBarcodeData[0]._attr.name._value;
      this.aadhaarData.fullName = result.PrintLetterBarcodeData[0]._attr.name._value;
      if (result.PrintLetterBarcodeData[0]._attr.gender._value === 'M') {
        this.personalDetail.gender = { name: 'Male', genderID: 1 };
        this.aadhaarData.gender = { name: 'Male', genderID: 1 };
      } else if (result.PrintLetterBarcodeData[0]._attr.gender._value === 'F') {
        this.personalDetail.gender = { name: 'Female', genderID: 2 };
        this.aadhaarData.gender = { name: 'Female', genderID: 2 };
      } else {
        this.personalDetail.gender = { name: result.PrintLetterBarcodeData[0]._attr.gender._value };
        this.aadhaarData.gender = { name: result.PrintLetterBarcodeData[0]._attr.gender._value };
      }
      this.personalDetail.pincode = result.PrintLetterBarcodeData[0]._attr.pc._value;
      this.candidateProfile.personalDetails = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.personalDetail));
      this.candidateProfile.aadhaarVerified = true;
      this.$toasted.success(this.$t('toastr.toastrAadhaarScanSuccess'), {
        theme: 'bubble',
        duration: 2000
      });
    },

    getAllData: function getAllData() {
      var _this4 = this;

      // Get Mother Tongue List.
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('r/personalDetails/getMotherTongueListRoute').then(function (response) {
        _this4.motherTongueList = response.data;
        _this4.getPersonalDetails();
      }).catch(function (e) {
        console.error(e);
      });
    },
    getPersonalDetails: function getPersonalDetails() {
      var _this5 = this;

      // Get Personal Details.
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('r/personalDetails/getPersonalDetailsRoute/' + this.$store.state.candidateProfile.profileUser).then(function (response) {
        var responseData = response.data;
        if (responseData !== null && responseData !== '') {
          // console.log('fullName' + JSON.stringify(response.data.fullName))
          _this5.candidateProfile = responseData;
          if (_this5.candidateProfile.aadhaarVerified === true) {
            _this5.aadhaarData.fullName = _this5.candidateProfile.personalDetails.fullName;
            _this5.aadhaarData.gender = _this5.candidateProfile.personalDetails.gender;
            _this5.aadhaarData.aadhaarNumber = _this5.candidateProfile.personalDetails.aadhaarNumber;
          }
          _this5.personalDetail = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this5.candidateProfile.personalDetails));

          if (_this5.personalDetail.gender.genderID === 0) {
            delete _this5.personalDetail.gender;
            delete _this5.personalDetail.maritalStatus;
            delete _this5.personalDetail.motherTongue;
          }
          if (_this5.personalDetail.dob !== undefined && _this5.personalDetail.dob !== null && _this5.personalDetail.dob !== '') {
            _this5.startTime = __WEBPACK_IMPORTED_MODULE_6_moment___default()(String(_this5.personalDetail.dob)).format('YYYY-MM-DD');
          }
        }
      }).catch(function (e) {
        console.error(e);
      });
    },

    checkAadhaarValidity: function checkAadhaarValidity() {
      var _this6 = this;

      var self = this;
      if (this.validateAadhaar()) {
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('r/personalDetails/validateaadhaarduplication/' + this.$store.state.candidateProfile.profileUser + '/' + this.personalDetail.aadhaarNumber).then(function (response) {
          var aadhaaValid = response.data;
          if (!aadhaaValid) {
            _this6.aadhaarValid = false;
            _this6.$toasted.error(self.$t('candidateProfile.personalDetails.toastrAadhaarAlreadyExists'));
          } else {
            _this6.aadhaarValid = true;
            _this6.save();
          }
        }).catch(function (e) {
          console.error(e);
        });
      } else {
        this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrEnterValidAadhaarDetails'));
        return false;
      }
    },
    validateAadhaar: function validateAadhaar() {
      return __WEBPACK_IMPORTED_MODULE_8_aadhaar_validator___default.a.isValidNumber(this.personalDetail.aadhaarNumber.toString());
    },
    validatePanNumber: function validatePanNumber() {
      var panPat = /^([a-zA-Z]{5})(\d{4})([a-zA-Z]{1})$/;
      var code = /([C,P,H,F,A,T,B,L,J,G])/;
      var panSubString = this.personalDetail.panNumber.substring(3, 4);
      if (this.personalDetail.panNumber.search(panPat) === -1) {
        return false;
      }
      if (code.test(panSubString) === false) {
        return false;
      }
      return true;
    },
    save: function save(scope) {
      var _this7 = this;

      // This method save personal details in candidate_profile collection(mongoDB).
      this.personalDetail.fullName = this.personalDetail.fullName.toUpperCase();
      this.personalDetail.nameOnLeavingCertificate = this.personalDetail.nameOnLeavingCertificate.toUpperCase();
      if (this.personalDetail.panNumber) {
        this.personalDetail.panNumber = this.personalDetail.panNumber.toUpperCase();
      }
      var self = this;
      return this.$validator.validate().then(function (result) {
        if (result) {
          /* if (this.aadhaarValid === false) {
            this.checkAadhaarValidity()
            return false
          } */
          if (_this7.personalDetail.panNumber !== undefined && _this7.personalDetail.panNumber !== null && _this7.personalDetail.panNumber !== '') {
            if (!_this7.validatePanNumber()) {
              _this7.$toasted.error(self.$t('candidateProfile.personalDetails.toastrEnterValidPanDetails'));
              return false;
            }
          }
          if (_this7.aadhaarData.fullName !== undefined && _this7.aadhaarData.fullName !== null && _this7.aadhaarData.fullName !== '') {
            if (_this7.aadhaarData.fullName !== _this7.personalDetail.fullName) {
              _this7.candidateProfile.aadhaarVerified = false;
              _this7.candidateProfile.personalDetails.fullName = _this7.personalDetail.fullName;
            }
            if (_this7.aadhaarData.gender.genderID !== _this7.personalDetail.gender.genderID) {
              _this7.candidateProfile.aadhaarVerified = false;
              _this7.candidateProfile.personalDetails.gender.genderID = _this7.personalDetail.gender.genderID;
            }
            if (_this7.aadhaarData.aadhaarNumber !== _this7.personalDetail.aadhaarNumber) {
              _this7.candidateProfile.aadhaarVerified = false;
              _this7.candidateProfile.personalDetails.aadhaarNumber = _this7.personalDetail.aadhaarNumber;
            }
            if (_this7.personalDetail.pincode !== undefined && _this7.personalDetail.pincode !== null && _this7.personalDetail.pincode !== '') {
              _this7.candidateProfile.contactDetails.permanentPin = _this7.personalDetail.pincode;
            }
          } else {
            _this7.candidateProfile.aadhaarVerified = false;
          }
          if (_this7.personalDetail.panNumber !== undefined && _this7.personalDetail.panNumber !== null && _this7.personalDetail.panNumber !== '') {
            _this7.candidateProfile.personalDetails.panNumber = _this7.personalDetail.panNumber.toUpperCase();
          }
          _this7.candidateProfile.personalDetails = _this7.personalDetail;
          _this7.candidateProfile.personalDetails.dob = new Date(__WEBPACK_IMPORTED_MODULE_6_moment___default()(String(_this7.startTime)).format('YYYY-MM-DD'));
          _this7.candidateProfile.personalDetails.fullName = _this7.candidateProfile.personalDetails.fullName.trim();
          _this7.candidateProfile.personalDetails.nameOnLeavingCertificate = _this7.candidateProfile.personalDetails.nameOnLeavingCertificate.trim();
          return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('r/personalDetails/updatepersonalDetails/' + _this7.$store.state.candidateProfile.profileUser, _this7.candidateProfile).then(function (response) {
            if (response.status === 200) {
              _this7.$toasted.success(self.$t('toastr.toastrPersonalDetailsSaved'));
              _this7.scanAadhar = false;
              // this.$router.push('address')
              _this7.fetchUserDetails();
              return true;
            }
          }).catch(function (e) {
            console.log(e);
            return false;
          });
        } else {
          _this7.$validator.validate('form-1.FullName', _this7.personalDetail.fullName).then(function (result) {
            if (!result) {
              _this7.$toasted.error(self.$t('candidateProfile.personalDetails.toastrEnterValidFullName'));
            }
          });
          _this7.$validator.validate('form-1.Father Name', _this7.personalDetail.fatherName).then(function (result) {
            if (!result) {
              _this7.$toasted.error(self.$t('candidateProfile.personalDetails.toastrEnterFatherName'));
            }
          });
          _this7.$validator.validate('form-1.Mother Name', _this7.personalDetail.motherName).then(function (result) {
            if (!result) {
              _this7.$toasted.error(self.$t('candidateProfile.personalDetails.toastrEnterMotherName'));
            }
          });
          _this7.$validator.validate('gender', _this7.personalDetail.gender).then(function (result) {
            if (!result) {
              _this7.$toasted.error(self.$t('candidateProfile.personalDetails.toastrSelectGender'));
            }
          });
          _this7.$validator.validate('DOB', _this7.personalDetail.dob).then(function (result) {
            if (!result) {
              _this7.$toasted.error(self.$t('candidateProfile.personalDetails.toastrEnterValidDOB'));
            }
          });
          _this7.$validator.validate('mother Tongue', _this7.personalDetail.motherTongue).then(function (result) {
            if (!result) {
              _this7.$toasted.error(self.$t('candidateProfile.personalDetails.toastrSelectMotherTongue'));
            }
          });
          _this7.$validator.validate('marital Status', _this7.personalDetail.maritalStatus).then(function (result) {
            if (!result) {
              _this7.$toasted.error(self.$t('candidateProfile.personalDetails.toastrSelectMaritalStatus'));
            }
          });
          _this7.$validator.validate('form-1.Name On Leaving Certificate', _this7.personalDetail.nameOnLeavingCertificate).then(function (result) {
            if (!result) {
              _this7.$toasted.error(self.$t('candidateProfile.personalDetails.toastrEnterNameOnLeavingCertificate'));
            }
          });
          _this7.$validator.validate('form-1.Aadhar Number', _this7.personalDetail.aadhaarNumber).then(function (result) {
            if (!result) {
              if (_this7.personalDetail.aadhaarNumber === '') {
                _this7.$toasted.error(self.$t('candidateProfile.personalDetails.toastrEnterAadhaarDetails'));
              } else {
                _this7.$toasted.error(self.$t('candidateProfile.personalDetails.toastrAadhaarMustBe12Digits'));
              }
            }
          });
          return false;
        }
      }).catch(function (e) {
        console.error(e);
        return false;
      });
    }
  },
  created: function created() {
    if (this.$store.state.user.userDetails.confirmStatus) {
      this.$router.push({ name: 'entry' });
    } else {
      this.getAllData();
      this.getPersonalDetails();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.scanAadhar = false;
  }
});

/***/ }),

/***/ "BlQR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mfs_header_vue__ = __webpack_require__("ua1h");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5502e422_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mfs_header_vue__ = __webpack_require__("nB+O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("1Ft2")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mfs_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5502e422_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mfs_header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5502e422_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mfs_header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C1Az":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imageExtracter_vue__ = __webpack_require__("DVUZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3067bc49_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_imageExtracter_vue__ = __webpack_require__("+H/O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("p/2+")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imageExtracter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3067bc49_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_imageExtracter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3067bc49_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_imageExtracter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CBuF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DNzp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DVUZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_konva__ = __webpack_require__("xLKd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_konva___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_konva__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ImageExtracter',
  data: function data() {
    return {
      title: '',
      index: 0,
      darthVaderGroup: {},
      imagePath: '',
      questionList: [],
      documentList: [],
      imgposition: { x: 0, y: 0 }
    };
  },

  methods: {
    nextTabFunc: function nextTabFunc() {
      this.save();
    },
    prevTabFunc: function prevTabFunc() {
      this.$router.push('documentsupload');
    },
    changeCheckBox: function changeCheckBox(item) {
      for (var index = 0; index < this.questionList.length; index++) {
        if (item.field === this.questionList[index].field) {
          var temp = this.questionList;
          this.questionList = [];
          temp[index].field = item.field;
          this.questionList = temp;
        }
      }
    },
    nextDoc: function nextDoc() {
      var _this = this;

      var self = this;
      this.$validator.validate().then(function (result) {
        if (!result) {
          for (var i in self.questionList) {
            if (self.questionList[i].value.trim() === '') {
              self.$toasted.error(self.$t('candidateProfile.imageExtracter.toastrMessageAppender') + self.questionList[i].title, {
                theme: 'bubble',
                duration: self.TOASTR_TIME
              });
            }
          }
        } else {
          if (_this.getDoc(_this.index + 1) === true) {
            _this.documentList[_this.index].completed = true;
            _this.index++;
          }
        }
      });
    },
    prevDoc: function prevDoc() {
      var _this2 = this;

      var self = this;
      this.$validator.validate().then(function (result) {
        if (!result) {
          for (var i in self.questionList) {
            if (self.questionList[i].value.trim() === '') {
              self.$toasted.error(self.$t('candidateProfile.imageExtracter.toastrMessageAppender') + self.questionList[i].title, {
                theme: 'bubble',
                duration: self.TOASTR_TIME
              });
            }
          }
        } else {
          if (_this2.getDoc(_this2.index - 1) === true) {
            _this2.documentList[_this2.index].completed = true;
            _this2.index--;
          }
        }
      });
    },
    getDoc: function getDoc(i) {
      if (i < this.documentList.length && i > -1) {
        this.title = this.documentList[i].title;
        this.imagePath = this.documentList[i].marksheetUrl;
        this.questionList = this.documentList[i].questions;
        return true;
      }
      return false;
    },
    crop: function crop(que) {
      que.crop = true;
      this.capturePoints(this.imgposition.x, this.imgposition.y, this.darthVaderGroup.children[0].attrs.width, this.darthVaderGroup.children[0].attrs.height, 'id', que);
    },
    getDocumentDetails: function getDocumentDetails() {
      var profileUser = this.$store.state.candidateProfile.profileUser;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('r/ocr/documents/' + profileUser).then(function (response) {
        if (response.status === 200) {
          self.documentList = response.data;
          if (self.documentList.length > 0) {
            self.getDoc(0);
          }
        }
      }).catch(function (e) {
        console.error(e);
        self.$toasted.error(self.$('candidateProfile.imageExtracter.toastrCertificationDetailsFeatchError'), {
          theme: 'bubble',
          duration: self.TOASTR_TIME
        });
      });
    },
    save: function save() {
      var _this3 = this;

      if (this.index < this.documentList.length - 1) {
        this.nextDoc();
        return false;
      }
      var profileUser = this.$store.state.candidateProfile.profileUser;
      var self = this;
      return this.$validator.validate().then(function (result) {
        if (result) {
          _this3.documentList[_this3.index].completed = true;
          for (var i in _this3.documentList) {
            if (_this3.documentList.length > 1 && (_this3.documentList[i].completed === undefined || !_this3.documentList[i].completed)) {
              self.$toasted.error(self.$t('candidateProfile.imageExtracter.toastrMessageAppender') + _this3.documentList[i].title + ' details', {
                theme: 'bubble',
                duration: self.TOASTR_TIME
              });
              return false;
            }
          }
          return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('r/candidateProfile/saveEducationFieldDetails/' + profileUser, _this3.documentList).then(function (response) {
            if (response.status === 200) {
              self.$toasted.success(self.$t('toastr.toastrEducationalDetailsSaved'), {
                theme: 'bubble',
                duration: self.TOASTR_TIME
              });
              self.$router.push({ name: 'profileSummary' });
              return true;
            }
            return false;
          }).catch(function (e) {
            self.$toasted.error(self.$t('candidateProfile.imageExtracter.toastrCertificationDetailsFeatchError'), {
              theme: 'bubble',
              duration: self.TOASTR_TIME
            });
            return false;
          });
        } else {
          for (var j in self.questionList) {
            if (self.questionList[j].value.trim() === '') {
              self.$toasted.error(self.$t('candidateProfile.imageExtracter.toastrMessageAppender') + self.questionList[j].title, {
                theme: 'bubble',
                duration: self.TOASTR_TIME
              });
            }
          }
          return false;
        }
      });
    },
    addAnchor: function addAnchor(group, x, y, name) {
      var self = this;
      // var stage = group.getStage();
      var layer = group.getLayer();
      var anchor = new __WEBPACK_IMPORTED_MODULE_0_konva___default.a.Circle({
        x: x,
        y: y,
        stroke: '#666',
        fill: '#ddd',
        strokeWidth: 2,
        radius: 8,
        name: name,
        draggable: true,
        dragOnTop: false
      });

      anchor.on('dragmove', function () {
        self.update(this);
        layer.draw();
      });
      anchor.on('mousedown touchstart', function () {
        group.setDraggable(false);
        this.moveToTop();
      });
      anchor.on('dragend', function () {
        group.setDraggable(true);
        layer.draw();
      });
      // add hover styling
      anchor.on('mouseover', function () {
        var layer = this.getLayer();
        document.body.style.cursor = 'pointer';
        this.setStrokeWidth(2);
        layer.draw();
      });
      anchor.on('mouseout', function () {
        var layer = this.getLayer();
        document.body.style.cursor = 'default';
        this.setStrokeWidth(2);
        layer.draw();
      });

      group.add(anchor);
      self.darthVaderGroup = group;
    },
    capturePoints: function capturePoints(x, y, w, h, id, que) {
      var obj = {};
      obj.x = x;
      obj.y = y;
      obj.w = w;
      obj.h = h;
      obj.imagePath = this.imagePath;
      var self = this;
      if (this.imagePath === undefined || this.imagePath === null || this.imagePath === '') {
        self.$toasted.error(self.$t('candidateProfile.imageExtracter.toastrImageNotAvailable'), {
          theme: 'bubble',
          duration: self.TOASTR_TIME
        });
        return false;
      }
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('r/ocr/parse', obj).then(function (response) {
        if (response.status === 200) {
          que.value = response.data.result;
        }
      }).catch(function () {
        self.$toasted.error(self.$t('candidateProfile.imageExtracter.toastrCertificationListFeatchError'), {
          theme: 'bubble',
          duration: self.TOASTR_TIME
        });
      });
    },
    updateGroup: function updateGroup(group) {
      this.darthVaderGroup = group;
      var topLeft = group.get('.topLeft')[0];
      var anchorX = group.getX();
      var anchorY = group.getY();
      this.imgposition.y = anchorY + topLeft.getY();
      this.imgposition.x = anchorX + topLeft.getX();
    },
    update: function update(activeAnchor) {
      var group = activeAnchor.getParent();
      // var layer = group.getLayer()
      var topLeft = group.get('.topLeft')[0];
      var topRight = group.get('.topRight')[0];
      var bottomRight = group.get('.bottomRight')[0];
      var bottomLeft = group.get('.bottomLeft')[0];
      var image = group.get('Image')[0];

      var anchorX = activeAnchor.getX();
      var anchorY = activeAnchor.getY();

      // update anchor positions
      switch (activeAnchor.getName()) {
        case 'topLeft':
          topRight.setY(anchorY);
          bottomLeft.setX(anchorX);
          break;
        case 'topRight':
          topLeft.setY(anchorY);
          bottomRight.setX(anchorX);
          break;
        case 'bottomRight':
          bottomLeft.setY(anchorY);
          topRight.setX(anchorX);
          break;
        case 'bottomLeft':
          bottomRight.setY(anchorY);
          topLeft.setX(anchorX);
          break;
      }
      image.position(topLeft.position());
      var width = topRight.getX() - topLeft.getX();
      var height = bottomLeft.getY() - topLeft.getY();
      if (width && height) {
        image.width(width);
        image.height(height);
      }
    }
  },
  created: function created() {
    if (this.$store.state.user.userDetails.confirmStatus) {
      this.$router.push({ name: 'entry' });
    } else {
      this.getDocumentDetails();
    }
  },
  mounted: function mounted() {
    var self = this;
    var stage = new __WEBPACK_IMPORTED_MODULE_0_konva___default.a.Stage({
      container: 'container',
      width: 600,
      height: 800,
      transparent: true
    });

    var layer = new __WEBPACK_IMPORTED_MODULE_0_konva___default.a.Layer();
    stage.add(layer);

    // darth vader
    var darthVaderImg = new __WEBPACK_IMPORTED_MODULE_0_konva___default.a.Image({
      width: 200,
      height: 137
    });

    var darthVaderGroup = new __WEBPACK_IMPORTED_MODULE_0_konva___default.a.Group({
      x: 0,
      y: 0,
      draggable: true
    });
    self.darthVaderGroup = darthVaderGroup;

    layer.add(darthVaderGroup);
    darthVaderGroup.add(darthVaderImg);
    self.addAnchor(darthVaderGroup, 0, 0, 'topLeft');
    self.addAnchor(darthVaderGroup, 200, 0, 'topRight');
    self.addAnchor(darthVaderGroup, 200, 138, 'bottomRight');
    self.addAnchor(darthVaderGroup, 0, 138, 'bottomLeft');
    var imageObj1 = new Image();
    imageObj1.onload = function () {
      darthVaderImg.image(imageObj1);
      layer.draw();
    };
    //    imageObj1.src = 'static/assets/images/login/rectangle.png'

    darthVaderGroup.on('dragmove', function () {
      self.updateGroup(this);
      layer.draw();
    });
    darthVaderGroup.on('dragend', function () {
      layer.draw();
    });
    // add hover styling
    darthVaderGroup.on('mouseover', function () {
      // var layer = this.getLayer()
      document.body.style.cursor = 'pointer';
      // this.setStrokeWidth(2)
      layer.draw();
    });
    darthVaderGroup.on('mouseout', function () {
      // var layer = this.getLayer()
      document.body.style.cursor = 'default';
      // this.setStrokeWidth(2)
      layer.draw();
    });
  }
});

/***/ }),

/***/ "DXrT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loader_vue__ = __webpack_require__("+667");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dffcb7e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loader_vue__ = __webpack_require__("aHHY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("7H/g")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dffcb7e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dffcb7e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DcXO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Loader'),_vm._v(" "),(!_vm.isNormalPage)?_c('div',{staticClass:"main"},[_c('router-view')],1):_vm._e(),_vm._v(" "),(_vm.isNormalPage)?_c('div',{staticClass:"main"},[_c('section',{staticClass:"sidebar hidden-sm-down"},[_c('Sidebar')],1),_vm._v(" "),_c('section',{staticClass:"main-content withsidebar"},[_c('div',{staticClass:"f-wrap"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)])]):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "Dofa":
/***/ (function(module, exports) {

module.exports = {"selectLanguage":"Select Language","footerBar":{"lblOrgnization":"2018 Maharashtra Knowledge Corporation Limited","lblPowerdBy":"Powered by MKCL's Core Platform v1.0.1"},"headerBar":{"lblLangEng":"English","lblLangMar":"Marathi","lblHello":"Hello,","lblUserMenu":"User Menu","lblLogout":"Logout","tostrLogout":"Logout Successfully."},"sideBar":{"lblRegistration":"Registration","lblLogout":"Logout","lblCopyRights":"2018 Maharashtra Knowledge Corporation Limited. All Rights Reserved.","tostrLogout":"Logout Successfully."},"login":{"lblHeading1":"MFS Admission Cell","lblHeading2":"Welcome back Please Login here"},"candidateProfile":{"agreement":{"lblCandidateAgreement":"This is an agreement between the student or candidate and the YCMOU which is entered into by virtue of the candidate for admission clicking on “ACCEPT” button on the online admission portal at the time of admission to a program using online admission process. In this agreement the term “candidate” is used to mean the person who proposes to take admission to a program in YCMOU and the term “student” is used to mean a person who has been admitted to a program of the YCMOU after fulfilling all the conditions thereof..","lblUndertakes":"The candidate undertakes that","lblRulesAgree":"I have read the prospectus and rules about admission, thus clicking the below ‘I Agree’ button.","btnIAgree":"I Agree"},"personalDetails":{"plceHoFullName":"Enter your fullname","plceHoNameOnCert":"Enter name as on Leaving Certifcate/Marksheet","plceHoGender":"Select gender","plceHoDOB":"Enter DOB","plceHoMaritalStatus":"Select marital status","plceHoMotherTongue":"Select mother tongue","plceHoAadhaarNo":"Enter Aadhaar number","plceHoPanNo":"Enter PAN number","toastrDeneidCameraAccess":"It seems, your application do not have permission to access camera","toastrNotSuitableCameraDevice":"It seems, no suitable camera device installed","toastrPageIsNotServed":"Page is not served over HTTPS (or localhost)","toastrCameraAlereadyInUse":"It seems, like camera is already in use by other application","toastrDontMatchAnyCamera":"Passed constraints don't match any camera.","toastrBrowserLackingFeatures":"Browser is probably lacking features (WebRTC, Canvas).","toastrEnterValidPanDetails":"Please Enter Valid Pan number","toastrAadhaarMustBe12Digits":"Aadhaar Number must be of 12 Digits","toastrEnterAadhaarDetails":"Please Enter Aadhaar number","toastrEnterNameOnLeavingCertificate":"Please Enter Name as on Leavning Ceriticate","toastrSelectMaritalStatus":"Please Select Marital Status","toastrSelectMotherTongue":"Please Select Mother Tongue","toastrEnterValidDOB":"Please Enter Valid Date of Birth","toastrSelectGender":"Please Select Gender","toastrEnterValidFullName":"Please Enter Valid Full Name","toastrEnterValidAadhaarDetails":"Please Enter Valid Aadhaar Number","toastrNotValidDOB":"You must be at least 17 years old to apply for MFS Programs.","msgScanAadhar":"I would like to scan my aadhaar card for adding information","noteAadhar":"Aadhaar card should not be laminated. You can download digital copy from the official website of UIDAI and scan the QR code via mobile. Scanning aadhaar card is not mandatory, you can fill below details manually too.","lblAadhar":"Scan aadhaar card","lblName":"My name is","lblGender":"and I am a","lblDob":"I was born on","lblMotherTongue":"I speak","lblMotherTongueSpeak":"language at home,","lblMarritalStatus":"Currently I am","lblNameOnLeavingCertificate":"The name on my leaving certificate is","lblAadharNumber":"My aadhaar number is ","lblPanNumber":"and PAN card number is  ","toastrAadhaarAlreadyExists":"Aadhaar Number already exists"},"contactDetails":{"lblCorrespondenceAddressPIN":"My correspondence address's pincode is","plceCorrespondancePIN":"Correspondence Address PIN","lblPermanentAddressPIN":"and permanent address's pincode is","plcePermanentAddressPIN":"Permanent Address PIN","lblContactDetails":"Contact Details","lblEmailID":"Contact me on my verified email address","plceEmailID":"Email ID","lblMobileNumber":"and mobile number","plceMobileNumber":"Mobile Number","lblSkypeID":"My skype ID is","plceSkypeID":"Skype ID","toastrEnterCorrespondanceAddress":"Please Enter Correspondance Address Pincode","toastrCorrespondancePinDigits":"Correspondance Address PIN must have 6 digits","toastrEnterPermanentAddress":"Please Enter Permanent Address Pincode","toastrPermanentPinDigits":"Permanent Address must have 6 digits","toastrEnterEmailID":"Please Enter Email ID","toastrInvalidEmailID":"Email ID is Invalid...Please Enter Valid Email ID","toastrEnterMobileNumber":"Please Enter Mobile Number","toastrMobileNumberDigits":"Mobile Number Must have 10 Digits"},"educationDetails":{"lblPassedOrAppeared":"I","lblIn":"In","lblExam":"exam","lblName":"Since you are not passed/apperred for HSC/Diploma so can not go Further","lblHscOrDiploma":"in HSC / Diploma","plceQualification":"Qualification","plceQualificationStatus":"Qualification Status","lblDiplomaTicketDoc":"Diploma Hall Ticket","lblHSCHallTicketDoc":"HSC Hall Ticket","toastrSelectQualification":"Please Select Any One Qualification","toastrSelectQualificationStatus":"Please Select Qualification Status","lblNoneOfAbove":"None of the above","lblHsc":"HSC","lblSelectHSCResult":"Select your HSC Result","lblAppearing":"Appearing","lblPassed":"Passed","lblOr":"OR","lblDiploma":"Diploma","lblSelectDiplomaResult":"Select your Diploma Result","lblAnyOfAbove":"Have you completed any of the above?","lblNo":"No","lblHSCAppeared":"HSC Appeared","lblDiplomaAppeared":"Diploma Appeared"},"certification":{"lblCertificationCompleted":"I have completed my IT literacy certification in","lblLearnerCode":"Learner Code","lblLearnerCodeIs":"and my learner code is","lblNotCompletedCertification":"I have not completed any IT literacy certifications like MS-CIT, BS-CIT, ...","lblAnyCertificate":"Do you have completed any of following certification?","plceHoLearnerCode":"Enter your learner code","plceHoITCertification":"MS-CIT","toastrErrorFetchingCertificationList":"Error While Fetching Certification List","toastrSelectCertification":"Please Select IT Certification","toastrLearnerCodeInvalid":"Learner Details of given learner code doest not exists","toastrEnterLearnerCode":"Please Enter Learner code"},"profileSummary":{"lblPersonalDetails":"Personal Details","lblName":" Hi, my name is ","lblGender":"I am a","lblDOB":"born on","lblMotherTounge":"My mother tongue is","lblAnd":"and","lblMaritalStatus":"I am currently","btnEditDetails":"Edit Details","lblContactDetails":"Contact Details ","lblMartialStatus":"Martial Status","lblAadharNo":"Aadhar No","lblPanNo":"Pan No","lblNameOnLeaving":"Name on leaving certificate","lblMobileNumber":"My verified mobile number is ","lblEmailID":"and email id is ","lblSkypeId":"My Skype id is","lblCorrespondanceAddress":"My correspondance address is ","lblPermanentAddress":"and permanent address is","lblRespectively":"respectively.","lblITCertification":"IT Literacy Certification","lblCompletedITCertification":"I have completed my IT certification in","lblLearnerCode":"My learner code is ","lblSkil":"I am skilled in","lblPreviousExperience":"My previous experience includes","lblITCertficationTechnology":"IT Technologies respectively.","lblKnownTechnologies":"Known Technological Languages","lblEducationDetails":"Educational Details","lblSSC":"SSC","lblHSC":"HSC","lblDiploma":"Diploma","lblDegree":"Degree","lblMarksheet":"Marksheet","lblCertificationNotCompleted":"I have not completed any Certification","lblNotEligible":"Since you have not Appeared/Passed HSC or Degree you are not eligible for this program.","toastrPermanentPinCodeNotFound":"Permanent Address For Given Pincode Not Found!","toastrcorrespondancePinCodeNotFound":"Correpondance Address For Given Pincode Not Found!"},"imageExtracter":{"toastrMessageAppender":"Please Enter ","toastrCertificationDetailsFeatchError":"Error while featch certificate details","toastrCertificationListFeatchError":"Error while featch certificate list'","lblCrop":"Crop","toastrImageNotAvailable":"Image Not Available"},"documentUpload":{"lblProfilePhoto":"Profile Photo","lblSscDoc":"SSC Documents","lblHscDoc":"HSC Documents","lblDiplomaDoc":"Diploma Documents","toastrFileAlreadyExists":"File Already Present on CDN","toastrNoResponse":"No response from CDN","toastrDocumentsUploadSuccess":"Documents details saved successfully","toastrFileDeleted":"File Deleted Successfully","toastrDataNotPresent":"Data Not Present in DB","toastrDocumentsUploadedSuccess":"Documents uploaded successfully","toastrDocumentsUploadError":"Please Upload All Documents","toastrDocumentsUploadSizeError":"Please Upload file less than 300 KB"}},"registration":{"fullName":"Full Name","dob":"DOB","email":"Email","mobile":"Mobile","username":"Username","password":"Password","lblMFSAdmissionCell":"MFS Admission Cell","lblSignUpToContinue":"Sign up to continue","lblSuggestedUsernames":"Suggested user names :","msgSignUpNote":"By signing up you agree to our Terms and Conditons","toastrPleaseEnterValidFullName":"Please Enter Valid Full Name","toastrUsernameRequired":"Please Enter Username","toastrPasswordRequired":"Please Enter Password","toastrEmailRequired":"Please Enter Email ID","toastrInvalidEmail":"Please Enter Valid Email ID","toastrMobileRequired":"Please Enter Mobile No","toastrInvalidMobile":"Mobile No must have 10 digits","toastrOTPRequired":"Please Enter OTP","toastrInvalidOTP":"OTP must have 6 digits","toastrVerifyMobileNumber":"Please Verify Mobile No","buttonType":{"register":"Register","cancel":"Cancel","verifyOTP":"Verify OTP","sendOTP":"Send OTP"},"placeholder":{"fullname":"Full Name","mobile":"Mobile Number","username":"Username","password":"Password","email":"Email"},"alerts":{"DATA_NOT_VALID":"Please Properly fill the data","REGISTRATION_FAIL":"Registration Failed","REGISTRATION_SUCCESS":"Registration Successful","FAIL_TO_FIND_USERNAME_AVAILABILITY":"Failed to find username availability","USERNAME_NOT_AVAILABLE":"Username is Not Available","USERNAME_NOT_VALID":"Email ID is Not Valid","USERNAME_ALREADY_EXIST":"Email ID already exist","OTP_SEND_SUCCESS":"OPT is sent to your mobile number please verify.","OTP_Send_Fail":"Fail to send OTP check Mobile Number/Email","ENTER_VALID_DETAILS":"Please Enter Valid Details","OTP_VERIFY_SUCCESS":"OTP verified Successfully","OTP_INVALID":"Invalid OTP","MOBILE_NUMBER_CHANGED":"Please Resend OTP to given Mobile Number","OTP_VERIFY_FAIL":"Fail To verify because of You changed Mobile no./Email"},"tabs":{"tabITLiteracy":"IT Literacy Certification","tabPersonalDetails":"Personal details","tabContactDetails":"Contact Details","tabEducationDetails":"Educational Details","tabDocumentUpload":"Documents Upload","tabProfileSummary":"Profile Summary","tabImageExtractor":"Qualification Details"}},"candidateApplications":{"title":"Course Selection","plceHoSearchBox":"Search Course/University","erorNotMatchFound":"There is no matching found.","toastrAppAlreadyExist":"Your have already applied for this Application."},"workPlace":{"toastrAddedInCart":"added in your list.","toastrExistData":"This workplace already selected.","plceHoWorkPlace":"Search workplace","toastrDelete":"removed from your list.","toastrSaveData":"Your Application Saved Successfully.","toastrWarningForSelection":"Please select workplace.","lblWorkPlace":"Select your workplace","erorNotMatchFound":"There is no matching found.","lblSelectedWorkPlace":"Selected workplaces","infoStatment1":"You have selected","infoStatment2":"as course at","erorNotSelected":"There is no workplace selected."},"entry":{"candidateAgreement":"Candidate / Student Agreement","toastrSelectAtLeastOne":"Please check at least one instruction"},"button":{"apply":"Apply","select":"Select","view":"View","save":"Save","update":"Update","delete":"Delete","remove":"Remove","Finish":"Confirm & Proceed","signUp":"Sign Up","login":"Login","back":"Back","next":"Next","cancel":"Cancel","confirm_proceed":"Confirm & Proceed"},"toastr":{"toastrPersonalDetailsSaved":"Personal Details Saved Successfully.","toastrAddressDetailsSaved":"Address Details Saved Successfully.","toastrContactDetailsSaved":"Contact Details Saved Successfully.","toastrEducationalDetailsSaved":"Educational Details Saved Successfully.","toastrCertificationDetailsSaved":"Certification Details Saved Successfully.","toastrSomethingWentWrong":"Ooops…Something went Wrong!","toastrDetailsSaved":"Details Saved Successfully","toastrAadhaarScanSuccess":"Aadhaar Scan Successful","toastrProfileCompleted":"Profile Completed","toastrIntrustionsSaved":"Instructions Saved"}}

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return STORE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STORE_PROFILE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STORE_PROFILE_USER_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STORE_PROFILE_USER_PHOTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STORE_PROFILE_USER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return STORE_CONFIRM_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return STORE_INCREMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return STORE_DECREMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return STORE_LOGIN; });
/* unused harmony export STORE_LOGOUT */
/* unused harmony export STORE_CHANGE_PASSWORD */
/* unused harmony export STORE_CENTER */
/* unused harmony export STORE_SET_FULL_BANNER */
/* unused harmony export STORE_HEADER */
/* unused harmony export STORE_HEADER_OBJ */
/* unused harmony export STORE_CHILDREN_OBJ */
/* unused harmony export STORE_CHILDREN */
/* unused harmony export STORE_ARRAY */
/* unused harmony export STORE_NEXT */
/* unused harmony export STORE_PREVIOUS */
/* unused harmony export STORE_NAVIGATE */
/* unused harmony export STORE_UPDATE_INDEX */
/* unused harmony export STORE_HEADER_INIT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return STORE_CLEAR_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return STORE_SET_LANG_PREF; });
/* unused harmony export STORE_CLEAR_CONTENT_ALL */
/* unused harmony export STORE_PARAMS_INIT */
/* unused harmony export STORE_CONTENT_HEADER_LOADER */
/* unused harmony export STORE_CONTENT_VIEWER_INIT */
/* unused harmony export STORE_SET_FRAMEWORK_CONFIG */
/* unused harmony export STORE_CONTENT_VIEWER_RESET_TIMER */
/* unused harmony export STORE_CONTENT_VIEWER_INCREMENT_TIMER */
/* unused harmony export STORE_CONTENT_VIEWER_SET_INTERVALID */
/* unused harmony export STORE_CONTENT_VIEWER_SET_VISIT_DETAILS */
/* unused harmony export STORE_CONTENT_VIEWER_SET_LAST_VISITED_DETAILS */
/* unused harmony export STORE_CONTENT_VIEWER_SET_LANGUAGE */
var STORE_LOADING = 'STORE_LOADING';
var STORE_PROFILE_USER = 'STORE_PROFILE_USER';
var STORE_PROFILE_USER_DETAILS = 'STORE_PROFILE_USER_DETAILS';
var STORE_PROFILE_USER_PHOTO = 'STORE_PROFILE_USER_PHOTO';
var STORE_PROFILE_USER_NAME = 'STORE_PROFILE_USER_NAME';
var STORE_CONFIRM_STATUS = 'STORE_CONFIRM_STATUS';
var STORE_INCREMENT = 'STORE_INCREMENT';
var STORE_DECREMENT = 'STORE_DECREMENT';
var STORE_LOGIN = 'STORE_LOGIN';
var STORE_LOGOUT = 'STORE_LOGOUT';
var STORE_CHANGE_PASSWORD = 'STORE_CHANGE_PASSWORD';
var STORE_CENTER = 'STORE_CENTER';
var STORE_SET_FULL_BANNER = 'STORE_SET_FULL_BANNER';
var STORE_HEADER = 'STORE_HEADER';
var STORE_HEADER_OBJ = 'STORE_HEADER_OBJ';
var STORE_CHILDREN_OBJ = 'STORE_CHILDREN_OBJ';
var STORE_CHILDREN = 'STORE_CHILDREN';
var STORE_ARRAY = 'STORE_ARRAY';
var STORE_NEXT = 'STORE_NEXT';
var STORE_PREVIOUS = 'STORE_PREVIOUS';
var STORE_NAVIGATE = 'STORE_NAVIGATE';
var STORE_UPDATE_INDEX = 'STORE_UPDATE_INDEX';
var STORE_HEADER_INIT = 'STORE_HEADER_INIT';
var STORE_CLEAR_ALL = 'STORE_CLEAR_ALL';
var STORE_SET_LANG_PREF = 'STORE_SET_LANG_PREF';
var STORE_CLEAR_CONTENT_ALL = 'STORE_CLEAR_CONTENT_ALL';
var STORE_PARAMS_INIT = 'STORE_PARAMS_INIT';
var STORE_CONTENT_HEADER_LOADER = 'STORE_CONTENT_HEADER_LOADER';
var STORE_CONTENT_VIEWER_INIT = 'STORE_CONTENT_VIEWER_INIT';
var STORE_SET_FRAMEWORK_CONFIG = 'STORE_SET_FRAMEWORK_CONFIG';
var STORE_CONTENT_VIEWER_RESET_TIMER = 'STORE_CONTENT_VIEWER_RESET_TIMER';
var STORE_CONTENT_VIEWER_INCREMENT_TIMER = 'STORE_CONTENT_VIEWER_INCREMENT_TIMER';
var STORE_CONTENT_VIEWER_SET_INTERVALID = 'STORE_CONTENT_VIEWER_SET_INTERVALID';
var STORE_CONTENT_VIEWER_SET_VISIT_DETAILS = 'STORE_CONTENT_VIEWER_SET_VISIT_DETAILS';
var STORE_CONTENT_VIEWER_SET_LAST_VISITED_DETAILS = 'STORE_CONTENT_VIEWER_SET_LAST_VISITED_DETAILS';
var STORE_CONTENT_VIEWER_SET_LANGUAGE = 'STORE_CONTENT_VIEWER_SET_LANGUAGE';

/***/ }),

/***/ "E/B9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mfs-footer',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "E3fr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


__WEBPACK_IMPORTED_MODULE_1_axios___default.a.default.baseURL = '';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Entry',
  data: function data() {
    return {
      agreeCondition: false,
      universityConfig: {},
      undertakingsList: [{ agree: true }],
      noOfCheckedInstructions: 0,
      instructions: {},
      agreement: []
    };
  },

  methods: {
    // This method play audio.
    playInstructionAudio: function playInstructionAudio() {
      this.$refs.instrAudioModalRef.show();
      this.$refs.audioRef.src = this.instructions.audioURL;
      this.$refs.audioRef.play();
    },

    // This method hide details audio.
    hideAudioModal: function hideAudioModal() {
      this.$refs.instrAudioModalRef.hide();
      this.$refs.audioRef.pause();
    },

    // This method play audio.
    playInstructionVideo: function playInstructionVideo() {
      this.$refs.instrVideoModalRef.show();
      this.$refs.instrVideoRef.src = this.instructions.videoURL + '?autoplay=1';
    },

    // This method hide details audio.
    hideInstructionVideoModal: function hideInstructionVideoModal() {
      this.$refs.instrVideoRef.src = this.instructions.videoURL + '?autoplay=0';
      this.$refs.instrVideoModalRef.hide();
    },
    getProjectConfig: function getProjectConfig() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('o/projectConfig/getUniversityConfig').then(function (response) {
        _this.universityConfig = response.data;
        _this.getListOfUndertakings();
      }).catch(function (e) {
        console.error(e);
      });
    },

    selectionChanged: function selectionChanged(selectedInstruction) {
      var checked = selectedInstruction.agree;
      if (checked === true) {
        this.noOfCheckedInstructions++;
        var selectedData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(selectedInstruction));
        delete selectedData.agree;
        this.agreement.push(selectedData);
      } else {
        this.noOfCheckedInstructions--;
        for (var index = 0; index < this.agreement.length; index++) {
          if (this.agreement[index].instructionId === selectedInstruction.instructionId) {
            this.agreement.splice(index, 1);
          }
        }
      }
    },
    getListOfUndertakings: function getListOfUndertakings() {
      var _this2 = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('r/candidateProfile/getAgreementUndertakings').then(function (response) {
        if (response.data !== null) {
          _this2.undertakingsList = response.data;
          _this2.getUserAgreedInstructions();
        }
      }).catch(function (e) {
        _this2.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: _this2.TOASTR_TIME
        });
        console.error(e);
      });
    },
    getInstruction: function getInstruction() {
      var _this3 = this;

      // This method get video biodata instructions.
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('r/getGeneralInstructions/' + 'CandidateAgreement').then(function (response) {
        if (response.status === 200) {
          _this3.instructions = response.data;
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    getUserAgreedInstructions: function getUserAgreedInstructions() {
      var _this4 = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('r/candidateProfile/getuseragreedinstructions/' + this.$store.state.candidateProfile.profileUser).then(function (response) {
        if (response.data !== null) {
          _this4.agreement = response.data;
          if (_this4.agreement.length > 0) {
            _this4.noOfCheckedInstructions = _this4.agreement.length;
          }
          for (var index = 0; index < _this4.agreement.length; index++) {
            for (var innerIndex = 0; innerIndex < _this4.undertakingsList.length; innerIndex++) {
              if (_this4.agreement[index].instructionId === _this4.undertakingsList[innerIndex].instructionId) {
                _this4.undertakingsList[innerIndex].agree = true;
              }
            }
          }
          _this4.undertakingsList = _this4.orderedUsers();
        }
      }).catch(function (e) {
        _this4.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: _this4.TOASTR_TIME
        });
        console.error(e);
      });
    },
    saveData: function saveData() {
      var _this5 = this;

      var self = this;
      if (this.noOfCheckedInstructions > 0) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/r/candidateProfile/saveAgreementUndertakings/' + this.$store.state.candidateProfile.profileUser, this.agreement).then(function (response) {
          if (response.data !== null && response.data === 'true') {
            _this5.$toasted.success(self.$t('toastr.toastrIntrustionsSaved'), {
              theme: 'bubble',
              duration: _this5.TOASTR_TIME
            });
            _this5.$router.push('itCertification');
          } else {
            _this5.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
              theme: 'bubble',
              duration: _this5.TOASTR_TIME
            });
          }
        }).catch(function (e) {
          _this5.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
            theme: 'bubble',
            duration: _this5.TOASTR_TIME
          });
          console.error(e);
        });
      } else {
        this.$toasted.error(self.$t('entry.toastrSelectAtLeastOne'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        });
      }
    },
    orderedUsers: function orderedUsers() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(this.undertakingsList, 'sequence');
    }
  },
  mounted: function mounted() {
    if (this.$store.state.user.userDetails.confirmStatus) {
      this.$router.push({ name: 'entry' });
    } else {
      this.getProjectConfig();
      this.getInstruction();
    }
  }
});

/***/ }),

/***/ "EV1k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__("broi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_535c75df_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__("eXtr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("rb2e")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_535c75df_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_535c75df_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FiF/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid signup",staticStyle:{"background":"url('static/assets/images/login/bg1.jpg')"}},[_c('div',{staticClass:"row "},[_c('div',{staticClass:"col-sm-5 signup-box align-self-center"},[_c('div',{staticClass:"row align-content-center no-gutters"},[_vm._m(0),_vm._v(" "),(_vm.currentServerDate.getTime() > _vm.applicationEndDate.getTime() || _vm.currentServerDate.getTime() < _vm.applicationStartDate.getTime())?_c('div',{staticClass:"text-left mt-4"},[(_vm.currentServerDate.getTime() < _vm.applicationStartDate.getTime())?_c('h5',{staticClass:"alert alert-success"},[_vm._v(" "+_vm._s(_vm.$t('registration.lblStartReg'))+" "),_c('b',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.applicationStartDate)))])]):_vm._e(),_vm._v(" "),(_vm.currentServerDate.getTime() > _vm.applicationEndDate.getTime())?_c('h5',{staticClass:"alert alert-danger"},[_vm._v(_vm._s(_vm.$t('registration.lblEndReg'))+" "),_c('b',[_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.applicationEndDate)))])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-default mt-4",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.$t('registration.buttonType.cancel')))])]):_c('div',{staticClass:"col-sm-12"},[_c('form',{attrs:{"data-vv-scope":"signUpForm","novalidate":""}},[_c('div',{staticClass:"form-group custom-form"},[_c('label',[_vm._v(_vm._s(_vm.$t('registration.fullName')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|alpha_spaces'),expression:"'required|alpha_spaces'"},{name:"model",rawName:"v-model",value:(_vm.signUpForm.personalDetails.fullName),expression:"signUpForm.personalDetails.fullName"}],ref:"txt_fullname",staticClass:"form-control",class:{'uppercase': _vm.signUpForm.personalDetails.fullName,  'input' : true, 'is-success': !_vm.errors.has('signUpForm.fullName')},attrs:{"disabled":_vm.otpResent,"type":"text","name":"fullName","placeholder":_vm.$t('registration.placeholder.fullname')},domProps:{"value":(_vm.signUpForm.personalDetails.fullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.signUpForm.personalDetails.fullName=$event.target.value}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signUpForm.fullName')),expression:"errors.has('signUpForm.fullName')"}],staticClass:"red is-danger",class:{'help':!_vm.signUpForm.personalDetails.fullName, 'padbot' : _vm.signUpForm.personalDetails.fullName}},[_vm._v(_vm._s(_vm.errors.first('signUpForm.fullName')))])]),_vm._v(" "),_c('div',{staticClass:"form-group custom-form"},[_c('label',[_vm._v(_vm._s(_vm.$t('registration.email')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"},{name:"model",rawName:"v-model",value:(_vm.signUpForm.userName),expression:"signUpForm.userName"}],staticClass:"form-control",class:{'lowercase': _vm.signUpForm.userName,'input' : true, 'is-success': !_vm.errors.has('signUpForm.email')&& _vm.isUsernameAvailable},attrs:{"disabled":_vm.otpResent,"type":"signUpForm","name":"email","placeholder":_vm.$t('registration.placeholder.email')},domProps:{"value":(_vm.signUpForm.userName)},on:{"focusout":_vm.checkUsernameAvailability,"input":[function($event){if($event.target.composing){ return; }_vm.signUpForm.userName=$event.target.value},function($event){_vm.signUpForm.userName = $event.target.value.toLowerCase()}]}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signUpForm.email')),expression:"errors.has('signUpForm.email')"}],staticClass:"red help is-danger"},[_vm._v(_vm._s(_vm.errors.first('signUpForm.email')))])]),_vm._v(" "),(!_vm.otpResent)?_c('div',{staticClass:"form-group custom-form"},[_c('label',[_vm._v(_vm._s(_vm.$t('registration.confirmEmail')))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"},{name:"model",rawName:"v-model",value:(_vm.confirmEmail),expression:"confirmEmail"}],staticClass:"form-control",class:{'lowercase': _vm.signUpForm.confirmEmail,'input' : true, 'is-success': !_vm.errors.has('signUpForm.confirm email')&& _vm.isUsernameAvailable},attrs:{"disabled":_vm.otpResent,"type":"signUpForm","name":"confirm email","placeholder":_vm.$t('registration.placeholder.confirmEmail')},domProps:{"value":(_vm.confirmEmail)},on:{"focusout":_vm.validateEmail,"input":[function($event){if($event.target.composing){ return; }_vm.confirmEmail=$event.target.value},function($event){_vm.confirmEmail = $event.target.value.toLowerCase()}],"paste":_vm.pasteValue}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signUpForm.confirm email')),expression:"errors.has('signUpForm.confirm email')"}],staticClass:"red help is-danger"},[_vm._v(_vm._s(_vm.errors.first('signUpForm.confirm email')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group custom-form"},[_c('label',[_vm._v(_vm._s(_vm.$t('registration.password')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.signUpForm.password),expression:"signUpForm.password"}],staticClass:"form-control",class:{'input': true},attrs:{"disabled":_vm.otpResent,"id":"txt_password","type":"password","name":"password","placeholder":_vm.$t('registration.placeholder.password')},domProps:{"value":(_vm.signUpForm.password)},on:{"keypress":_vm.passwordChanged,"input":function($event){if($event.target.composing){ return; }_vm.signUpForm.password=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"pcss input-group-addon"},[(!_vm.isShowPass)?_c('span',{attrs:{"title":"Show Password"},on:{"click":_vm.showHidePassword}},[_c('i',{staticClass:"mdi mdi-eye-off"})]):_vm._e(),_vm._v(" "),(_vm.isShowPass)?_c('span',{attrs:{"title":"Hide Password"},on:{"click":_vm.showHidePassword}},[_c('i',{staticClass:"mdi mdi-eye"})]):_vm._e()])]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(!_vm.errors.has('signUpForm.password')),expression:"!errors.has('signUpForm.password')"}],staticClass:"help",attrs:{"id":"strength"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signUpForm.password')),expression:"errors.has('signUpForm.password')"}],staticClass:"red help is-danger"},[_vm._v(" "+_vm._s(_vm.errors.first('signUpForm.password')))])]),_vm._v(" "),_c('div',{staticClass:"form-group custom-form"},[_c('label',[_vm._v(_vm._s(_vm.$t('registration.mobile')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|regex:^([0-9]{10})$|numeric'),expression:"'required|regex:^([0-9]{10})$|numeric'"},{name:"model",rawName:"v-model",value:(_vm.signUpForm.contactDetails.phoneNo),expression:"signUpForm.contactDetails.phoneNo"}],staticClass:"form-control mr-3",attrs:{"max":"10","maxlength":"10","oninput":"this.value=this.value.slice(0,this.maxLength||1/1);this.value=(this.value   < 0) ? (1/1) : this.value;","type":"number","id":"txt_mobNo","name":"mobile","placeholder":_vm.$t('registration.placeholder.mobile')},domProps:{"value":(_vm.signUpForm.contactDetails.phoneNo)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }_vm.trigger($event)},"focusout":_vm.mobileNoChanged,"input":function($event){if($event.target.composing){ return; }_vm.signUpForm.contactDetails.phoneNo=$event.target.value}}}),_vm._v(" "),(!_vm.otpResent)?_c('input',{staticClass:"btn btn-default-alt input-group-addon",attrs:{"type":"button","id":"sendOtpButton","disabled":_vm.otpSent,"value":_vm.$t('registration.buttonType.sendOTP')},on:{"click":_vm.sendOTP}}):_vm._e(),_vm._v(" "),(_vm.otpResent)?_c('input',{staticClass:"btn btn-default-alt input-group-addon",attrs:{"type":"button","id":"resendButton","disabled":_vm.otpSent,"value":_vm.$t('registration.buttonType.resendOTP')},on:{"click":_vm.sendOTP}}):_vm._e()]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signUpForm.mobile')),expression:"errors.has('signUpForm.mobile')"}],staticClass:"red help is-danger"},[_vm._v(_vm._s(_vm.errors.first('signUpForm.mobile')))])]),_vm._v(" "),(_vm.otpSent)?_c('div',{staticClass:"form-group custom-form"},[_c('label',[_vm._v(_vm._s(_vm.$t('registration.otp')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|regex:^([0-9]{6})$|numeric'),expression:"'required|regex:^([0-9]{6})$|numeric'"},{name:"model",rawName:"v-model",value:(_vm.otp),expression:"otp"}],staticClass:"form-control mr-3",attrs:{"type":"number","name":"otp","max":"6","maxlength":"6","oninput":"this.value=this.value.slice(0,this.maxLength||1/1);this.value=(this.value   < 0) ? (1/1) : this.value;","placeholder":"Enter OTP"},domProps:{"value":(_vm.otp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.otp=$event.target.value}}}),_vm._v(" "),_c('small',{staticClass:"green"},[_c('i',[_vm._v(_vm._s(_vm.$t('registration.otpResendNote')))]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signUpForm.otp')),expression:"errors.has('signUpForm.otp')"}],staticClass:"red help is-danger"},[_vm._v(_vm._s(_vm.errors.first('signUpForm.otp')))])]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-orange mt-2",attrs:{"type":"button","disabled":!_vm.otpSent,"id":"registerButton"},on:{"click":_vm.verifyOTP}},[_vm._v(_vm._s(_vm.$t('registration.buttonType.register')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-default mt-2",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.$t('registration.buttonType.cancel')))])])])]),_vm._v(" "),_c('div',{staticClass:"logo-box"},[_c('img',{staticClass:"mkcl-logo",attrs:{"src":"static/assets/images/logo_mkcl-s.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"mkcl-logo right",attrs:{"src":_vm.getLogoUrl(_vm.universityConfig.abbr),"alt":""}})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-heading"},[_c('img',{staticClass:"login-logo",attrs:{"src":"static/assets/images/mfs-logo.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',[_c('i',{attrs:{"id":"demo"}},[_vm._v("00.00s")])])}]


/***/ }),

/***/ "I5Xq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'
// import { mixin as onClickOutside } from 'vue-on-click-outside'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'language',
  // mixins: [onClickOutside],
  components: {},
  data: function data() {
    return {};
  },

  methods: {
    changelang: function changelang(opt) {
      this.$i18n.set(opt);
    }
  },
  created: function created() {
    this.changelang(this.$store.state.login.user.langPref);
  }
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_content__ = __webpack_require__("61xj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_login__ = __webpack_require__("jeSg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_candidateProfile__ = __webpack_require__("3rUF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_user__ = __webpack_require__("bREw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex_persistedstate__ = __webpack_require__("qQWK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex_persistedstate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuex_persistedstate__);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  modules: {
    content: __WEBPACK_IMPORTED_MODULE_4__modules_content__["a" /* default */],
    login: __WEBPACK_IMPORTED_MODULE_5__modules_login__["a" /* default */],
    candidateProfile: __WEBPACK_IMPORTED_MODULE_6__modules_candidateProfile__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_7__modules_user__["a" /* default */]
  },
  strict: debug,
  plugins: [__WEBPACK_IMPORTED_MODULE_8_vuex_persistedstate___default()({ storage: window.sessionStorage })]
}));

/***/ }),

/***/ "IoCR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_video_player__ = __webpack_require__("iqGf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_video_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_video_player__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'videoUpload',
  components: { videoPlayer: __WEBPACK_IMPORTED_MODULE_0_vue_video_player__["videoPlayer"] },
  data: function data() {
    return {
      playerOptions: {
        // videojs options
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: 'video/mp4',
          src: 'http://staging-applymfs.mkcl.org/cdn/ERA/data/MFSFramework/data/2018/documents/videoBioData/hiteshb@mkcl.org/1527837986662hiteshb@mkcl.org_Q1_videoBioData.mp4'
        }],
        poster: '/static/images/author.jpg'
      }
    };
  },
  mounted: function mounted() {
    console.log('this is current player instance object', __WEBPACK_IMPORTED_MODULE_0_vue_video_player__["videoPlayer"]);
  },

  computed: {
    player: function player() {
      return this.$refs.videoPlayer.player;
    }
  },
  methods: {
    // listen event
    onPlayerPlay: function onPlayerPlay(player) {
      // console.log('player play!', player)
    },
    onPlayerPause: function onPlayerPause(player) {
      // console.log('player pause!', player)
    },

    // ...player event
    // or listen state event
    playerStateChanged: function playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },

    // player is ready
    playerReadied: function playerReadied(player) {
      console.log('the player is readied', player);
      // you can use it to do something...
      // player.[methods]
    }
  }
});

/***/ }),

/***/ "J+zz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{attrs:{"id":"footer"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"text-center copyright"},[_c('img',{attrs:{"src":"static/assets/images/logo_mkcl.png","alt":"MKCL"}}),_vm._v(" "),_c('span',[_vm._v("© "+_vm._s(_vm.$t(_vm.footerBar.lblOrgnization)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(_vm.footerBar.lblPowerdBy)))])])])])}
var staticRenderFns = []


/***/ }),

/***/ "JfE9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K0Fx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kguq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_modal_vue__ = __webpack_require__("yN8m");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_0_axios___default.a.default.baseURL = '';
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Entry',
  components: { modal: __WEBPACK_IMPORTED_MODULE_1__components_common_modal_vue__["a" /* default */] },
  data: function data() {
    return {
      universityConfig: {},
      isApplicationCompleted: false,
      showConfirmation: false,
      checkedTermCondition: false,
      instructions: {}
    };
  },

  methods: {
    fetchUserDetails: function fetchUserDetails() {
      var _this = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/r/entry/getUserApplicationStatus/' + self.$store.state.candidateProfile.profileUser).then(function (response) {
        if (response.data !== null) {
          self.isApplicationCompleted = response.data.appStatus;
          var profileStatus = response.data.profileStatus;
          var confStatus = response.data.confStatus;
          if (profileStatus.termConditionDetails) {
            if (confStatus) {
              self.$store.commit('STORE_CONFIRM_STATUS', true);
            }
            if (self.isApplicationCompleted === true) {
              // replace below line with redirection
              window.MKCLAPI.switchAppWithSingleSignOn(self.MFS_CLIENT_ID);
            } else {
              if (confStatus) {
                self.$router.push({ name: 'candidateApplication' });
              } else if (!profileStatus.itCertificationsDetails) {
                self.$router.push({ name: 'agreement' });
              } else if (!profileStatus.personalDetails) {
                self.$router.push({ name: 'personalDetails' });
              } else if (!profileStatus.contactDetails) {
                self.$router.push({ name: 'address' });
              } else if (!profileStatus.educationDetails) {
                self.$router.push({ name: 'educationalDetails' });
              } else if (!profileStatus.documentDetails) {
                self.$router.push({ name: 'documentsupload' });
              } else if (!profileStatus.qualificationDetails) {
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('r/projectConfig/getAllProjectConfig').then(function (responses) {
                  if (responses.data.ocrConfig.required) {
                    self.$router.push({ name: 'imageExtracter' });
                  } else {
                    self.$router.push({ name: 'qualificationDetails' });
                  }
                }).catch(function (e) {
                  console.log(e);
                });
              } else if (profileStatus.qualificationDetails) {
                self.$router.push({ name: 'profileSummary' });
              } else {
                self.$router.push({ name: 'agreement' });
              }
            }
          } else {
            _this.getTermCondition();
          }
        }
      }).catch(function (e) {
        console.error(e);
      });
    },
    saveTermCondition: function saveTermCondition() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('r/candidateProfile/saveTermConditionStatus/' + this.$store.state.candidateProfile.profileUser).then(function (response) {
        if (response.data) {
          _this2.showConfirmation = false;
          _this2.$toasted.success(_this2.$t('toastr.toastrTermConditionSaved'));
          _this2.fetchUserDetails();
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    getTermCondition: function getTermCondition() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('r/getGeneralInstructions/' + 'TermCondition').then(function (responses) {
        if (responses.status === 200) {
          _this3.instructions = responses.data;
          _this3.showConfirmation = true;
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    getProjectConfig: function getProjectConfig() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('o/projectConfig/getUniversityConfig').then(function (response) {
        _this4.universityConfig = response.data;
      }).catch(function (e) {
        console.error(e);
      });
    }
  },
  created: function created() {
    var token = window.MKCLAPI.getDecodedToken();
    this.$store.commit('STORE_PROFILE_USER', token.username);
  },
  mounted: function mounted() {
    this.fetchUserDetails();
    this.getProjectConfig();
  }
});

/***/ }),

/***/ "L9rW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav',{staticClass:"lang-user-wrapper text-center",attrs:{"is-nav-bar":""}},[_c('b-nav-item-dropdown',{staticClass:"lang-wrapper",attrs:{"text":this.$i18n.locale()==='en'?'English':this.$i18n.locale()==='hi'?'हिन्दी':'मराठी'}},[_c('b-dropdown-item',{class:{onn: this.$i18n.locale()==='en'?true:false},attrs:{"id":"chnglangbtn1","name":"chnglangbtn1name"},on:{"click":function($event){_vm.changelang('en')}}},[_vm._v("English")]),_vm._v(" "),_c('b-dropdown-item',{class:{onn: this.$i18n.locale()==='hi'?true:false},attrs:{"id":"chnglangbtn2","name":"chnglangbtn2name"},on:{"click":function($event){_vm.changelang('hi')}}},[_vm._v("हिन्दी")]),_vm._v(" "),_c('b-dropdown-item',{class:{onn: this.$i18n.locale()==='mr'?true:false},attrs:{"id":"chnglangbtn3","name":"chnglangbtn3name"},on:{"click":function($event){_vm.changelang('mr')}}},[_vm._v("मराठी")])],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "LR9A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Address',
  components: {},
  data: function data() {
    return {
      contactDetails: { corespondeneceAddress: {}, permanentAddress: {} },
      aadhaarPin: '',
      permanentPinVerified: false,
      correspondancePinVerified: false,
      correspondanceTehsilPinObj: null,
      permanentTehsilPinObj: null,
      uniqueCorrespondanceAddressList: [],
      uniquePermanentAddressList: [],
      showCorrespondenceTalukaList: false,
      showPermanentTalukaList: false,
      disableEmail: false,
      disableMobile: false
    };
  },

  methods: {
    fetchUserDetails: function fetchUserDetails() {
      var _this = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/r/entry/getUserApplicationStatus/' + this.$store.state.candidateProfile.profileUser).then(function (response) {
        if (response.data !== null) {
          var profileStatus = response.data.profileStatus;
          if (!profileStatus.personalDetails) {
            _this.$router.push({ name: 'personalDetails' });
          } else if (!profileStatus.contactDetails) {
            _this.$router.push({ name: 'address' });
          } else if (!profileStatus.educationDetails) {
            _this.$router.push({ name: 'educationalDetails' });
          } else if (!profileStatus.documentDetails) {
            _this.$router.push({ name: 'documentsupload' });
          } else if (!profileStatus.qualificationDetails) {
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('r/projectConfig/getAllProjectConfig').then(function (responses) {
              if (responses.data.ocrConfig.required) {
                _this.$router.push({ name: 'imageExtracter' });
              } else {
                _this.$router.push({ name: 'qualificationDetails' });
              }
            }).catch(function (e) {
              console.log(e);
            });
          } else {
            _this.$router.push({ name: 'profileSummary' });
          }
        }
      }).catch(function (e) {
        _this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: _this.TOASTR_TIME
        });
        console.error(e);
      });
    },
    nextTabFunc: function nextTabFunc() {
      this.validateInput();
    },
    prevTabFunc: function prevTabFunc() {
      this.$router.push('personalDetails');
    },
    pinCodeChanged: function pinCodeChanged(pincode, addressType) {
      var _this2 = this;

      if (addressType === 'Correspondence') {
        this.correspondancePinVerified = false;
        this.showCorrespondenceTalukaList = false;
      } else {
        this.permanentPinVerified = false;
        this.showPermanentTalukaList = false;
      }
      var self = this;
      if (pincode.length === 6) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('r/candidateProfile/getAddressByPincode/' + pincode).then(function (Response) {
          var responseData = Response.data;
          if (responseData.length === 0 && addressType === 'Correspondence') {
            _this2.$toasted.error(self.$t('candidateProfile.profileSummary.toastrcorrespondancePinCodeNotFound'), {
              theme: 'bubble',
              duration: _this2.TOASTR_TIME
            });
            return false;
          } else if (responseData.length === 0 && addressType === 'Permanent') {
            _this2.$toasted.error(self.$t('candidateProfile.profileSummary.toastrPermanentPinCodeNotFound'), {
              theme: 'bubble',
              duration: _this2.TOASTR_TIME
            });
            return false;
          }
          if (addressType === 'Correspondence') {
            if (responseData.length === 1) {
              _this2.showCorrespondenceTalukaList = false;
              _this2.correspondanceTehsilPinObj = null;
              _this2.contactDetails.corespondeneceAddress.tehsil = responseData[0].tehsil;
              _this2.contactDetails.corespondeneceAddress.district = responseData[0].district;
              _this2.contactDetails.corespondeneceAddress.state = responseData[0].state;
            } else {
              _this2.showCorrespondenceTalukaList = true;
              _this2.uniqueCorrespondanceAddressList = responseData;
            }
          } else {
            if (responseData.length === 1) {
              _this2.showPermanentTalukaList = false;
              _this2.permanentTehsilPinObj = null;
              _this2.contactDetails.permanentAddress.tehsil = responseData[0].tehsil;
              _this2.contactDetails.permanentAddress.district = responseData[0].district;
              _this2.contactDetails.permanentAddress.state = responseData[0].state;
            } else {
              _this2.showPermanentTalukaList = true;
              _this2.uniquePermanentAddressList = responseData;
            }
          }
        }).catch(function (e) {
          console.error(e);
          _this2.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
            theme: 'bubble',
            duration: _this2.TOASTR_TIME
          });
        });
      }
    },
    getData: function getData() {
      var _this3 = this;

      var self = this;
      var userName = this.$store.state.candidateProfile.profileUser;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('r/candidateProfile/getContactDetails/' + userName).then(function (Response) {
        _this3.candidateProfile = Response.data;
        _this3.contactDetails = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.candidateProfile.contactDetails));
        if (_this3.contactDetails.phoneNo) {
          _this3.disableMobile = true;
        }
        if (_this3.contactDetails.email) {
          _this3.disableEmail = true;
        }
        if (_this3.candidateProfile.aadhaarVerified === true) {
          _this3.aadhaarPin = _this3.candidateProfile.contactDetails.permanentPin;
        }
        if (_this3.contactDetails.corespondeneceAddress !== undefined && _this3.contactDetails.corespondeneceAddress !== null && _this3.contactDetails.corespondeneceAddress.tehsil !== '') {
          _this3.correspondanceTehsilPinObj = {};
          _this3.correspondanceTehsilPinObj.tehsil = _this3.contactDetails.corespondeneceAddress.tehsil;
          _this3.correspondanceTehsilPinObj.district = _this3.contactDetails.corespondeneceAddress.district;
          _this3.correspondanceTehsilPinObj.state = _this3.contactDetails.corespondeneceAddress.state;
          _this3.correspondanceTehsilPinObj.displayField = _this3.contactDetails.corespondeneceAddress.tehsil + '-' + _this3.contactDetails.corespondeneceAddress.district + '-' + _this3.contactDetails.corespondeneceAddress.state;
        }
        if (_this3.contactDetails.permanentAddress !== undefined && _this3.contactDetails.permanentAddress !== null && _this3.contactDetails.permanentAddress.tehsil !== '') {
          _this3.permanentTehsilPinObj = {};
          _this3.permanentTehsilPinObj.tehsil = _this3.contactDetails.permanentAddress.tehsil;
          _this3.permanentTehsilPinObj.district = _this3.contactDetails.permanentAddress.district;
          _this3.permanentTehsilPinObj.state = _this3.contactDetails.permanentAddress.state;
          _this3.permanentTehsilPinObj.displayField = _this3.contactDetails.permanentAddress.tehsil + '-' + _this3.contactDetails.permanentAddress.district + '-' + _this3.contactDetails.permanentAddress.state;
        }
        _this3.pinCodeChanged(_this3.contactDetails.corespondenecePin, 'Correspondence');
        _this3.pinCodeChanged(_this3.contactDetails.permanentPin, 'Permanent');
        _this3.correspondancePinVerified = true;
        _this3.permanentPinVerified = true;
      }).catch(function (e) {
        console.error(e);
        _this3.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: _this3.TOASTR_TIME
        });
      });
    },
    validate: function validate() {
      this.$validator.validate();
      alert('Inside Validate');
    },

    // save contact details
    validateInput: function validateInput(scope) {
      var _this4 = this;

      var self = this;
      return this.$validator.validate().then(function (result) {
        if (result) {
          return _this4.validatePinCode(_this4.contactDetails.corespondenecePin);
        } else {
          _this4.$validator.validate('Contactform.Correspondence Address PIN', _this4.contactDetails.corespondenecePin).then(function (result) {
            if (!result) {
              if (_this4.contactDetails.corespondenecePin === '') {
                _this4.$toasted.error(self.$t('candidateProfile.contactDetails.toastrEnterCorrespondanceAddress'), {
                  theme: 'bubble',
                  duration: _this4.TOASTR_TIME
                });
              } else {
                _this4.$toasted.error(self.$t('candidateProfile.contactDetails.toastrCorrespondancePinDigits'), {
                  theme: 'bubble',
                  duration: _this4.TOASTR_TIME
                });
              }
            }
          });
          _this4.$validator.validate('Contactform.Permanent Address PIN', _this4.contactDetails.permanentPin).then(function (result) {
            if (!result) {
              if (_this4.contactDetails.permanentPin === '') {
                _this4.$toasted.error(self.$t('candidateProfile.contactDetails.toastrEnterPermanentAddress'), {
                  theme: 'bubble',
                  duration: _this4.TOASTR_TIME
                });
              } else {
                _this4.$toasted.error(self.$t('candidateProfile.contactDetails.toastrPermanentPinDigits'), {
                  theme: 'bubble',
                  duration: _this4.TOASTR_TIME
                });
              }
            }
          });
          _this4.$validator.validate('Contactform.email', _this4.contactDetails.email).then(function (result) {
            if (!result) {
              if (_this4.contactDetails.email === '') {
                _this4.$toasted.error(self.$t('candidateProfile.contactDetails.toastrEnterEmailID'), {
                  theme: 'bubble',
                  duration: _this4.TOASTR_TIME
                });
              } else {
                _this4.$toasted.error(self.$t('candidateProfile.contactDetails.toastrInvalidEmailID'), {
                  theme: 'bubble',
                  duration: _this4.TOASTR_TIME
                });
              }
            }
          });
          _this4.$validator.validate('Contactform.mobile', _this4.contactDetails.phoneNo).then(function (result) {
            if (!result) {
              if (_this4.contactDetails.phoneNo === '') {
                _this4.$toasted.error(self.$t('candidateProfile.contactDetails.toastrEnterMobileNumber'), {
                  theme: 'bubble',
                  duration: _this4.TOASTR_TIME
                });
              } else {
                _this4.$toasted.error(self.$t('candidateProfile.contactDetails.toastrMobileNumberDigits'), {
                  theme: 'bubble',
                  duration: _this4.TOASTR_TIME
                });
              }
            }
          });
          if (_this4.showCorrespondenceTalukaList) {
            _this4.$validator.validate('correspondanceTehsil', _this4.correspondanceTehsilPinObj).then(function (result) {
              if (!result) {
                _this4.$toasted.error(self.$t('candidateProfile.contactDetails.toastrSelectCorrespondanceTehsil'), {
                  theme: 'bubble',
                  duration: _this4.TOASTR_TIME
                });
              }
            });
          }
          if (_this4.showPermanentTalukaList) {
            _this4.$validator.validate('tehsil', _this4.permanentTehsilPinObj).then(function (result) {
              if (!result) {
                _this4.$toasted.error(self.$t('candidateProfile.contactDetails.toastrSelectPermanentTehsil'), {
                  theme: 'bubble',
                  duration: _this4.TOASTR_TIME
                });
              }
            });
          }
          return false;
        }
      }).catch(function (e) {
        console.error(e);
        _this4.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: _this4.TOASTR_TIME
        });
        return false;
      });
    },

    saveContactDetails: function saveContactDetails() {
      var _this5 = this;

      if (this.correspondanceTehsilPinObj !== null) {
        this.contactDetails.corespondeneceAddress.tehsil = this.correspondanceTehsilPinObj.tehsil;
        this.contactDetails.corespondeneceAddress.district = this.correspondanceTehsilPinObj.district;
        this.contactDetails.corespondeneceAddress.state = this.correspondanceTehsilPinObj.state;
      }
      if (this.permanentTehsilPinObj !== null) {
        this.contactDetails.permanentAddress.tehsil = this.permanentTehsilPinObj.tehsil;
        this.contactDetails.permanentAddress.district = this.permanentTehsilPinObj.district;
        this.contactDetails.permanentAddress.state = this.permanentTehsilPinObj.state;
      }
      if (this.aadhaarPin !== null && this.aadhaarPin !== '' && this.aadhaarPin !== this.contactDetails.permanentPin) {
        this.candidateProfile.aadhaarVerified = false;
        this.candidateProfile.contactDetails = this.contactDetails;
      } else {
        this.candidateProfile.contactDetails = this.contactDetails;
      }
      if (this.candidateProfile.contactDetails.skypeId !== undefined && this.candidateProfile.contactDetails.skypeId !== null) {
        this.candidateProfile.contactDetails.skypeId = this.candidateProfile.contactDetails.skypeId.trim();
      }
      var self = this;
      if (this.contactDetails.corespondeneceAddress.tehsil === undefined || this.contactDetails.corespondeneceAddress.tehsil === null || this.contactDetails.corespondeneceAddress.tehsil === '') {
        this.$toasted.error(self.$t('candidateProfile.contactDetails.toastrSelectCorrespondanceTehsil'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        });
        return false;
      }
      if (this.contactDetails.permanentAddress.tehsil === undefined || this.contactDetails.permanentAddress.tehsil === null || this.contactDetails.permanentAddress.tehsil === '') {
        this.$toasted.error(self.$t('candidateProfile.contactDetails.toastrSelectPermanentTehsil'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        });
        return false;
      }

      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('r/candidateProfile/updateContactDetails/' + this.$store.state.candidateProfile.profileUser, this.candidateProfile).then(function (response) {
        if (response.status === 200) {
          _this5.$toasted.success(self.$t('toastr.toastrContactDetailsSaved'), {
            theme: 'bubble',
            duration: _this5.TOASTR_TIME
          });
          // this.$router.push('educationalDetails')
          _this5.fetchUserDetails();
          return true;
        }
      }).catch(function (e) {
        console.error(e);
        _this5.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: _this5.TOASTR_TIME
        });
        return false;
      });
    },
    validatePinCode: function validatePinCode(pincode) {
      var _this6 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/r/candidateProfile/verifyPincode/' + pincode).then(function (response) {
        if (response.data !== null && response.data !== 'false') {
          if (_this6.contactDetails.corespondenecePin === pincode) {
            _this6.correspondancePinVerified = true;
            if (_this6.contactDetails.corespondenecePin === _this6.contactDetails.permanentPin) {
              _this6.permanentPinVerified = true;
            } else {
              if (!_this6.permanentPinVerified) {
                return _this6.validatePinCode(_this6.contactDetails.permanentPin);
              }
            }
          } else if (_this6.contactDetails.permanentPin === pincode) {
            _this6.permanentPinVerified = true;
          }
          if (_this6.correspondancePinVerified && _this6.permanentPinVerified) {
            return _this6.saveContactDetails();
          }
        } else {
          if (_this6.contactDetails.corespondenecePin === pincode) {
            _this6.$toasted.error(self.$t('candidateProfile.profileSummary.toastrcorrespondancePinCodeNotFound'), {
              theme: 'bubble',
              duration: _this6.TOASTR_TIME
            });
          } else if (_this6.contactDetails.permanentPin === pincode) {
            _this6.$toasted.error(self.$t('candidateProfile.profileSummary.toastrPermanentPinCodeNotFound'), {
              theme: 'bubble',
              duration: _this6.TOASTR_TIME
            });
          }
          return false;
        }
      }).catch(function (e) {
        _this6.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: _this6.TOASTR_TIME
        });
        console.error(e);
        return false;
      });
    }
  },
  created: function created() {
    if (this.$store.state.user.userDetails.confirmStatus) {
      this.$router.push({ name: 'entry' });
    } else {
      this.getData();
    }
  }
});

/***/ }),

/***/ "LRRy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_datepicker2__ = __webpack_require__("ipUw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DiplomaDetails',
  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_0_vue_datepicker2__["a" /* default */]
  },
  data: function data() {
    return {
      startTime: '',
      educationDetails: {},
      selectedBoard: null,
      boardList: [],
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'DD/MM/YYYY',
        placeholder: 'Select Date Of Birth',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          border: '2px solid #fff',
          'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
          'border-radius': '2px',
          color: '#5F5F5F'
        }
      },
      limit: [{
        type: 'fromto',
        from: '1960-02-01',
        to: '2018-02-23'
      }]
    };
  },

  methods: {
    getBoardDetails: function getBoardDetails() {
      var self = this;
      console.log('get board details');
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('r/candidateProfile/getBoardDetails').then(function (response) {
        if (response.status === 200) {
          self.boardList = response.data;
          self.getUserDiplomaDetails();
          // self.certificationList.push(self.defaultObj)
        }
      }).catch(function () {
        self.$toasted.error(self.$t('candidateProfile.certification.toastrErrorFetchingCertificationList'), {
          theme: 'bubble',
          duration: 2000
        });
      });
    },
    getUserDiplomaDetails: function getUserDiplomaDetails() {
      var self = this;
      var profileUser = this.$store.state.candidateProfile.profileUser;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('r/candidateProfile/getDiplomaDetails/' + profileUser).then(function (response) {
        if (response.status === 200) {
          self.educationDetails = response.data;
          for (var i in self.boardList) {
            if (self.boardList[i].boardName === self.educationDetails.board) {
              self.selectedBoard = self.boardList[i];
            }
          }
          if (self.educationDetails.dateOfResult !== undefined && self.educationDetails.dateOfResult !== null && self.educationDetails.dateOfResult !== '') {
            console.log(self.educationDetails.dateOfResult);
            var parts = self.educationDetails.dateOfResult.split('/');
            self.startTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(String(new Date(parts[2], parts[1] - 1, parts[0]))).format('DD/MM/YYYY');
          }
          // self.certificationList.push(self.defaultObj)
        }
      }).catch(function () {
        /*  self.$toasted.error(self.$t('candidateProfile.certification.toastrErrorFetchingCertificationList'), {
           theme: 'bubble',
           duration: 2000
         }) */
      });
    },
    saveDiplomaDetails: function saveDiplomaDetails() {
      var _this = this;

      var profileUser = this.$store.state.candidateProfile.profileUser;
      this.$validator.validate().then(function (result) {
        if (result) {
          _this.educationDetails.board = _this.selectedBoard.boardName;
          _this.educationDetails.dateOfResult = __WEBPACK_IMPORTED_MODULE_2_moment___default()(String(_this.startTime)).format('DD/MM/YYYY');
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('r/candidateProfile/saveDiplomaDetails/' + profileUser, _this.educationDetails).then(function (response) {
            if (response.status === 200) {
              _this.$toasted.success('Diploma Details Save Successfuly', {
                theme: 'bubble',
                duration: 2000
              });
              return true;
            }
          }).catch(function (e) {
            console.log(e);
            return false;
          });
        } else {
          _this.$toasted.error('Please Enter Required data', {
            theme: 'bubble',
            duration: 2000
          });
        }
      }).catch(function (e) {
        _this.$toasted.error('Oops Something goes wrong', {
          theme: 'bubble',
          duration: 2000
        });
      });
    }
  },
  created: function created() {
    this.getBoardDetails();
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ea80aec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("DcXO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("qFyN")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ea80aec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ea80aec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MsRS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{staticClass:"row justify-content-center p-details",attrs:{"action":"POST","data-vv-scope":"form-1"},on:{"submit":function($event){$event.preventDefault();_vm.save('form-1')}}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group custom-input"},[_c('div',{staticClass:"para"},[_vm._v("I have completed Diploma ")]),_vm._v(" "),_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|not_in:Select'),expression:"'required|not_in:Select'"}],class:{'form-error': _vm.errors.has('board')},attrs:{"label":"boardName","options":_vm.boardList,"error-messages":_vm.errors.collect('board'),"data-vv-name":"board","name":"board","placeholder":"Select Board","required":""},model:{value:(_vm.selectedBoard),callback:function ($$v) {_vm.selectedBoard=$$v},expression:"selectedBoard"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v("On date")]),_vm._v(" "),_c('date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-error': _vm.errors.has('dateofResult'),'input': true, 'is-danger': _vm.errors.collect('dateofResult') },attrs:{"name":"dateofResult","option":_vm.option,"limit":_vm.limit,"data-vv-name":"dateofResult","data-vv-validate-on":"change"},model:{value:(_vm.startTime),callback:function ($$v) {_vm.startTime=$$v},expression:"startTime"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(" having RollNo / Seat No ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.educationDetails.seatNumber),expression:"educationDetails.seatNumber"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control-alt col-6",class:{'form-error': _vm.errors.has('form-1.Seat No'),'input': true, 'is-danger': _vm.errors.has('form-1.Seat No') },attrs:{"name":"Seat No","id":"namelc","type":"text","placeholder":"Roll/Seat No"},domProps:{"value":(_vm.educationDetails.seatNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.educationDetails.seatNumber=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(".Completed Diploma with ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.educationDetails.totalMarksObtained),expression:"educationDetails.totalMarksObtained"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control-alt",class:{'form-error': _vm.errors.has('form-1.Total Mark'),'input': true, 'is-danger': _vm.errors.has('form-1.Total Mark') },attrs:{"name":"Total Mark","id":"totalMark","type":"text","placeholder":"Mark Obtained"},domProps:{"value":(_vm.educationDetails.totalMarksObtained)},on:{"input":function($event){if($event.target.composing){ return; }_vm.educationDetails.totalMarksObtained=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v("Out of")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.educationDetails.outOf),expression:"educationDetails.outOf"}],staticClass:"form-control-alt",class:{'form-error': _vm.errors.has('form-1.Out Of'),'input': true, 'is-danger': _vm.errors.has('form-1.Out Of') },attrs:{"name":"Out Of","id":"outOf","type":"text","placeholder":"Out Of"},domProps:{"value":(_vm.educationDetails.outOf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.educationDetails.outOf=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v("Marksheet No")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.educationDetails.marksheetNo),expression:"educationDetails.marksheetNo"}],staticClass:"form-control-alt",class:{'form-error': _vm.errors.has('form-1.Marksheet No'),'input': true, 'is-danger': _vm.errors.has('form-1.Marksheet No') },attrs:{"name":"Marksheet No","id":"panNo","type":"text","placeholder":"Marksheet No"},domProps:{"value":(_vm.educationDetails.marksheetNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.educationDetails.marksheetNo=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success-alt text-center",attrs:{"type":"button"},on:{"click":_vm.saveDiplomaDetails}},[_vm._v("Save")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])}]


/***/ }),

/***/ "N8GI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-header"},[_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col-10 text-left"},[_c('h2',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t('registration.tabs.tabContactDetails')))])]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('form',{staticClass:"row justify-content-center",attrs:{"action":"POST","data-vv-scope":"Contactform"},on:{"submit":function($event){$event.preventDefault();_vm.validateInput('Contactform')}}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group custom-input"},[_c('div',{staticClass:"para"},[_vm._v(_vm._s(_vm.$t('candidateProfile.contactDetails.lblCorrespondenceAddressPIN')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contactDetails.corespondenecePin),expression:"contactDetails.corespondenecePin"},{name:"validate",rawName:"v-validate",value:('required|regex:^([0-9]{6})$|numeric'),expression:"'required|regex:^([0-9]{6})$|numeric'"}],staticClass:"form-control-alt col-2",class:{'form-error': _vm.errors.has('Contactform.Correspondence Address PIN'),'input': true, 'is-danger': _vm.errors.has('Contactform.Correspondence Address PIN') },attrs:{"max":"6","maxlength":"6","oninput":"this.value=this.value.slice(0,this.maxLength||1/1);this.value=(this.value   < 0) ? (1/1) : this.value;","name":"Correspondence Address PIN","id":"correspondence","type":"number","placeholder":_vm.$t('candidateProfile.contactDetails.plceAddressPIN')},domProps:{"value":(_vm.contactDetails.corespondenecePin)},on:{"keyup":function($event){_vm.correspondanceTehsilPinObj = null;_vm.pinCodeChanged(_vm.contactDetails.corespondenecePin,'Correspondence')},"input":function($event){if($event.target.composing){ return; }_vm.contactDetails.corespondenecePin=$event.target.value}}}),_vm._v(" "),_vm._m(1),_vm._v(" "),(_vm.showCorrespondenceTalukaList)?_c('span',[_c('div',{staticClass:"para"},[_vm._v(_vm._s(_vm.$t('candidateProfile.contactDetails.lblCorrespondancetehsilDistrictState')))]),_vm._v(" "),_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|not_in:Select'),expression:"'required|not_in:Select'"}],class:{'form-error': _vm.errors.has('correspondanceTehsil')},attrs:{"label":"displayField","options":_vm.uniqueCorrespondanceAddressList,"error-messages":_vm.errors.collect('correspondanceTehsil'),"data-vv-name":"correspondanceTehsil","name":"correspondanceTehsil","placeholder":"Tehsil-District-State","required":""},model:{value:(_vm.correspondanceTehsilPinObj),callback:function ($$v) {_vm.correspondanceTehsilPinObj=$$v},expression:"correspondanceTehsilPinObj"}}),_vm._v(" "),_vm._m(2)],1):_vm._e(),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('Contactform.Correspondence Address PIN')),expression:"errors.has('Contactform.Correspondence Address PIN')"}],staticClass:"fa fa-warning"}),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(_vm._s(_vm.$t('candidateProfile.contactDetails.lblPermanentAddressPIN')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contactDetails.permanentPin),expression:"contactDetails.permanentPin"},{name:"validate",rawName:"v-validate",value:('required|regex:^([0-9]{6})$|numeric'),expression:"'required|regex:^([0-9]{6})$|numeric'"}],staticClass:"form-control-alt col-2",class:{'form-error': _vm.errors.has('Contactform.Permanent Address PIN'),'input': true, 'is-danger': _vm.errors.has('Contactform.Permanent Address PIN') },attrs:{"max":"6","maxlength":"6","oninput":"this.value=this.value.slice(0,this.maxLength||1/1);this.value=(this.value   < 0) ? (1/1) : this.value;","name":"Permanent Address PIN","id":"permanent","type":"number","placeholder":_vm.$t('candidateProfile.contactDetails.plceAddressPIN')},domProps:{"value":(_vm.contactDetails.permanentPin)},on:{"keyup":function($event){_vm.permanentTehsilPinObj = null;_vm.pinCodeChanged(_vm.contactDetails.permanentPin,'Permanent')},"input":function($event){if($event.target.composing){ return; }_vm.contactDetails.permanentPin=$event.target.value}}}),_vm._v(" "),_vm._m(3),_vm._v(" "),(_vm.showPermanentTalukaList)?_c('span',[_c('div',{staticClass:"para"},[_vm._v(_vm._s(_vm.$t('candidateProfile.contactDetails.lblPermanenttehsilDistrictState')))]),_vm._v(" "),_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|not_in:Select'),expression:"'required|not_in:Select'"}],class:{'form-error': _vm.errors.has('tehsil')},attrs:{"label":"displayField","options":_vm.uniquePermanentAddressList,"error-messages":_vm.errors.collect('tehsil'),"data-vv-name":"tehsil","name":"tehsil","placeholder":"Tehsil-District-State","required":""},model:{value:(_vm.permanentTehsilPinObj),callback:function ($$v) {_vm.permanentTehsilPinObj=$$v},expression:"permanentTehsilPinObj"}}),_vm._v(" "),_vm._m(4)],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group custom-input"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(_vm._s(_vm.$t('candidateProfile.contactDetails.lblEmailID')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contactDetails.email),expression:"contactDetails.email"},{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"form-control-alt",class:{'form-error': _vm.errors.has('Contactform.email'),'input': true, 'is-danger': _vm.errors.has('Contactform.email') },attrs:{"name":"email","disabled":_vm.disableEmail,"id":"email","type":"text","placeholder":_vm.$t('candidateProfile.contactDetails.plceEmailID')},domProps:{"value":(_vm.contactDetails.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.contactDetails.email=$event.target.value}}}),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(_vm._s(_vm.$t('candidateProfile.contactDetails.lblMobileNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contactDetails.phoneNo),expression:"contactDetails.phoneNo"},{name:"validate",rawName:"v-validate",value:('required|regex:^([0-9]{10})$'),expression:"'required|regex:^([0-9]{10})$'"}],staticClass:"form-control-alt col-2",class:{'form-error': _vm.errors.has('Contactform.mobile'),'input': true, 'is-danger': _vm.errors.has('Contactform.mobile') },attrs:{"maxlength":"10","disabled":_vm.disableMobile,"name":"mobile","id":"mobile","type":"text","placeholder":_vm.$t('candidateProfile.contactDetails.plceMobileNumber')},domProps:{"value":(_vm.contactDetails.phoneNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.contactDetails.phoneNo=$event.target.value}}}),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('span',{staticClass:"pcss input-group-addon btn btn-sm",attrs:{"title":_vm.$t('candidateProfile.contactDetails.tooltipSkypeID')}},[_vm._v(" "+_vm._s(_vm.$t('candidateProfile.contactDetails.lblSkypeID'))+"\n            "),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contactDetails.skypeId),expression:"contactDetails.skypeId"}],staticClass:"form-control-alt",attrs:{"type":"text","id":"skype","aria-describedby":"skype","placeholder":_vm.$t('candidateProfile.contactDetails.plceSkypeID')},domProps:{"value":(_vm.contactDetails.skypeId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.contactDetails.skypeId=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:" row text-center p-3"},[_c('button',{staticClass:"btn btn btn-info-alt mr-3",attrs:{"type":"button"},on:{"click":_vm.prevTabFunc}},[_vm._v(" "+_vm._s(_vm.$t('button.back')))]),_vm._v(" "),_c('button',{staticClass:"btn btn btn-orange ml-auto",attrs:{"type":"button"},on:{"click":_vm.nextTabFunc}},[_vm._v(" "+_vm._s(_vm.$t('button.next')))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2 lighten text-right"},[_c('h2',{staticClass:"page-title"},[_vm._v("34%")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])}]


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_assets_styles_css_bootstrap_min_css__ = __webpack_require__("f5FY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_assets_styles_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_assets_styles_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_assets_plugins_materialdesignicons_css_materialdesignicons_css__ = __webpack_require__("fH4b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_assets_plugins_materialdesignicons_css_materialdesignicons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_assets_plugins_materialdesignicons_css_materialdesignicons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_assets_styles_scss_template_scss__ = __webpack_require__("/9U9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_assets_styles_scss_template_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_assets_styles_scss_template_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_simple_uploader__ = __webpack_require__("LgDO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_simple_uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_simple_uploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_vue__ = __webpack_require__("sCSS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuebar__ = __webpack_require__("CoJ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_toasted__ = __webpack_require__("IZMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_toasted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_lodash_dist_vue_lodash_min__ = __webpack_require__("NETs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_lodash_dist_vue_lodash_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_lodash_dist_vue_lodash_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vddl__ = __webpack_require__("gBx8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vddl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vddl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_mfs_server_config__ = __webpack_require__("Pu3C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_checkbox_radio__ = __webpack_require__("nnYD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_checkbox_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_checkbox_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__static_mkclLogin_js__ = __webpack_require__("fhYK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuex_i18n__ = __webpack_require__("kmDT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_qrcode_reader__ = __webpack_require__("AbOu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue2_filters__ = __webpack_require__("OjAt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__static_localization_en_json__ = __webpack_require__("3kQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__static_localization_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__static_localization_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__static_localization_mr_json__ = __webpack_require__("k1mU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__static_localization_mr_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__static_localization_mr_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__static_localization_hi_json__ = __webpack_require__("Dofa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__static_localization_hi_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__static_localization_hi_json__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


























initConfig();
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_21_vuex_i18n__["a" /* default */].plugin, __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].i18n.add('hi', __WEBPACK_IMPORTED_MODULE_26__static_localization_hi_json___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].i18n.add('en', __WEBPACK_IMPORTED_MODULE_24__static_localization_en_json___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].i18n.add('mr', __WEBPACK_IMPORTED_MODULE_25__static_localization_mr_json___default.a);

// set the start locale to use
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].i18n.set('en');
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_16_vddl___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15_vue_lodash_dist_vue_lodash_min___default.a, __WEBPACK_IMPORTED_MODULE_14_lodash___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vuebar___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_simple_uploader___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_20_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].component('v-select', __WEBPACK_IMPORTED_MODULE_13_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_18_vue_checkbox_radio___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_22_vue_qrcode_reader__["default"]);
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_23_vue2_filters___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_toasted___default.a, {
  duration: 4000,
  theme: 'bubble'
});
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].config.productionTip = false;
// window.mkclApi = mkclApi
window.MKCLAPI = __WEBPACK_IMPORTED_MODULE_19__static_mkclLogin_js__["a" /* default */];

var ENVIRONMENT = 'PROD'; // eg. PROD,DEV
var CNDHEADER = 'TNOU'; // eh. ERA,TNOU

if (ENVIRONMENT === 'PROD') {
  window.MKCLAPI.init({
    clientId: 'MFS_APPLICANT',
    mkclLoginServerURL: window.MKCL_HOST + '/ssoserver',
    mkclLoginClientURL: window.MKCL_HOST + '/sso/#/login',
    MFS_REGISTRATION_URL: window.MKCL_HOST + '/registration/'
  });
  __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].mixin({
    data: function data() {
      return {
        // Application Constants
        MFS_APPLICANT_ID: 'MFS_APPLICANT',
        MFS_CLIENT_ID: 'MFS',
        MFS_INDUSTRY_PARTNER_ID: 'MFS_INDUSTRY_PARTNER',
        MFS_ASC_ID: 'MFS_ASC',
        MFS_ADMIN_ID: 'MFS_ADMIN',
        CDN_LOAD_BALANCER_URL: window.MKCL_HOST + '/lb/',
        CDN_URL: window.MKCL_HOST + '/cdn/',
        /* CDN_BUSINESS_HEADER: 'ERA', */
        CDN_BUSINESS_HEADER: CNDHEADER,
        CDN_CLIENT_HEADER: 'MFSFramework',
        // Application URL
        /* CDN_LOAD_BALANCER_URL: 'http://applymfs.mkcl.org/lb/',
        CDN_URL: 'http://applymfs.mkcl.org/cdn/', */
        /*  CDN_LOAD_BALANCER_URL: 'http://10.2.10.42:9091/',
         CDN_URL: 'http://10.2.10.42:9090/', */
        MFS_URL: window.MKCL_HOST + '/mfs/',
        MFS_REGISTRATION_URL: window.MKCL_HOST + '/registration/#/',
        TOASTR_TIME: 4000
      };
    }
  });
} else {
  window.MKCLAPI.init({
    clientId: 'MFS_APPLICANT',
    mkclLoginServerURL: 'http://localhost:5002',
    mkclLoginClientURL: 'http://localhost:8080/#/login',
    MFS_REGISTRATION_URL: 'http://localhost:8088/#/'
  });
  __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].mixin({
    data: function data() {
      return {
        // Application Constants
        MFS_APPLICANT_ID: 'MFS_APPLICANT',
        MFS_CLIENT_ID: 'MFS',
        MFS_INDUSTRY_PARTNER_ID: 'MFS_INDUSTRY_PARTNER',
        MFS_ASC_ID: 'MFS_ASC',
        MFS_ADMIN_ID: 'MFS_ADMIN',
        // Application URL
        CDN_LOAD_BALANCER_URL: 'http://10.2.10.42:9091/',
        CDN_URL: 'http://10.2.10.42:9090/',
        CDN_BUSINESS_HEADER: 'ERA',
        CDN_CLIENT_HEADER: 'MFSFramework',
        MFS_URL: '',
        MFS_REGISTRATION_URL: 'http://localhost:8088/#/',
        TOASTR_TIME: 4000
      };
    }
  });
}

window.lcmsserver = __WEBPACK_IMPORTED_MODULE_17__components_mfs_server_config__["a" /* server */].address;
// axios.interceptors.request.use(function (config) {
//   config.headers.post['Content-Type'] = 'application/json'

//   return config
// })
// set baseUrl from app : local
__WEBPACK_IMPORTED_MODULE_9_axios___default.a.defaults.baseURL = '/mfsserver/';
// production
// axios.defaults.baseURL = 'http://localhost:3030/'

__WEBPACK_IMPORTED_MODULE_9_axios___default.a.interceptors.request.use(function (config) {
  __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].commit('STORE_LOADING', true);
  var clientId = __WEBPACK_IMPORTED_MODULE_19__static_mkclLogin_js__["a" /* default */].config.clientId;
  if (clientId != null) {
    config.headers.ClientId = clientId;
  }
  if ((config.baseURL.indexOf('mfsserver') !== -1 || config.baseURL.indexOf('ssoserver') !== -1) && (config.baseURL + config.url).indexOf('/o/') === -1) {
    var token = window.MKCLAPI.getToken(clientId);
    if (token) {
      config.headers.common['authorization'] = token;
      config.headers.post['Content-Type'] = 'application/json';
    } else {
      __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].commit('STORE_CLEAR_ALL');
      sessionStorage.removeItem('authorization');
      window.localStorage.clear();
      window.location.href = __WEBPACK_IMPORTED_MODULE_19__static_mkclLogin_js__["a" /* default */].config.MFS_REGISTRATION_URL;
      return;
    }
  }
  return config;
}, function (error) {
  __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].commit('STORE_LOADING', false);
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* axios.interceptors.response.use((response) => {
  return response
}, function (error) {
  // Do something with response error
  if (error.response.status === 401) {
    Vue.toasted.error('Your Session is Expired....Please Login Again!')
    window.MKCLAPI.deleteAllCookies()
    // router.replace('/login')
    window.location.href = MKCLAPI.config.MFS_REGISTRATION_URL
  }
  // Do something with response error
  if (error.response.status === 400) {
    window.location.href = MKCLAPI.config.MFS_REGISTRATION_URL
  }
  return Promise.reject(error)
}) */

var showToasterFlag = true;
__WEBPACK_IMPORTED_MODULE_9_axios___default.a.interceptors.response.use(function (response) {
  __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].commit('STORE_LOADING', false);
  if (response.status === 208 && showToasterFlag) {
    showToasterFlag = false;
    alert('Found another active session');
    sessionStorage.removeItem('authorization');
    window.localStorage.clear();
    window.location.href = __WEBPACK_IMPORTED_MODULE_19__static_mkclLogin_js__["a" /* default */].config.MFS_REGISTRATION_URL;
  }
  return response;
}, function (error) {
  __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].commit('STORE_LOADING', false);
  if (error.response.status === 504 && showToasterFlag) {
    showToasterFlag = false;
    __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].commit('STORE_CLEAR_ALL');
    window.MKCLAPI.deleteAllCookies();
    sessionStorage.removeItem('authorization');
    window.localStorage.clear();
    alert('It seems your server or internet connection is down.');
    window.location.href = __WEBPACK_IMPORTED_MODULE_19__static_mkclLogin_js__["a" /* default */].config.MFS_REGISTRATION_URL;
    return false;
  }
  // Do something with response error
  if ((error.response.status === 400 || error.response.status === 401) && showToasterFlag) {
    showToasterFlag = false;
    alert('Your Session is Expired....Please Login Again!!!');
    __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].commit('STORE_CLEAR_ALL');
    window.MKCLAPI.deleteAllCookies();
    sessionStorage.removeItem('authorization');
    window.localStorage.clear();
    window.location.href = __WEBPACK_IMPORTED_MODULE_19__static_mkclLogin_js__["a" /* default */].config.MFS_REGISTRATION_URL;
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* eslint-disable no-new */
var vm = new __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */]
  }
});

window.app = vm;

__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requireAuth;
  })) {
    window.MKCLAPI.isSessionPresent().then(function () {
      next();
    }).catch(function () {
      alert('Your Session is Expired....Please Login Again!!');
      __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].commit('STORE_CLEAR_ALL');
      window.MKCLAPI.deleteAllCookies();
      sessionStorage.removeItem('authorization');
      window.localStorage.clear();
      window.location.href = __WEBPACK_IMPORTED_MODULE_19__static_mkclLogin_js__["a" /* default */].config.MFS_REGISTRATION_URL;
    });
  } else {
    next();
  }
});

function initConfig() {
  var url = window.location.href;
  var arr = url.split('/');
  var result = arr[0] + '//' + arr[2];
  window.MKCL_HOST = result;
}

/***/ }),

/***/ "NKT+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_agreement_vue__ = __webpack_require__("E3fr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b65337a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_agreement_vue__ = __webpack_require__("tudI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("8mG2")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_agreement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b65337a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_agreement_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b65337a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_agreement_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NO0o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{directives:[{name:"bar",rawName:"v-bar"}],staticClass:"sidebar vb"},[_c('div',{staticClass:"sidebar-wrapper"},[_c('div',{staticClass:"sidebar-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"user-details"},[_c('div',{staticClass:"user-image"},[_c('img',{attrs:{"src":_vm.$store.state.user.userDetails.profilePhotoUrl,"alt":"user"}})]),_vm._v(" "),_c('div',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.$store.state.user.userDetails.fullName)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" ["+_vm._s(_vm.$store.state.candidateProfile.profileUser)+"]")])])]),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"menu-items"},[_c('b-link',{staticClass:"menu-item",attrs:{"to":"agreement"}},[_c('i',{staticClass:"mdi mdi-format-list-bulleted"}),_vm._v(_vm._s(_vm.$t('sideBar.lblRegistration')))]),_vm._v(" "),_c('b-link',{staticClass:"menu-item",on:{"click":_vm.logout}},[_c('i',{staticClass:"mdi  mdi-logout"}),_vm._v(_vm._s(_vm.$t('sideBar.lblLogout'))+" ")]),_vm._v(" "),_c('b-link',{staticClass:"menu-item",attrs:{"to":"termsConditions"}},[_c('i',{staticClass:"mdi mdi-file"}),_vm._v(_vm._s(_vm.$t('sideBar.lblTermCondition')))])],1),_vm._v(" "),_c('div',{staticClass:"sidebar-footer"},[_c('img',{attrs:{"src":"static/assets/images/logo_mkcl.png","alt":"MKCL"}}),_vm._v(" "),_c('div',{staticClass:"copyright"},[_vm._v("©"+_vm._s(_vm.$t('sideBar.lblCopyRights'))+" ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-header"},[_c('img',{attrs:{"src":"static/assets/images/mfs-logo.png","alt":"Recruitment","width":"120px"}})])}]


/***/ }),

/***/ "PsLs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pu3C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return server; });

var server = {
  address: 'http://localhost:8088/server'
};


/***/ }),

/***/ "RVOR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qualificationDetails_vue__ = __webpack_require__("uxIY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7abf7b88_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_qualificationDetails_vue__ = __webpack_require__("pLS5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("YJD/")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qualificationDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7abf7b88_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_qualificationDetails_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7abf7b88_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_qualificationDetails_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S8pY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SEAD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_itCertification_vue__ = __webpack_require__("BGXO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5711f136_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_itCertification_vue__ = __webpack_require__("5Zg9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("3J2B")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_itCertification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5711f136_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_itCertification_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5711f136_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_itCertification_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "USeP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_datepicker2__ = __webpack_require__("ipUw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HscDetails',
  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_0_vue_datepicker2__["a" /* default */]
  },
  data: function data() {
    return {
      startTime: '',
      educationDetails: {},
      selectedBoard: null,
      boardList: [],
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'DD/MM/YYYY',
        placeholder: 'Select Date Of Birth',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          border: '2px solid #fff',
          'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
          'border-radius': '2px',
          color: '#5F5F5F'
        }
      },
      limit: [{
        type: 'fromto',
        from: '1960-02-01',
        to: '2018-02-23'
      }]
    };
  },

  methods: {
    getBoardDetails: function getBoardDetails() {
      var self = this;
      console.log('get board details');
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('r/candidateProfile/getBoardDetails').then(function (response) {
        if (response.status === 200) {
          self.boardList = response.data;
          self.getUserHSCDetails();
          // self.certificationList.push(self.defaultObj)
        }
      }).catch(function () {
        self.$toasted.error(self.$t('candidateProfile.certification.toastrErrorFetchingCertificationList'), {
          theme: 'bubble',
          duration: 2000
        });
      });
    },
    getUserHSCDetails: function getUserHSCDetails() {
      var self = this;
      var profileUser = this.$store.state.candidateProfile.profileUser;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('r/candidateProfile/getHSCDetails/' + profileUser).then(function (response) {
        if (response.status === 200) {
          self.educationDetails = response.data;
          for (var i in self.boardList) {
            if (self.boardList[i].boardName === self.educationDetails.board) {
              self.selectedBoard = self.boardList[i];
            }
          }
          if (self.educationDetails.dateOfResult !== undefined && self.educationDetails.dateOfResult !== null && self.educationDetails.dateOfResult !== '') {
            console.log(self.educationDetails.dateOfResult);
            var parts = self.educationDetails.dateOfResult.split('/');
            self.startTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(String(new Date(parts[2], parts[1] - 1, parts[0]))).format('DD/MM/YYYY');
          }
          // self.certificationList.push(self.defaultObj)
        }
      }).catch(function () {
        /*  self.$toasted.error(self.$t('candidateProfile.certification.toastrErrorFetchingCertificationList'), {
           theme: 'bubble',
           duration: 2000
         }) */
      });
    },
    saveHSCDetails: function saveHSCDetails() {
      var _this = this;

      var profileUser = this.$store.state.candidateProfile.profileUser;
      this.$validator.validate().then(function (result) {
        if (result) {
          _this.educationDetails.board = _this.selectedBoard.boardName;
          _this.educationDetails.dateOfResult = __WEBPACK_IMPORTED_MODULE_2_moment___default()(String(_this.startTime)).format('DD/MM/YYYY');
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('r/candidateProfile/saveHSCDetails/' + profileUser, _this.educationDetails).then(function (response) {
            if (response.status === 200) {
              _this.$toasted.success('HSC Details Save Successfuly', {
                theme: 'bubble',
                duration: 2000
              });
              return true;
            }
          }).catch(function (e) {
            console.log(e);
            return false;
          });
        } else {
          _this.$toasted.error('Please Enter Required data', {
            theme: 'bubble',
            duration: 2000
          });
        }
      }).catch(function (e) {
        _this.$toasted.error('Oops Something goes wrong', {
          theme: 'bubble',
          duration: 2000
        });
      });
    }
  },
  created: function created() {
    this.getBoardDetails();
  }
});

/***/ }),

/***/ "UTrd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-header"},[_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col-10 text-left"},[_c('h2',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t('registration.tabs.tabProfileSummary')))])]),_vm._v(" "),_c('div',{staticClass:"col-2 lighten text-right"})])]),_vm._v(" "),_c('div',{staticClass:"row profileSummary justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-auto"},[_c('img',{staticClass:"userpic img-thumbnail d-block circle",attrs:{"src":_vm.profilesrc}})]),_vm._v(" "),_c('div',{staticClass:"col align-self-center"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('candidateProfile.profileSummary.lblPersonalDetails')))])]),_vm._v(" "),_c('div',{staticClass:"col text-right"},[_c('b-link',{staticClass:"btn btn-info-alt",attrs:{"to":"personalDetails"}},[_vm._v(_vm._s(_vm.$t('candidateProfile.profileSummary.btnEditDetails')))])],1)]),_vm._v(" "),_c('div',{staticClass:"section"},[_vm._v(_vm._s(_vm.$t('candidateProfile.profileSummary.lblName'))),_c('div',{staticClass:"input-css"},[_vm._v(_vm._s(_vm.candidateProfile.personalDetails.fullName))]),_vm._v(" \n                            "+_vm._s(_vm.$t('candidateProfile.profileSummary.lblFatherName'))+" "),_c('div',{staticClass:"input-css"},[_vm._v(_vm._s(_vm.candidateProfile.personalDetails.fatherName))]),_vm._v("\n                            "+_vm._s(_vm.$t('candidateProfile.profileSummary.lblAnd'))+" \n                            "),_c('div',{staticClass:"input-css"},[_vm._v(_vm._s(_vm.candidateProfile.personalDetails.motherName)+".")]),_vm._v("\n                            "+_vm._s(_vm.$t('candidateProfile.profileSummary.lblGender'))+" "),_c('div',{staticClass:"input-css"},[_vm._v(_vm._s(_vm.candidateProfile.personalDetails.gender.name)+".")]),_vm._v("\n                            "+_vm._s(_vm.$t('candidateProfile.profileSummary.lblDOB'))+" "),_c('div',{staticClass:"input-css"},[_vm._v(_vm._s(_vm._f("formatDate")(_vm.candidateProfile.personalDetails.dob))+".")]),_vm._v("\n                            "+_vm._s(_vm.$t('candidateProfile.profileSummary.lblMotherTounge'))+" "),_c('div',{staticClass:"input-css"},[_vm._v(_vm._s(_vm.candidateProfile.personalDetails.motherTongue.name))]),_vm._v(" "+_vm._s(_vm.$t('candidateProfile.profileSummary.lblAnd'))+" \n                            "+_vm._s(_vm.$t('candidateProfile.profileSummary.lblMaritalStatus'))+" "),_c('div',{staticClass:"input-css"},[_vm._v(_vm._s(_vm.candidateProfile.personalDetails.maritalStatus.name)+".")])])])])])]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('candidateProfile.profileSummary.lblContactDetails')))])]),_vm._v(" "),_c('div',{staticClass:"col text-right"},[_c('b-link',{staticClass:"btn btn-info-alt",attrs:{"to":"address"}},[_vm._v(_vm._s(_vm.$t('candidateProfile.profileSummary.btnEditDetails')))])],1)]),_vm._v(" "),_c('div',{staticClass:"section"},[_vm._v(_vm._s(_vm.$t('candidateProfile.profileSummary.lblMobileNumber'))),_c('div',{staticClass:"input-css"},[_vm._v(_vm._s(_vm.candidateProfile.contactDetails.phoneNo)+",")]),_vm._v("\n                            "+_vm._s(_vm.$t('candidateProfile.profileSummary.lblEmailID'))+" "),_c('div',{staticClass:"input-css"},[_vm._v(_vm._s(_vm.candidateProfile.contactDetails.email)+".")]),_vm._v("\n                            "+_vm._s(_vm.$t('candidateProfile.profileSummary.lblCorrespondanceAddress'))+" "),_c('div',{staticClass:"input-css"},[_vm._v(_vm._s(_vm.candidateProfile.contactDetails.corespondeneceAddress.tehsil)+", "+_vm._s(_vm.candidateProfile.contactDetails.corespondeneceAddress.district)+", "+_vm._s(_vm.candidateProfile.contactDetails.corespondeneceAddress.state)+".")]),_vm._v("\n                            "+_vm._s(_vm.$t('candidateProfile.profileSummary.lblPermanentAddress'))+" "),_c('div',{staticClass:"input-css"},[_vm._v(_vm._s(_vm.candidateProfile.contactDetails.permanentAddress.tehsil)+", "+_vm._s(_vm.candidateProfile.contactDetails.permanentAddress.district)+", "+_vm._s(_vm.candidateProfile.contactDetails.permanentAddress.state))]),_vm._v("\n                            "+_vm._s(_vm.$t('candidateProfile.profileSummary.lblRespectively'))+" "),(_vm.candidateProfile.contactDetails.skypeId !== '')?_c('div',[_vm._v(_vm._s(_vm.$t('candidateProfile.profileSummary.lblSkypeId'))+" "),_c('div',{staticClass:"input-css"},[_vm._v(_vm._s(_vm.candidateProfile.contactDetails.skypeId)+" .")])]):_vm._e()])])]),_vm._v(" "),_c('hr')]),_vm._v(" "),(_vm.screenConfig.visible)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t('candidateProfile.profileSummary.lblITCertification')))])]),_vm._v(" "),_c('div',{staticClass:"col text-right"},[_c('b-link',{staticClass:"btn btn-info-alt",attrs:{"to":"itCertification"}},[_vm._v(_vm._s(_vm.$t('candidateProfile.profileSummary.btnEditDetails')))])],1)]),_vm._v(" "),(_vm.candidateProfile.itCertificationsDetails.itCertification.certificationID !== 0)?_c('div',{staticClass:"section"},[_vm._v(_vm._s(_vm.$t('candidateProfile.profileSummary.lblCompletedITCertification'))+"  "),_c('div',{staticClass:"input-css"},[_vm._v(_vm._s(_vm.candidateProfile.itCertificationsDetails.itCertification.certificationName)+".")]),_vm._v("\n                            "+_vm._s(_vm.$t('candidateProfile.profileSummary.lblLearnerCode'))+" "),_c('div',{staticClass:"input-css"},[_vm._v(_vm._s(_vm.candidateProfile.itCertificationsDetails.learnerCode)+".")]),_vm._v(" "),(_vm.candidateProfile.knownLanguages.length > 0 )?_c('div',[_vm._v(_vm._s(_vm.$t('candidateProfile.profileSummary.lblSkil'))+" "),_c('div',{staticClass:"input-css"},[_vm._v(_vm._s(_vm.candidateProfile.itCertificationsDetails.knownLanguagesInfo))]),_vm._v(" "+_vm._s(_vm.$t('candidateProfile.profileSummary.lblITCertficationTechnology'))+" ")]):_vm._e(),_vm._v(" "),(_vm.candidateProfile.experienceDetails.length > 0)?_c('div',[_vm._v(_vm._s(_vm.$t('candidateProfile.profileSummary.lblPreviousExperience'))+" "),_c('div',{staticClass:"input-css"},[_vm._v(_vm._s(_vm.candidateProfile.itCertificationsDetails.experienceDetails)+".")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.candidateProfile.itCertificationsDetails.itCertification.certificationID === 0)?_c('div',{staticClass:"section"},[_vm._v(_vm._s(_vm.$t('candidateProfile.profileSummary.lblCertificationNotCompleted'))+"\n                            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"section"},[(_vm.candidateProfile.itCertificationsDetails.referralCode)?_c('div',[_vm._v(_vm._s(_vm.$t('candidateProfile.profileSummary.lblReferalCode'))+" "),_c('div',{staticClass:"input-css"},[_vm._v(_vm._s(_vm.candidateProfile.itCertificationsDetails.referralCode)+".")])]):_vm._e(),_vm._v(" "),(_vm.candidateProfile.itCertificationsDetails.alcCode)?_c('div',[_vm._v(_vm._s(_vm.$t('candidateProfile.profileSummary.lblAlcCode'))+" "),_c('div',{staticClass:"input-css"},[_vm._v(_vm._s(_vm.candidateProfile.itCertificationsDetails.alcCode)+".")])]):_vm._e()])])]),_vm._v(" "),_c('hr')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col align-self-start"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('candidateProfile.profileSummary.lblEducationDetails'))+" ")])]),_vm._v(" "),_c('div',{staticClass:"col align-self-start text-right"},[_c('b-link',{staticClass:"btn btn-info-alt",attrs:{"to":"educationalDetails"}},[_vm._v(_vm._s(_vm.$t('candidateProfile.profileSummary.btnEditDetails')))])],1)]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('div',{staticClass:"row"},[(_vm.candidateProfile.educationDetails.isSSCPassed)?_c('div',{staticClass:"col-4"},[_c('div',[_vm._v(_vm._s(_vm.$t('candidateProfile.profileSummary.lblSSC'))),_c('img',{staticClass:"dpic documentImg img-fluid img-thumbnail",attrs:{"src":_vm.sscsrc},on:{"click":function($event){_vm.showSSC = true}}})])]):_vm._e(),_vm._v(" "),(_vm.candidateProfile.educationDetails.isHSCPassed)?_c('div',{staticClass:"col-4"},[_c('div',[_vm._v(_vm._s(_vm.$t('candidateProfile.profileSummary.lblHSC'))),_c('img',{staticClass:"dpic documentImg img-fluid img-thumbnail",attrs:{"src":_vm.hscsrc},on:{"click":function($event){_vm.showHSC = true}}})])]):_vm._e(),_vm._v(" "),(_vm.candidateProfile.educationDetails.isDiplomaPassed)?_c('div',{staticClass:"col-4"},[_c('div',[_vm._v(_vm._s(_vm.$t('candidateProfile.profileSummary.lblDiploma'))),_c('img',{staticClass:"dpic documentImg img-fluid img-thumbnail",attrs:{"src":_vm.diplomasrc},on:{"click":function($event){_vm.showDiploma = true}}})])]):_vm._e(),_vm._v(" "),(_vm.candidateProfile.educationDetails.neverAppeared)?_c('div',{staticClass:"col-12"},[_c('b',{staticClass:"red"},[_vm._v(_vm._s(_vm.$t('candidateProfile.profileSummary.lblNotEligible'))+" ")])]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 text-center p-4"},[_c('div',{staticClass:"row"},[_c('button',{staticClass:"btn btn btn-info-alt mr-3",attrs:{"type":"button"},on:{"click":_vm.prevTabFunc}},[_vm._v(" "+_vm._s(_vm.$t('button.back')))]),_vm._v(" "),_c('button',{staticClass:"btn btn btn-orange ml-auto",attrs:{"type":"button"},on:{"click":_vm.nextTabFunc}},[_vm._v(" "+_vm._s(_vm.$t('button.confirm_proceed')))])])])]),_vm._v(" "),(_vm.showSSC)?_c('modal',{staticClass:"lg",on:{"close":function($event){_vm.showSSC = false}}},[_c('h3',{slot:"header"},[_vm._v("SSC Document")]),_vm._v(" "),_c('div',{slot:"body"},[_c('img',{attrs:{"src":_vm.sscsrc,"width":"100%"}})])]):_vm._e(),_vm._v(" "),(_vm.showHSC)?_c('modal',{staticClass:"lg",on:{"close":function($event){_vm.showHSC = false}}},[_c('h3',{slot:"header"},[_vm._v("HSC Document")]),_vm._v(" "),_c('div',{slot:"body"},[_c('img',{attrs:{"src":_vm.hscsrc,"width":"100%"}})])]):_vm._e(),_vm._v(" "),(_vm.showDiploma)?_c('modal',{staticClass:"lg",on:{"close":function($event){_vm.showDiploma = false}}},[_c('h3',{slot:"header"},[_vm._v("DIploma Document")]),_vm._v(" "),_c('div',{slot:"body"},[_c('img',{attrs:{"src":_vm.diplomasrc,"width":"100%"}})])]):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "UjVw":
/***/ (function(module, exports) {



/***/ }),

/***/ "Vd6d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_registration_vue__ = __webpack_require__("deAl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_656db2f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_registration_vue__ = __webpack_require__("3NHr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("/aqT")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_registration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_656db2f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_registration_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_656db2f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_registration_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Vkv3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WYlY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mfs_footer_vue__ = __webpack_require__("E/B9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c5e9e8a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mfs_footer_vue__ = __webpack_require__("J+zz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Vkv3")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mfs_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c5e9e8a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mfs_footer_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c5e9e8a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mfs_footer_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XYOV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y+0M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal'
});

/***/ }),

/***/ "Y2Vg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YDR2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'signup',
  data: function data() {
    return {
      signUpForm: {
        contactDetails: {
          phoneNo: null,
          mobileNo: null
        },
        personalDetails: {
          fullName: null
        },
        userName: null,
        password: null
      },
      isUsernameAvailable: false,
      confirmEmail: '',
      isShowPass: false,
      otp: '',
      tempMobileNumber: 0,
      universityConfig: { state: {} },
      otpSent: false,
      otpResent: false,
      otpTimeInMin: 0,
      stopCountDown: false,
      applicationStartDate: '',
      applicationEndDate: '',
      currentServerDate: ''
    };
  },

  methods: {
    getLogoUrl: function getLogoUrl(abbr) {
      return 'static/assets/images/' + abbr + '.png';
    },
    getProjectConfig: function getProjectConfig() {
      var _this = this;

      // This method get university configuration
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('o/projectConfig/getUniversityConfig').then(function (response) {
        _this.universityConfig = response.data;
      }).catch(function (e) {
        console.error(e);
      });
      // This method get application start date and end date.
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('o/projectConfig/getStartEndDate').then(function (responses) {
        _this.applicationEndDate = new Date(responses.data.endDate);
        _this.applicationStartDate = new Date(responses.data.startDate);
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('o/projectConfig/getCurrentServerDateTime').then(function (response) {
          _this.currentServerDate = new Date(response.data);
        }).catch(function (e) {
          console.error(e);
        });
      }).catch(function (e) {
        console.error(e);
      });
      // This method get otp time configuration
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('o/projectConfig/getResendOtpTimeInMin').then(function (response) {
        _this.otpTimeInMin = parseInt(response.data);
      }).catch(function (e) {
        console.error(e);
      });
    },
    validateEmail: function validateEmail() {
      if (this.signUpForm.userName !== this.confirmEmail) {
        this.$toasted.error(this.$t('registration.alerts.EMAIL_NOT_MATCHED'));
        this.confirmEmail = '';
        return false;
      }
    },
    pasteValue: function pasteValue() {
      var _this2 = this;

      window.setTimeout(function () {
        _this2.confirmEmail = '';
      });
    },
    checkUsernameAvailability: function checkUsernameAvailability() {
      var self = this;
      if (self.signUpForm.userName !== '' && self.signUpForm.userName !== null) {
        self.signUpForm.userName = self.signUpForm.userName.toLowerCase();
        this.$validator.validate('signUpForm.email', self.signUpForm.userName).then(function (result) {
          if (result) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('o/isUsernameAvailable', self.signUpForm).then(function (response) {
              if (response.status === 200) {
                self.isUsernameAvailable = false;
                self.errors.remove('username');
                // self.$toasted.info(self.$t('registration.alerts.USERNAME_NOT_AVAILABLE'))
              }
              if (response.status === 207) {
                self.isUsernameAvailable = true;
                self.$toasted.info(self.$t('registration.alerts.USERNAME_ALREADY_EXIST'));
                self.signUpForm.userName = '';
              }
            }).catch(function () {
              self.isUsernameAvailable = false;
              self.$toasted.error(self.$t('registration.alerts.FAIL_TO_FIND_USERNAME_AVAILABILITY'));
            });
          } else {
            self.$toasted.error(self.$t('registration.toastrPleaseEnterValidEmail'));
          }
        });
      }
    },
    validateInput: function validateInput() {
      var _this3 = this;

      var self = this;
      this.$validator.validate('signUpForm.fullName', self.signUpForm.personalDetails.fullName).then(function (result) {
        if (!result) {
          _this3.$toasted.error(self.$t('registration.toastrPleaseEnterValidFullName'));
        }
      });
      this.$validator.validate('signUpForm.password', self.signUpForm.password).then(function (result) {
        if (!result) {
          _this3.$toasted.error(self.$t('registration.toastrPasswordRequired'));
        }
      });
      this.$validator.validate('signUpForm.email', self.signUpForm.userName).then(function (result) {
        if (!result) {
          _this3.$toasted.error(self.$t('registration.toastrPleaseEnterValidEmail'));
        }
      });
      this.$validator.validate('signUpForm.confirm email', self.confirmEmail).then(function (result) {
        if (!result) {
          _this3.$toasted.error(self.$t('registration.toastrPleaseEnterValidConfirmEmail'));
        }
      });
      this.$validator.validate('signUpForm.mobile', self.signUpForm.contactDetails.phoneNo).then(function (result) {
        if (!result) {
          _this3.$toasted.error(self.$t('registration.toastrPleaseEnterValidMobile'));
        }
      });
    },
    sendOTP: function sendOTP() {
      var _this4 = this;

      var self = this;
      this.stopCountDown = false;
      var countDownTime = this.otpTimeInMin * 60;
      this.$validator.validate().then(function (result) {
        if (result) {
          if (!self.isUsernameAvailable) {
            self.signUpForm.personalDetails.fullName = self.signUpForm.personalDetails.fullName.toUpperCase().trim();
            self.signUpForm.userName = self.signUpForm.userName.toLowerCase();
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('o/sendotp', self.signUpForm).then(function (response) {
              if (response.status === 200) {
                self.otpResent = true;
                self.tempMobileNumber = self.signUpForm.contactDetails.phoneNo;
                self.otpSent = true;
                // setTimeout(function () {
                //   document.getElementById('sendOtpButton').disabled = false
                //   document.getElementById('registerButton').disabled = true
                //   self.otpSent = false
                // }, 600000)
                var x = setInterval(function () {
                  countDownTime = countDownTime - 1;
                  var min = Math.floor(countDownTime / 60);
                  var sec = Math.floor(countDownTime % 60);
                  var minZero = '';
                  if (min < 10) {
                    minZero = '0';
                  }
                  var secZero = '';
                  if (sec < 10) {
                    secZero = '0';
                  }
                  if (countDownTime <= 0) {
                    self.stopCountDown = true;
                  }
                  if (self.stopCountDown) {
                    clearInterval(x);
                    self.otpSent = false;
                  }
                  document.getElementById('demo').innerHTML = minZero + min + ':' + secZero + sec + 's';
                }, 1000);
                self.$toasted.success(self.$t('registration.alerts.OTP_SEND_SUCCESS'));
              }
            }).catch(function () {
              self.$toasted.error(self.$t('registration.alerts.OTP_Send_Fail'));
              self.otpSent = false;
              self.stopCountDown = true;
              // document.getElementById('sendOtpButton').disabled = false
            });
          } else {
            self.signUpForm.userName = '';
            self.stopCountDown = true;
            self.$toasted.info(self.$t('registration.alerts.USERNAME_ALREADY_EXIST'));
          }
        } else {
          _this4.validateInput();
        }
      });
    },
    verifyOTP: function verifyOTP() {
      var self = this;
      if (self.tempMobileNumber === self.signUpForm.contactDetails.phoneNo) {
        var verifyObj = {};
        verifyObj.otp = this.otp;
        verifyObj.userName = this.signUpForm.userName.toLowerCase();
        this.$validator.validateAll({
          otp: this.otp,
          userName: this.signUpForm.userName
        }).then(function (result) {
          if (result) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('o/verifyotp', verifyObj).then(function (response) {
              if (response.status === 200) {
                if (response.data === true) {
                  self.register();
                } else {
                  self.$toasted.error(self.$t('registration.alerts.OTP_INVALID'));
                }
              }
            }).catch(function () {
              self.$toasted.error(self.$t('registration.alerts.OTP_VERIFY_FAIL'));
            });
          } else {
            self.$toasted.error(self.$t('registration.alerts.ENTER_VALID_DETAILS'));
          }
        });
      } else {
        // document.getElementById('sendButton').disabled = false
        // document.getElementById('registerButton').disabled = true
        self.otpSent = false;
        self.stopCountDown = true;
        self.otp = '';
        self.$toasted.info(self.$t('registration.alerts.MOBILE_NUMBER_CHANGED'));
        return false;
      }
    },
    register: function register() {
      var _this5 = this;

      var self = this;
      if (self.otp === undefined || self.otp === null || self.otp === '') {
        self.$toasted.error(self.$t('registration.alerts.OTP_INVALID'));
        return false;
      }
      this.$validator.validate().then(function (result) {
        if (result) {
          self.signUpForm.personalDetails.fullName = self.signUpForm.personalDetails.fullName.toUpperCase().trim();
          self.signUpForm.userName = self.signUpForm.userName.toLowerCase();
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('o/signup', self.signUpForm).then(function (response) {
            if (response.status === 200) {
              self.stopCountDown = true;
              self.$toasted.success(self.$t('registration.alerts.REGISTRATION_SUCCESS'));
              self.$router.push({ path: '/' });
            }
          }).catch(function () {
            this.$toasted.error(self.$t('registration.alerts.REGISTRATION_FAIL'));
          });
        } else {
          _this5.validateInput();
        }
      });
    },
    mobileNoChanged: function mobileNoChanged() {
      var txtMobNo = document.getElementById('txt_mobNo');
      var mobRegExp = new RegExp('^[7-9][0-9]{9}$');
      if (!mobRegExp.test(txtMobNo.value)) {
        this.errors.add('mobile', 'Invalid Mobile Number');
      } else {
        this.errors.remove('mobile');
      }
    },
    passwordChanged: function passwordChanged() {
      var strength = document.getElementById('strength');
      var strongRegex = new RegExp('^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$', 'g');
      var mediumRegex = new RegExp('^(?=.{7,})(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))).*$', 'g');
      var enoughRegex = new RegExp('(?=.{6,}).*', 'g');
      var pwd = document.getElementById('txt_password');
      if (strongRegex.test(pwd.value)) {
        strength.innerHTML = "<span style='color:green'>Strong!</span>";
      } else if (mediumRegex.test(pwd.value)) {
        strength.innerHTML = "<span style='color:orange'>Medium!</span>";
      } else if (enoughRegex.test(pwd.value)) {
        strength.innerHTML = "<span style='color:red'>Weak!</span>";
      } else {
        strength.innerHTML = '<span style="color:red">Very Weak!</span>';
      }
    },
    showHidePassword: function showHidePassword() {
      if (this.isShowPass) {
        this.isShowPass = false;
        document.getElementById('txt_password').setAttribute('type', 'password');
      } else {
        this.isShowPass = true;
        document.getElementById('txt_password').setAttribute('type', 'text');
      }
    },
    cancel: function cancel() {
      this.stopCountDown = true;
      this.$router.push({ path: '/' });
    },
    trigger: function trigger() {
      this.register();
    }
  },
  created: function created() {
    this.getProjectConfig();
  },
  filters: {
    formatDate: function formatDate(value) {
      if (value) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(String(value)).format('DD-MMM-YYYY');
      }
    }
  }
});

/***/ }),

/***/ "YJD/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YUUT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_datepicker2__ = __webpack_require__("ipUw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SscDetails',
  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_0_vue_datepicker2__["a" /* default */]
  },
  data: function data() {
    return {
      startTime: '',
      educationDetails: {},
      selectedBoard: null,
      boardList: [],
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'DD/MM/YYYY',
        placeholder: 'Select Date Of Birth',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          border: '2px solid #fff',
          'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
          'border-radius': '2px',
          color: '#5F5F5F'
        }
      },
      limit: [{
        type: 'fromto',
        from: '1960-02-01',
        to: '2018-02-23'
      }]
    };
  },

  methods: {
    getBoardDetails: function getBoardDetails() {
      var self = this;
      console.log('get board details');
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('r/candidateProfile/getBoardDetails').then(function (response) {
        if (response.status === 200) {
          self.boardList = response.data;
          self.getUserSSCDetails();
          // self.certificationList.push(self.defaultObj)
        }
      }).catch(function () {
        self.$toasted.error(self.$t('candidateProfile.certification.toastrErrorFetchingCertificationList'), {
          theme: 'bubble',
          duration: 2000
        });
      });
    },
    getUserSSCDetails: function getUserSSCDetails() {
      var self = this;
      console.log('get user ssc details');
      var profileUser = this.$store.state.candidateProfile.profileUser;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('r/candidateProfile/getSSCDetails/' + profileUser).then(function (response) {
        if (response.status === 200) {
          self.educationDetails = response.data;
          for (var i in self.boardList) {
            if (self.boardList[i].boardName === self.educationDetails.board) {
              self.selectedBoard = self.boardList[i];
            }
          }
          if (self.educationDetails.dateOfResult !== undefined && self.educationDetails.dateOfResult !== null && self.educationDetails.dateOfResult !== '') {
            console.log(self.educationDetails.dateOfResult);
            var parts = self.educationDetails.dateOfResult.split('/');
            self.startTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(String(new Date(parts[2], parts[1] - 1, parts[0]))).format('DD/MM/YYYY');
          }
          // self.certificationList.push(self.defaultObj)
        }
      }).catch(function () {
        /*  self.$toasted.error(self.$t('candidateProfile.certification.toastrErrorFetchingCertificationList'), {
           theme: 'bubble',
           duration: 2000
         }) */
      });
    },
    saveSSCDetails: function saveSSCDetails() {
      var _this = this;

      var profileUser = this.$store.state.candidateProfile.profileUser;
      var self = this;
      this.$validator.validate().then(function (result) {
        if (result) {
          _this.educationDetails.board = _this.selectedBoard.boardName;
          _this.educationDetails.dateOfResult = __WEBPACK_IMPORTED_MODULE_2_moment___default()(String(_this.startTime)).format('DD/MM/YYYY');
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('r/candidateProfile/saveSSCDetails/' + profileUser, _this.educationDetails).then(function (response) {
            if (response.status === 200) {
              _this.$toasted.success(self.$t('toastr.toastrPersonalDetailsSaved'), {
                theme: 'bubble',
                duration: 2000
              });
              _this.scanAadhar = false;
              return true;
            }
          }).catch(function (e) {
            console.log(e);
            return false;
          });
        } else {
          _this.$toasted.error('Please Enter Required data', {
            theme: 'bubble',
            duration: 2000
          });
        }
      }).catch(function (e) {
        _this.$toasted.error('Oops Something goes wrong', {
          theme: 'bubble',
          duration: 2000
        });
      });
    }
  },
  created: function created() {
    this.getBoardDetails();
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_login_login__ = __webpack_require__("EV1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_signUp_sign_up__ = __webpack_require__("rIof");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_workPlace_workPlace__ = __webpack_require__("sEYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_registration_registration__ = __webpack_require__("Vd6d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_entry_entry__ = __webpack_require__("3PZQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_registration_agreement__ = __webpack_require__("NKT+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_candidateApplication_candidateApplication__ = __webpack_require__("p8Mm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_registration_personalDetails__ = __webpack_require__("g5EO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_registration_itCertification__ = __webpack_require__("SEAD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_registration_address__ = __webpack_require__("xtL+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_registration_educationalDetails__ = __webpack_require__("Af9h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_registration_profileSummary__ = __webpack_require__("e/V6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_registration_imageExtracter__ = __webpack_require__("C1Az");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_registration_documentsupload__ = __webpack_require__("obgm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_registration_educationFieldDetails__ = __webpack_require__("i3Qj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_registration_qualificationDetails__ = __webpack_require__("RVOR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_registration_termsConditions__ = __webpack_require__("ruvP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_videoUpload_videoUpload__ = __webpack_require__("o+41");





















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_login_login__["a" /* default */]
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_login_login__["a" /* default */]
  }, {
    path: '/candidateApplication',
    name: 'candidateApplication',
    component: __WEBPACK_IMPORTED_MODULE_8__components_candidateApplication_candidateApplication__["a" /* default */]
  }, {
    path: '/videoUpload',
    name: 'videoUpload',
    component: __WEBPACK_IMPORTED_MODULE_19__components_videoUpload_videoUpload__["a" /* default */]
  }, {
    path: '/workPlace/:courseID/:universityID',
    name: 'workPlace',
    component: __WEBPACK_IMPORTED_MODULE_4__components_workPlace_workPlace__["a" /* default */]
  }, {
    path: '/signup',
    name: 'signup',
    component: __WEBPACK_IMPORTED_MODULE_3__components_signUp_sign_up__["a" /* default */]
  }, {
    path: '/registration',
    name: 'registration',
    component: __WEBPACK_IMPORTED_MODULE_5__components_registration_registration__["a" /* default */],
    children: [{
      path: '/itCertification',
      name: 'itCertification',
      component: __WEBPACK_IMPORTED_MODULE_10__components_registration_itCertification__["a" /* default */]
    }, {
      path: '/personalDetails',
      name: 'personalDetails',
      component: __WEBPACK_IMPORTED_MODULE_9__components_registration_personalDetails__["a" /* default */]
    }, {
      path: '/address',
      name: 'address',
      component: __WEBPACK_IMPORTED_MODULE_11__components_registration_address__["a" /* default */]
    }, {
      path: '/educationalDetails',
      name: 'educationalDetails',
      component: __WEBPACK_IMPORTED_MODULE_12__components_registration_educationalDetails__["a" /* default */]
    }, {
      path: '/profileSummary',
      name: 'profileSummary',
      component: __WEBPACK_IMPORTED_MODULE_13__components_registration_profileSummary__["a" /* default */]
    }, {
      path: '/imageExtracter',
      name: 'imageExtracter',
      component: __WEBPACK_IMPORTED_MODULE_14__components_registration_imageExtracter__["a" /* default */]
    }, {
      path: '/documentsupload',
      name: 'documentsupload',
      component: __WEBPACK_IMPORTED_MODULE_15__components_registration_documentsupload__["default"]
    }, {
      path: '/educationFieldDetails',
      name: 'educationFieldDetails',
      component: __WEBPACK_IMPORTED_MODULE_16__components_registration_educationFieldDetails__["a" /* default */]
    }, {
      path: '/qualificationDetails',
      name: 'qualificationDetails',
      component: __WEBPACK_IMPORTED_MODULE_17__components_registration_qualificationDetails__["a" /* default */]
    }, {
      path: '/termsConditions',
      name: 'termsConditions',
      component: __WEBPACK_IMPORTED_MODULE_18__components_registration_termsConditions__["a" /* default */]
    }]
  }, {
    path: '/entry',
    name: 'entry',
    component: __WEBPACK_IMPORTED_MODULE_6__components_entry_entry__["a" /* default */]
  }, {
    path: '/agreement',
    name: 'agreement',
    component: __WEBPACK_IMPORTED_MODULE_7__components_registration_agreement__["a" /* default */]
  }, {
    path: '*',
    redirect: '/'
  }]
}));

/***/ }),

/***/ "Z0ny":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col"},[_c('h2',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t('entry.confirmText')))])])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row termcondition-font"},[_c('p',{staticClass:"para condition-height alert alert-info"},[_vm._v("\n      "+_vm._s(_vm.instructions.startUpPara)+" \n  ")]),_vm._v(" "),_c('strong',{staticClass:"p-bot"},[_c('p',[_vm._v(_vm._s(_vm.$t('candidateProfile.agreement.lblUndertakes')))])]),_vm._v(" "),_c('ul',{},_vm._l((_vm.instructions.instructionList),function(item){return _c('li',[_vm._v(_vm._s(item.instructionMsg)+"\n                "),(item.subInstructions)?_c('ul',{staticClass:"subInstructionFont"},_vm._l((item.subInstructions),function(subItem){return _c('li',[_vm._v(_vm._s(subItem.instructionMsg)+" ")])})):_vm._e()])}))]),_vm._v(" "),_c('div',{staticClass:"text-center pt-3"},[_c('button',{staticClass:"btn btn-info-alt",on:{"click":function($event){_vm.$router.push('entry')}}},[_vm._v(_vm._s(_vm.$t('button.back')))])])])])])])])}
var staticRenderFns = []


/***/ }),

/***/ "ZNIs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aCnX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header modal-paddings header-manage"},[_vm._t("header",[_vm._v("\n            default header\n          ")])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",[_vm._v("\n            default body\n          ")])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer modal-paddings"},[_vm._t("footer",[_c('button',{staticClass:"btn btn btn-orange ml-auto",on:{"click":function($event){_vm.$emit('close')}}},[_vm._v("\n              Close\n            ")])])],2)])])])])}
var staticRenderFns = []


/***/ }),

/***/ "aHHY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.user.loading)?_c('div',{staticClass:"loader-wraper"},[_vm._m(0)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-box"},[_c('div',{staticClass:"lds-roller"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')]),_vm._v(" "),_c('h6',{staticClass:"mt-2"},[_vm._v("Please wait...")])])}]


/***/ }),

/***/ "aiFg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doc-upload"},[_c('div',{staticClass:"page-header"},[_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col-10 text-left"},[_c('h2',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t('registration.tabs.tabDocumentUpload')))])]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[(_vm.profilesrc)?_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('candidateProfile.documentUpload.lblProfilePhoto')))]),_vm._v(" "),_c('img',{staticClass:"ppic documentImg img-fluid img-thumbnail",attrs:{"src":_vm.profilesrc}})]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.profilesrc || _vm.showDocuments ? 'col-9' : 'col-12'},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('candidateProfile.documentUpload.lblProfilePhoto')))]),_vm._v(" "),_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone1","options":_vm.dropzoneOptions},on:{"vdropzone-file-added":function($event){_vm.fileAdded('Profile',$event)},"vdropzone-removed-file":_vm.fileRemoved}}),_vm._v(" "),_c('small',{staticClass:"text-info"},[_vm._v("Document size should be less than 1MB")])],1),_vm._v(" "),(_vm.sscsrc)?_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('candidateProfile.documentUpload.lblSscDoc')))]),_vm._v(" "),_c('img',{staticClass:"dpic documentImg img-fluid img-thumbnail",attrs:{"src":_vm.sscsrc},on:{"click":function($event){_vm.showSSCModal = true}}})]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.sscsrc  ? 'col-9' : 'col-12'},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('candidateProfile.documentUpload.lblSscDoc')))]),_vm._v(" "),_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone2","options":_vm.dropzoneOptions},on:{"vdropzone-file-added":function($event){_vm.fileAdded('SSC',$event)},"vdropzone-removed-file":_vm.fileRemoved}}),_vm._v(" "),_c('small',{staticClass:"text-info"},[_vm._v("Document size should be less than 1MB")])],1),_vm._v(" "),(_vm.hscsrc && _vm.showHSC)?_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('candidateProfile.documentUpload.lblHscDoc')))]),_vm._v(" "),_c('img',{staticClass:"dpic documentImg img-fluid img-thumbnail",attrs:{"src":_vm.hscsrc},on:{"click":function($event){_vm.showHSCModal = true}}})]):_vm._e(),_vm._v(" "),(_vm.showHSC)?_c('div',{class:_vm.hscsrc  ? 'col-9' : 'col-12'},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('candidateProfile.documentUpload.lblHscDoc')))]),_vm._v(" "),_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone3","options":_vm.dropzoneOptions},on:{"vdropzone-file-added":function($event){_vm.fileAdded('HSC',$event)},"vdropzone-removed-file":_vm.fileRemoved}}),_vm._v(" "),_c('small',{staticClass:"text-info"},[_vm._v("Document size should be less than 1MB")])],1):_vm._e(),_vm._v(" "),(_vm.diplomasrc && _vm.showDiploma)?_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('candidateProfile.documentUpload.lblDiplomaDoc')))]),_vm._v(" "),_c('img',{staticClass:"dpic documentImg img-fluid img-thumbnail",attrs:{"src":_vm.diplomasrc},on:{"click":function($event){_vm.showDiplomaModal = true}}})]):_vm._e(),_vm._v(" "),(_vm.showDiploma)?_c('div',{class:_vm.diplomasrc ? 'col-9' : 'col-12'},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('candidateProfile.documentUpload.lblDiplomaDoc')))]),_vm._v(" "),_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone4","options":_vm.dropzoneOptions},on:{"vdropzone-file-added":function($event){_vm.fileAdded('Diploma',$event)},"vdropzone-removed-file":_vm.fileRemoved}}),_vm._v(" "),_c('small',{staticClass:"text-info"},[_vm._v("Document size should be less than 1MB")])],1):_vm._e(),_vm._v(" "),(_vm.diplomaHallTicketsrc && _vm.showDiplomaHallTicket)?_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('candidateProfile.educationDetails.lblDiplomaTicketDoc')))]),_vm._v(" "),_c('img',{staticClass:"dpic documentImg img-fluid img-thumbnail",attrs:{"src":_vm.diplomaHallTicketsrc}})]):_vm._e(),_vm._v(" "),(_vm.showDiplomaHallTicket)?_c('div',{class:_vm.diplomaHallTicketsrc ? 'col-9' : 'col-12'},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('candidateProfile.educationDetails.lblDiplomaTicketDoc')))]),_vm._v(" "),_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone4","options":_vm.dropzoneOptions},on:{"vdropzone-file-added":function($event){_vm.fileAdded('DiplomaHallTicket',$event)},"vdropzone-removed-file":_vm.fileRemoved}}),_vm._v(" "),_c('small',{staticClass:"text-info"},[_vm._v("Document size should be less than 1MB")])],1):_vm._e(),_vm._v(" "),(_vm.hscHallTicketsrc && _vm.showHSCHallTicket)?_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('candidateProfile.educationDetails.lblHSCHallTicketDoc')))]),_vm._v(" "),_c('img',{staticClass:"dpic documentImg img-fluid img-thumbnail",attrs:{"src":_vm.hscHallTicketsrc}})]):_vm._e(),_vm._v(" "),(_vm.showHSCHallTicket)?_c('div',{class:_vm.hscHallTicketsrc ? 'col-9' : 'col-12'},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('candidateProfile.educationDetails.lblHSCHallTicketDoc')))]),_vm._v(" "),_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone4","options":_vm.dropzoneOptions},on:{"vdropzone-file-added":function($event){_vm.fileAdded('HSCHallTicket',$event)},"vdropzone-removed-file":_vm.fileRemoved}}),_vm._v(" "),_c('small',{staticClass:"text-info"},[_vm._v("Document size should be less than 1MB")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:" row text-center p-3"},[_c('button',{staticClass:"btn btn btn-info-alt mr-3",attrs:{"type":"button"},on:{"click":_vm.prevTabFunc}},[_vm._v(" "+_vm._s(_vm.$t('button.back')))]),_vm._v(" "),_c('button',{staticClass:"btn btn btn-orange ml-auto",attrs:{"type":"button"},on:{"click":_vm.nextTabFunc}},[_vm._v(" "+_vm._s(_vm.$t('button.next')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading===true),expression:"loading===true"}],staticClass:"loader-wraper"},[_vm._m(1)]),_vm._v(" "),(_vm.showSSCModal)?_c('modal',{staticClass:"lg",on:{"close":function($event){_vm.showSSCModal = false}}},[_c('h3',{slot:"header"},[_vm._v("SSC Document")]),_vm._v(" "),_c('div',{slot:"body"},[_c('img',{attrs:{"src":_vm.sscsrc,"width":"100%"}})])]):_vm._e(),_vm._v(" "),(_vm.showHSCModal)?_c('modal',{staticClass:"lg",on:{"close":function($event){_vm.showHSCModal = false}}},[_c('h3',{slot:"header"},[_vm._v("HSC Document")]),_vm._v(" "),_c('div',{slot:"body"},[_c('img',{attrs:{"src":_vm.hscsrc,"width":"100%"}})])]):_vm._e(),_vm._v(" "),(_vm.showDiplomaModal)?_c('modal',{staticClass:"lg",on:{"close":function($event){_vm.showDiplomaModal = false}}},[_c('h3',{slot:"header"},[_vm._v("DIploma Document")]),_vm._v(" "),_c('div',{slot:"body"},[_c('img',{attrs:{"src":_vm.diplomasrc,"width":"100%"}})])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2 lighten text-right"},[_c('h2',{staticClass:"page-title"},[_vm._v("68%")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-box"},[_c('div',{staticClass:"lds-roller"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')]),_vm._v(" "),_c('h6',{staticClass:"mt-2"},[_vm._v("Please wait...")])])}]


/***/ }),

/***/ "bREw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");


var _mutations;


var state = {
  userDetails: { profilePhotoUrl: 'static/assets/images/dummy.png', confirmStatus: false, fullName: '' },
  loading: false
};
var getters = {
  getuserDetails: function getuserDetails(state) {
    return state.userDetails;
  },

  getLoader: function getLoader(state) {
    return state.loading;
  }
};
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* STORE_PROFILE_USER_DETAILS */], function (state, data) {
  state.userDetails = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* STORE_PROFILE_USER_PHOTO */], function (state, data) {
  state.userDetails.profilePhotoUrl = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* STORE_PROFILE_USER_NAME */], function (state, data) {
  state.userDetails.fullName = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* STORE_CONFIRM_STATUS */], function (state, data) {
  state.userDetails.confirmStatus = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* STORE_LOADING */], function (state, data) {
  state.loading = data;
}), _mutations);
var actions = {};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "bpFM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_vue__ = __webpack_require__("dzP6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Sidebar',
  components: { Language: __WEBPACK_IMPORTED_MODULE_1__language_vue__["a" /* default */] },
  data: function data() {
    return {
      selected: '',
      instructions: {},
      docImagePath: 'static/assets/images/dummy.png'
    };
  },
  mounted: function mounted() {
    this.getUserDetails();
  },

  methods: {
    getUserDetails: function getUserDetails() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/r/entry/getUserDetails/' + this.$store.state.candidateProfile.profileUser).then(function (response) {
        if (response.data !== null) {
          _this.$store.commit('STORE_PROFILE_USER_DETAILS', response.data);
          if (response.data.profilePhotoUrl === '') {
            _this.$store.commit('STORE_PROFILE_USER_PHOTO', _this.docImagePath);
          }
          if (_this.$store.state.user.userDetails !== undefined) {
            if (_this.$store.state.user.userDetails.profileUrl !== '') {
              _this.docImagePath = _this.$store.state.user.userDetails.profilePhotoUrl;
            }
            // this.username = this.$store.state.user.userDetails.fullName
          }
          /* this.$store.commit('STORE_PROFILE_USER_DETAILS', response.data)
          if (this.$store.state.user.userDetails.personalDetails !== undefined) {
            for (let docImage = 0; docImage < this.$store.state.user.userDetails.documents.length; docImage++) {
              if (this.$store.state.user.userDetails.documents[docImage].docId === this.$store.state.candidateProfile.profileUser + '_ProfilePicture') {
                this.docImagePath = this.$store.state.user.userDetails.documents[docImage].docImage
                break
              } else {
                this.docImagePath = 'static/assets/images/dummy.png'
              }
            } */
        }
      }).catch(function (e) {
        console.error(e);
      });
    },
    logout: function logout() {
      var self = this;
      window.MKCLAPI.logout().then(function (response) {
        self.$toasted.success(self.$t('sideBar.tostrLogout'));
        window.location.href = self.MFS_REGISTRATION_URL;
      }).catch(function (e) {
        console.error(e);
      });
    }
  }
});

/***/ }),

/***/ "broi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      user: {},
      universityConfig: { state: {} },
      userExists: false,
      currentServerDate: '',
      applicationStartDate: '',
      applicationEndDate: ''
    };
  },

  computed: {
    isUserExists: function isUserExists() {
      return this.userExists;
    }
  },
  methods: {
    signUp: function signUp() {
      //   if (this.currentServerDate < this.applicationEndDate) {
      //     this.toasted.error('Registration has been closed on date : ')
      //     return false
      //   } else {
      this.$router.push('signup');
      //  }
    },
    loginWithMkcl: function loginWithMkcl(clientId) {
      // window.MKCLAPI.login()
      window.MKCLAPI.switchAppWithSingleSignOn(clientId);
    },
    getLogoUrl: function getLogoUrl(abbr) {
      return 'static/assets/images/' + abbr + '.png';
    },

    // getUser () {
    //   axios
    //     .post(window.lcmsserver + '/o/lcmslogin/getuser', this.user)
    //     .then(response => {
    //       console.log('login response = ' + JSON.stringify(response))
    //       if (response != null && response.data === 'User_Not_Found') {
    //         // Vue.toasted.error('Invalid UserName', {
    //         //   theme: 'bubble',
    //         //   duration: 6000
    //         // })
    //         alert(response)
    //         this.userExists = false
    //       } else {
    //         this.userExists = true
    //       }
    //     })
    //     .catch(e => {
    //       console.log(e)
    //       this.userExists = false
    //       alert('Something went wrong while login')
    //     })
    //   this.userExists = true
    // },
    login: function login() {
      this.$store.dispatch('validateUser', this.user);
    },
    getProjectConfig: function getProjectConfig() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('o/projectConfig/getUniversityConfig').then(function (response) {
        _this.universityConfig = response.data;
      }).catch(function (e) {
        console.error(e);
      });
      // This method get application start date and end date.
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('o/projectConfig/getStartEndDate').then(function (responses) {
        _this.applicationStartDate = new Date(responses.data.startDate);
        _this.applicationEndDate = new Date(responses.data.endDate);
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('o/projectConfig/getCurrentServerDateTime').then(function (response) {
          _this.currentServerDate = new Date(response.data);
        }).catch(function (e) {
          console.error(e);
        });
      }).catch(function (e) {
        console.error(e);
      });
    },
    backToLoginForm: function backToLoginForm() {
      this.userExists = false;
    }
  },
  created: function created() {
    window.sessionStorage.removeItem('vuex');
    window.localStorage.clear();
    window.sessionStorage.clear();
    this.$store.commit('STORE_CLEAR_ALL');
    window.MKCLAPI.deleteAllCookies();
    window.document.title = 'Login Page';
    this.getProjectConfig();
  },
  filters: {
    formatDate: function formatDate(value) {
      if (value) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(String(value)).format('DD-MMM-YYYY');
      }
    }
  }
});

/***/ }),

/***/ "d9E2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{staticClass:"row justify-content-center p-details",attrs:{"action":"POST","data-vv-scope":"form-1"},on:{"submit":function($event){$event.preventDefault();_vm.save('form-1')}}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group custom-input"},[_c('div',{staticClass:"para"},[_vm._v("I have completed ssc ")]),_vm._v(" "),_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|not_in:Select'),expression:"'required|not_in:Select'"}],class:{'form-error': _vm.errors.has('board')},attrs:{"label":"boardName","options":_vm.boardList,"error-messages":_vm.errors.collect('board'),"data-vv-name":"board","name":"board","placeholder":"Select Board","required":""},model:{value:(_vm.selectedBoard),callback:function ($$v) {_vm.selectedBoard=$$v},expression:"selectedBoard"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v("On date")]),_vm._v(" "),_c('date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'form-error': _vm.errors.has('dateofResult'),'input': true, 'is-danger': _vm.errors.collect('dateofResult') },attrs:{"name":"dateofResult","option":_vm.option,"limit":_vm.limit,"data-vv-name":"dateofResult","data-vv-validate-on":"change"},model:{value:(_vm.startTime),callback:function ($$v) {_vm.startTime=$$v},expression:"startTime"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(" having RollNo / Seat No ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.educationDetails.seatNumber),expression:"educationDetails.seatNumber"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control-alt col-6",class:{'form-error': _vm.errors.has('form-1.Seat No'),'input': true, 'is-danger': _vm.errors.has('form-1.Seat No') },attrs:{"name":"Seat No","id":"namelc","type":"text","placeholder":"Roll/Seat No"},domProps:{"value":(_vm.educationDetails.seatNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.educationDetails.seatNumber=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(".Completed SSC with ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.educationDetails.totalMarksObtained),expression:"educationDetails.totalMarksObtained"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control-alt",class:{'form-error': _vm.errors.has('form-1.Total Mark'),'input': true, 'is-danger': _vm.errors.has('form-1.Total Mark') },attrs:{"name":"Total Mark","id":"totalMark","type":"text","placeholder":"Mark Obtained"},domProps:{"value":(_vm.educationDetails.totalMarksObtained)},on:{"input":function($event){if($event.target.composing){ return; }_vm.educationDetails.totalMarksObtained=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v("Out of")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.educationDetails.outOf),expression:"educationDetails.outOf"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control-alt",class:{'form-error': _vm.errors.has('form-1.Out Of'),'input': true, 'is-danger': _vm.errors.has('form-1.Out Of') },attrs:{"name":"Out Of","id":"outOf","type":"text","placeholder":"Out Of"},domProps:{"value":(_vm.educationDetails.outOf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.educationDetails.outOf=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v("Marksheet No")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.educationDetails.marksheetNo),expression:"educationDetails.marksheetNo"}],staticClass:"form-control-alt",class:{'form-error': _vm.errors.has('form-1.Marksheet No'),'input': true, 'is-danger': _vm.errors.has('form-1.Marksheet No') },attrs:{"name":"Marksheet No","id":"panNo","type":"text","placeholder":"Marksheet No"},domProps:{"value":(_vm.educationDetails.marksheetNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.educationDetails.marksheetNo=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success-alt text-center",attrs:{"type":"button"},on:{"click":_vm.saveSSCDetails}},[_vm._v("Save")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])}]


/***/ }),

/***/ "dHr3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_modal_vue__ = __webpack_require__("yN8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_candidateProfile__ = __webpack_require__("3rUF");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_0_axios___default.a.default.baseURL = '';
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profileSummary',
  components: { modal: __WEBPACK_IMPORTED_MODULE_2__components_common_modal_vue__["a" /* default */], candidateProfile: __WEBPACK_IMPORTED_MODULE_3__store_modules_candidateProfile__["a" /* default */] },
  data: function data() {
    return {
      candidateProfile: {
        personalDetails: {
          gender: {},
          maritalStatus: {},
          motherTongue: {}
        },
        contactDetails: { permanentAddress: {}, corespondeneceAddress: {} },
        documents: [],
        educationDetails: {},
        experienceDetails: [],
        hobbies: [],
        knownLanguages: [],
        knownTechnologies: [],
        itCertificationsDetails: {
          itCertification: {}
        }
      },
      profilesrc: '',
      sscsrc: '',
      hscsrc: '',
      diplomasrc: '',
      corespondenceAddress: {},
      permanentAddress: {},
      address: {},
      correspondanceSameAspermananent: false,
      showSSC: false,
      showHSC: false,
      showDiploma: false,
      screenConfig: {}
    };
  },

  methods: {
    nextTabFunc: function nextTabFunc() {
      var _this = this;

      var self = this;
      if (this.candidateProfile.profileStatus.itCertificationsDetails && this.candidateProfile.profileStatus.personalDetails && this.candidateProfile.profileStatus.contactDetails && this.candidateProfile.profileStatus.educationDetails && this.candidateProfile.profileStatus.documentDetails && this.candidateProfile.profileStatus.qualificationDetails) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('r/candidateProfile/confirmProfile/' + this.$store.state.candidateProfile.profileUser).then(function (response) {
          if (response.status === 200) {
            _this.$toasted.success(self.$t('toastr.toastrProfileCompleted'));
            _this.$store.commit('STORE_CONFIRM_STATUS', true);
            _this.$router.push({ name: 'candidateApplication' });
          }
        }).catch(function (e) {
          console.log(e);
        });
      } else {
        this.$toasted.error(self.$t('candidateProfile.profileSummary.toastrFillAllSections'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        });
      }
    },
    prevTabFunc: function prevTabFunc() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('r/projectConfig/getAllProjectConfig').then(function (responses) {
        if (responses.data.ocrConfig.required) {
          _this2.$router.push({ name: 'imageExtracter' });
        } else {
          _this2.$router.push({ name: 'qualificationDetails' });
        }
      }).catch(function (e) {
        console.log(e);
      });
    },

    getCompleteCandidateProfile: function getCompleteCandidateProfile() {
      var _this3 = this;

      var self = this;
      var profileUser = this.$store.state.candidateProfile.profileUser;
      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/r/candidateProfile/getCompleteCandiateProfile/' + profileUser).then(function (response) {
        if (response.data !== null) {
          _this3.candidateProfile = response.data;
          if (_this3.candidateProfile.contactDetails.corespondenecePin != null && _this3.candidateProfile.contactDetails.permanentPin) {
            if (_this3.candidateProfile.contactDetails.corespondenecePin === _this3.candidateProfile.contactDetails.permanentPin) {
              _this3.correspondanceSameAspermananent = true;
              // this.getCompleteAddress(this.candidateProfile.contactDetails.corespondenecePin)
              _this3.getDocuments();
            } else {
              _this3.correspondanceSameAspermananent = false;
              // this.getCompleteAddress(this.candidateProfile.contactDetails.corespondenecePin)
              // this.getCompleteAddress(this.candidateProfile.contactDetails.permanentPin)
              _this3.getDocuments();
            }
          }
        }
        return true;
      }).catch(function (e) {
        _this3.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: _this3.TOASTR_TIME
        });
        console.error(e);
        return false;
      });
    },
    getCompleteAddress: function getCompleteAddress(pincode) {
      var _this4 = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/r/candidateProfile/getCompleteAddressOfPincode/' + pincode).then(function (response) {
        if (response.data !== null) {
          if (response.data === 'false') {
            _this4.$toasted.info(self.$t('candidateProfile.profileSummary.toastrPinCodeNotFound'), {
              theme: 'bubble',
              duration: _this4.TOASTR_TIME
            });
          } else {
            if (_this4.correspondanceSameAspermananent === true) {
              _this4.corespondenceAddress = response.data;
              _this4.permanentAddress = _this4.corespondenceAddress;
            } else if (_this4.candidateProfile.contactDetails.corespondenecePin === pincode) {
              _this4.corespondenceAddress = response.data;
            } else {
              _this4.permanentAddress = response.data;
            }
          }
        } else {
          _this4.$toasted.error(self.$t('candidateProfile.profileSummary.toastrPinCodeNotFound'), {
            theme: 'bubble',
            duration: _this4.TOASTR_TIME
          });
        }
      }).catch(function (e) {
        _this4.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: _this4.TOASTR_TIME
        });
        console.error(e);
      });
    },
    changeTab: function changeTab(oldIndex, newIndex) {
      this.$emit('nextTab', oldIndex, newIndex);
    },
    getDocuments: function getDocuments() {
      var doc = this;
      var profileUser = this.$store.state.candidateProfile.profileUser;
      var myarray = doc.candidateProfile.documents;
      myarray.forEach(function (element) {
        if (element.docId === profileUser + '_ProfilePicture') {
          doc.profilesrc = element.docImage;
        } else if (element.docId === profileUser + '_SSC') {
          doc.sscsrc = element.docImage;
        } else if (element.docId === profileUser + '_HSC') {
          doc.hscsrc = element.docImage;
        } else if (element.docId === profileUser + '_Diploma') {
          doc.diplomasrc = element.docImage;
        } else {}
      });
    },
    getProjectConfig: function getProjectConfig() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('o/screenConfig/getScreenConfigByID/' + 'IT_CERTIFICATION').then(function (response) {
        _this5.screenConfig = response.data;
      }).catch(function (e) {
        console.error(e);
      });
    }
  },
  created: function created() {
    if (this.$store.state.user.userDetails.confirmStatus) {
      this.$router.push({ name: 'entry' });
    } else {
      this.getProjectConfig();
      this.getCompleteCandidateProfile();
    }
  },
  filters: {
    formatDate: function formatDate(value) {
      if (value) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(String(value)).format('DD-MMM-YYYY');
      }
    }
  }
});

/***/ }),

/***/ "dTzQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_modal_vue__ = __webpack_require__("yN8m");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'workPlace',
  components: { modal: __WEBPACK_IMPORTED_MODULE_1__components_common_modal_vue__["a" /* default */] },
  data: function data() {
    return {
      searchBox: '',
      workPlaceList: [],
      selectedWorkPlaceList: [],
      courseUniObj: {},
      universityConfig: {},
      instructions: {},
      showConfirmation: false
    };
  },

  computed: {
    // Filter work place list for search box.
    filterWorkPlaceList: function filterWorkPlaceList() {
      var self = this;
      return self.workPlaceList.filter(function (user) {
        var searchRegex = new RegExp(self.searchBox, 'i');
        return searchRegex.test(user.districtName);
      });
    }
  },
  methods: {
    // This method play audio.
    playInstructionAudio: function playInstructionAudio() {
      this.$refs.instrAudioModalRef.show();
      this.$refs.audioRef.src = this.instructions.audioURL;
      this.$refs.audioRef.play();
    },

    // This method hide details audio.
    hideAudioModal: function hideAudioModal() {
      this.$refs.instrAudioModalRef.hide();
      this.$refs.audioRef.pause();
    },

    // This method play audio.
    playInstructionVideo: function playInstructionVideo() {
      this.$refs.instrVideoModalRef.show();
      this.$refs.instrVideoRef.src = this.instructions.videoURL + '?autoplay=0';
    },

    // This method hide details audio.
    hideInstructionVideoModal: function hideInstructionVideoModal() {
      this.$refs.instrVideoRef.src = this.instructions.videoURL + '?autoplay=0';
      this.$refs.instrVideoModalRef.hide();
    },

    getInstruction: function getInstruction() {
      var _this = this;

      // This method get Industry partner instructions .
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('r/getGeneralInstructions/' + 'WorkPlacePage').then(function (response) {
        if (response.status === 200) {
          _this.instructions = response.data;
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    // Change the sequence of work place. (Decrease sequence)
    upSequence: function upSequence(item) {
      for (var k in this.selectedWorkPlaceList) {
        if (this.selectedWorkPlaceList[k].districtID === item.districtID) {
          var seq1 = this.selectedWorkPlaceList[k];
          seq1.sequence = item.sequence - 1;
          var seq2 = this.selectedWorkPlaceList[parseInt(k) - 1];
          seq2.sequence = item.sequence + 1;
          this.selectedWorkPlaceList.splice(parseInt(k) - 1, 2, seq1, seq2);
          break;
        }
      }
    },

    // Change the sequence of work place. (Increase sequence)
    downSequence: function downSequence(item) {
      for (var k in this.selectedWorkPlaceList) {
        if (this.selectedWorkPlaceList[k].districtID === item.districtID) {
          var seq1 = this.selectedWorkPlaceList[k];
          seq1.sequence = item.sequence + 1;
          var seq2 = this.selectedWorkPlaceList[parseInt(k) + 1];
          seq2.sequence = item.sequence - 1;
          this.selectedWorkPlaceList.splice(k, 2, seq2, seq1);
          break;
        }
      }
    },

    // Selecting the work place for application (Auto sequence).
    copyWorkPlace: function copyWorkPlace(item) {
      var dataFound = false;
      for (var i in this.selectedWorkPlaceList) {
        if (item.districtID === this.selectedWorkPlaceList[i].districtID) {
          dataFound = true;
          this.$toasted.info(this.$t('workPlace.toastrExistData'), {
            theme: 'bubble',
            duration: this.TOASTR_TIME
          });
          break;
        }
      }
      if (dataFound === false) {
        item.sequence = this.selectedWorkPlaceList.length + 1;
        this.selectedWorkPlaceList.push(item);
        this.$toasted.info(item.districtName + ' ' + this.$t('workPlace.toastrAddedInCart'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        });
      }
      for (var j in this.workPlaceList) {
        if (item.districtID === this.workPlaceList[j].districtID) {
          this.workPlaceList.splice(j, 1);
          break;
        }
      }
    },

    // Remove the selected work place from list. (Delete)
    removeWorkPlace: function removeWorkPlace(item) {
      this.workPlaceList.push(item);
      for (var j in this.selectedWorkPlaceList) {
        if (item.districtID === this.selectedWorkPlaceList[j].districtID) {
          this.selectedWorkPlaceList.splice(j, 1);
          for (var k in this.selectedWorkPlaceList) {
            if (this.selectedWorkPlaceList[k].sequence > item.sequence) {
              this.selectedWorkPlaceList[k].sequence--;
            }
          }
          this.$toasted.info(item.districtName + ' ' + this.$t('workPlace.toastrDelete'), {
            theme: 'bubble',
            duration: this.TOASTR_TIME
          });
          break;
        }
      }
    },
    getProjectConfig: function getProjectConfig() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('o/projectConfig/getUniversityConfig').then(function (response) {
        _this2.universityConfig = response.data;
        _this2.getAllData();
      }).catch(function (e) {
        console.error(e);
      });
    },

    getAllData: function getAllData() {
      var _this3 = this;

      // Get work place list.
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('r/workPlace/getWorkPlaceListRoute').then(function (response) {
        _this3.workPlaceList = response.data;
        var tempDistrictObj = { 'districtID': 10001, 'sequence': 0, 'districtName': ' Any where in ' + _this3.universityConfig.state.stateName };
        _this3.workPlaceList.push(tempDistrictObj);
      }).catch(function (e) {
        console.log('error in get work place list');
        console.log(e);
      });
      // Get course and university details.
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('r/workPlace/getCourseUniversityByID/' + this.$route.params.courseID + '/' + this.$route.params.universityID).then(function (response) {
        _this3.courseUniObj = response.data;
      }).catch(function (e) {
        console.log('error in get work place list');
        console.log(e);
      });
    },
    save: function save() {
      var _this4 = this;

      // This method validate workplace. (At least one workplace should be selected for procced)
      if (this.selectedWorkPlaceList.length < 1) {
        this.$toasted.info(this.$t('workPlace.toastrWarningForSelection'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        });
        return false;
      }
      // This method save workplace list in user application details in candidate_application collection(mongoDB).
      var userName = this.$store.state.candidateProfile.profileUser;
      var courseID = this.$route.params.courseID;
      var universityID = this.$route.params.universityID;
      var allOverStateExist = false;
      for (var index = 0; index < this.selectedWorkPlaceList.length; index++) {
        if (this.selectedWorkPlaceList[index].districtID === 10001) {
          allOverStateExist = true;
        }
      }
      if (allOverStateExist === false) {
        var tempDistrictObj = { 'districtID': 10001, 'sequence': this.selectedWorkPlaceList.length + 1, 'districtName': ' Any where in ' + this.universityConfig.state.stateName };
        this.selectedWorkPlaceList.push(tempDistrictObj);
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('r/workPlace/saveWorkPlaceListRoute/' + userName + '/' + courseID + '/' + universityID, this.selectedWorkPlaceList).then(function (response) {
        if (response.status === 200) {
          _this4.$toasted.success(_this4.$t('workPlace.toastrSaveData'));
          _this4.$store.commit('STORE_CONFIRM_STATUS', true);
          window.MKCLAPI.switchAppWithSingleSignOn(_this4.MFS_CLIENT_ID);
        }
      }).catch(function (e) {
        console.log('error in save methods');
        console.log(e);
      });
    }
  },
  created: function created() {
    if (this.$route.params.courseID === undefined || this.$route.params.courseID === null || this.$route.params.courseID === '' || this.$route.params.universityID === undefined || this.$route.params.universityID === null || this.$route.params.universityID === '') {
      this.$router.push({ name: 'candidateApplication' });
    } else {
      this.getProjectConfig();
      this.getInstruction();
    }
  }
});

/***/ }),

/***/ "deAl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__ = __webpack_require__("3kHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("2+hT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__itCertification_vue__ = __webpack_require__("SEAD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__personalDetails_vue__ = __webpack_require__("g5EO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__address_vue__ = __webpack_require__("xtL+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__educationalDetails_vue__ = __webpack_require__("Af9h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__profileSummary_vue__ = __webpack_require__("e/V6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__imageExtracter_vue__ = __webpack_require__("C1Az");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Registraiton',
  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["TabContent"],
    itCertification: __WEBPACK_IMPORTED_MODULE_3__itCertification_vue__["a" /* default */],
    personalDetails: __WEBPACK_IMPORTED_MODULE_4__personalDetails_vue__["a" /* default */],
    candidateAddress: __WEBPACK_IMPORTED_MODULE_5__address_vue__["a" /* default */],
    educationalDetails: __WEBPACK_IMPORTED_MODULE_6__educationalDetails_vue__["a" /* default */],
    imageExtracter: __WEBPACK_IMPORTED_MODULE_8__imageExtracter_vue__["a" /* default */],
    documentsuploader: function documentsuploader() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "obgm"));
    },
    profileSummary: __WEBPACK_IMPORTED_MODULE_7__profileSummary_vue__["a" /* default */]
  },
  data: function data() {
    return {
      selected: '',
      loadPersonal: false,
      loadContact: false,
      loadEducation: false,
      loadProfile: false,
      loadDoc: false,
      loadImageExtracter: false,
      tabName: '',
      currentTab: '',
      totalTabs: 6,
      percentage: 0,
      counter: 0
    };
  },

  methods: {
    setLoading: function setLoading(isValid, tabIndex) {
      console.log('Tab: ' + tabIndex + ' valid: ' + isValid);
    },
    nextTab: function nextTab(val1, val2) {
      this.$refs.wizard.changeTab(val1, val2);
    },

    onComplete: function onComplete() {
      var _this = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('r/candidateProfile/confirmProfile/' + this.$store.state.candidateProfile.profileUser).then(function (response) {
        if (response.status === 200) {
          _this.$toasted.success(self.$t('toastr.toastrProfileCompleted'), {
            theme: 'bubble',
            duration: _this.TOASTR_TIME
          });
          _this.$router.push({ name: 'candidateApplication' });
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    onChange: function onChange(val1, val2) {
      /* if (val2 !== 1) {
        this.$refs.personalDetails.scanAadhar = false
      } */
      if (val2 === 1) {
        this.loadPersonal = true;
        this.loadDoc = false;
        this.tabName = this.$t('registration.tabs.tabPersonalDetails');
        this.currentTab = 'Personal details';
      } else if (val2 === 2) {
        this.loadContact = true;
        this.loadDoc = false;
        this.tabName = this.$t('registration.tabs.tabContactDetails');
        this.currentTab = 'Contact Details';
      } else if (val2 === 3) {
        this.loadEducation = true;
        this.loadDoc = false;
        this.tabName = this.$t('registration.tabs.tabEducationDetails');
        this.currentTab = 'Educational Details';
      } else if (val2 === 4) {
        this.loadDoc = true;
        this.tabName = this.$t('registration.tabs.tabDocumentUpload');
        this.currentTab = 'Documents Upload';
      } else if (val2 === 6) {
        this.loadProfile = true;
        this.loadDoc = false;
        this.tabName = this.$t('registration.tabs.tabProfileSummary');
        this.currentTab = 'Profile Summary';
      } else if (val2 === 0) {
        this.tabName = this.$t('registration.tabs.tabITLiteracy');
        this.currentTab = 'IT Certification';
        this.loadDoc = false;
      } else if (val2 === 5) {
        this.loadImageExtracter = true;
        this.loadDoc = false;
        this.tabName = this.$t('registration.tabs.tabImageExtractor');
        this.currentTab = 'Image Extracter';
      }
      if (val1 < val2 && this.percentage < 100) {
        this.counter++;
      } else {
        this.counter--;
      }
      this.percentage = this.counter / this.totalTabs * 100;
      var precision = Math.pow(10, 0);
      this.percentage = Math.ceil(this.percentage * precision) / precision;
    },
    beforeCertificateTabSwitch: function beforeCertificateTabSwitch() {
      return this.$refs.certificate.validateLearnerCode('form-1');
    },
    beforePersonalTabSwitch: function beforePersonalTabSwitch() {
      return this.$refs.personalDetails.checkAadhaarValidity('form-1');
    },
    beforeContactTabSwitch: function beforeContactTabSwitch() {
      return this.$refs.address.validateInput('Contactform');
    },
    beforeImageExtractorTabSwitch: function beforeImageExtractorTabSwitch() {
      return this.$refs.imageExtractor.save('form-1');
    },
    beforeEducationTabSwitch: function beforeEducationTabSwitch() {
      return this.$refs.education.saveDetails('educationForm');
    },
    beforeDocUploadTabSwitch: function beforeDocUploadTabSwitch() {
      return this.$refs.document.documentStatus();
    },
    beforeSummaryTabSwitch: function beforeSummaryTabSwitch() {
      return true;
    }
  },
  created: function created() {
    this.tabName = this.$t('registration.tabs.tabITLiteracy');
    this.currentTab = 'IT Certification';
  }
});

/***/ }),

/***/ "dzP6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_language_vue__ = __webpack_require__("I5Xq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5284617c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_language_vue__ = __webpack_require__("L9rW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("9w64")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_language_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5284617c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_language_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5284617c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_language_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e/V6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profileSummary_vue__ = __webpack_require__("dHr3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3656caa0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profileSummary_vue__ = __webpack_require__("UTrd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Y2Vg")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profileSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3656caa0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profileSummary_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3656caa0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profileSummary_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eXtr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid login",staticStyle:{"background":"url('static/assets/images/login/bg1.jpg')"}},[_c('div',{staticClass:"row "},[_c('div',{staticClass:"col-sm-5 login-box align-self-center"},[_c('div',{staticClass:" v-middle align-content-center no-gutters pb-70"},[_c('img',{staticClass:"login-logo",attrs:{"src":"static/assets/images/mfs-logo.png","alt":""}}),_vm._v(" "),_c('div',{staticClass:"title-heading"},[_c('h1',[_vm._v(_vm._s(_vm.$t('login.lblHeading1')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('login.lblHeading2')))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('form',[_c('button',{staticClass:"btn btn-orange mr-2",attrs:{"type":"button"},on:{"click":_vm.signUp}},[_vm._v(_vm._s(_vm.$t('button.signUp')))]),_vm._v(" "),_c('b-dropdown',{staticClass:"btn-orange-wrapper",attrs:{"id":"ddown1","right":"","text":"Login"}},[_c('b-dropdown-item',{attrs:{"show":""},on:{"click":function($event){_vm.loginWithMkcl(_vm.MFS_APPLICANT_ID)}}},[_vm._v(_vm._s(_vm.$t('login.lblApplicant')))]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"show":""},on:{"click":function($event){_vm.loginWithMkcl(_vm.MFS_INDUSTRY_PARTNER_ID)}}},[_vm._v(_vm._s(_vm.$t('login.lblIP')))]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"show":""},on:{"click":function($event){_vm.loginWithMkcl(_vm.MFS_ASC_ID)}}},[_vm._v(_vm._s(_vm.$t('login.lblASC')))])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"text-left mt-4 start-date"},[(_vm.currentServerDate.getTime() < _vm.applicationStartDate.getTime())?_c('h5',[_vm._v(_vm._s(_vm.$t('registration.lblStartReg'))+" "),_c('b',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.applicationStartDate)))])]):_vm._e(),_vm._v(" "),(_vm.currentServerDate.getTime() >= _vm.applicationStartDate.getTime() && _vm.currentServerDate.getTime() <= _vm.applicationEndDate.getTime())?_c('h5',[_vm._v(_vm._s(_vm.$t('registration.lblGoingReg'))),_c('b',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.applicationEndDate)))])]):_vm._e(),_vm._v(" "),(_vm.currentServerDate.getTime() > _vm.applicationEndDate.getTime())?_c('h5',[_c('span',{staticClass:"red"},[_vm._v(_vm._s(_vm.$t('registration.lblEndReg'))+" "),_c('b',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.applicationEndDate)))])])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"logo-box"},[_c('img',{staticClass:"mkcl-logo",attrs:{"src":"static/assets/images/logo_mkcl-s.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"mkcl-logo right",attrs:{"src":_vm.getLogoUrl(_vm.universityConfig.abbr),"alt":""}})])])])}
var staticRenderFns = []


/***/ }),

/***/ "emyr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"picture-input",attrs:{"id":"picture-input"}},[(!_vm.supportsUpload)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.strings.upload)}}):(_vm.supportsPreview)?_c('div',[_c('div',{staticClass:"preview-container",style:({maxWidth: _vm.previewWidth + 'px', height: _vm.previewHeight + 'px', borderRadius: _vm.radius + '%'})},[_c('canvas',{ref:"previewCanvas",staticClass:"picture-preview",class:_vm.computedClasses,style:({height: _vm.previewHeight + 'px', zIndex: _vm.zIndex + 1 }),on:{"drag":function($event){$event.stopPropagation();$event.preventDefault();},"dragover":function($event){$event.stopPropagation();$event.preventDefault();},"dragstart":function($event){$event.stopPropagation();$event.preventDefault();_vm.onDragStart($event)},"dragenter":function($event){$event.stopPropagation();$event.preventDefault();_vm.onDragStart($event)},"dragend":function($event){$event.stopPropagation();$event.preventDefault();_vm.onDragStop($event)},"dragleave":function($event){$event.stopPropagation();$event.preventDefault();_vm.onDragStop($event)},"drop":function($event){$event.stopPropagation();$event.preventDefault();_vm.onFileDrop($event)},"click":function($event){$event.preventDefault();_vm.onClick($event)}}}),_vm._v(" "),(!_vm.imageSelected && !_vm.plain)?_c('div',{staticClass:"picture-inner",style:({top: -_vm.previewHeight + 'px', marginBottom: -_vm.previewHeight + 'px', fontSize: _vm.fontSize, borderRadius: _vm.radius + '%', zIndex: _vm.zIndex + 2})},[(_vm.supportsDragAndDrop)?_c('span',{staticClass:"picture-inner-text",domProps:{"innerHTML":_vm._s(_vm.strings.drag)}}):_c('span',{staticClass:"picture-inner-text",domProps:{"innerHTML":_vm._s(_vm.strings.tap)}})]):_vm._e()]),_vm._v(" "),(_vm.imageSelected && !_vm.hideChangeButton)?_c('button',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();_vm.selectImage($event)}}},[_vm._v(_vm._s(_vm.strings.change))]):_vm._e(),_vm._v(" "),(_vm.imageSelected && _vm.removable)?_c('button',{class:_vm.removeButtonClass,on:{"click":function($event){$event.preventDefault();_vm.removeImage($event)}}},[_vm._v(_vm._s(_vm.strings.remove))]):_vm._e(),_vm._v(" "),(_vm.imageSelected && _vm.toggleAspectRatio && _vm.width !== _vm.height)?_c('button',{class:_vm.aspectButtonClass,on:{"click":function($event){$event.preventDefault();_vm.rotateImage($event)}}},[_vm._v(_vm._s(_vm.strings.aspect))]):_vm._e()]):_c('div',[(!_vm.imageSelected)?_c('button',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();_vm.selectImage($event)}}},[_vm._v(_vm._s(_vm.strings.select))]):_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.strings.selected)}}),_vm._v(" "),(!_vm.hideChangeButton)?_c('button',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();_vm.selectImage($event)}}},[_vm._v(_vm._s(_vm.strings.change))]):_vm._e(),_vm._v(" "),(_vm.removable)?_c('button',{class:_vm.removeButtonClass,on:{"click":function($event){$event.preventDefault();_vm.removeImage($event)}}},[_vm._v(_vm._s(_vm.strings.remove))]):_vm._e()])]),_vm._v(" "),_c('input',{ref:"fileInput",attrs:{"type":"file","name":_vm.name,"id":_vm.id,"accept":_vm.accept},on:{"change":_vm.onFileChange}})])}
var staticRenderFns = []


/***/ }),

/***/ "f5FY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fH4b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fhYK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);


var axios = __webpack_require__("mtWM");
var jwtDecode = __webpack_require__("ytdl");

var config = {
  clientId: null,
  mkclLoginServerURL: null,
  mkclLoginClientURL: null
};
var loginWindow;
// var clientConfig = null
// const MKCL'_LOGIN_URL = 'http://10.4.0.46:8080/#/login'
var LOGOUT_API = '/r/logout';
var VALIDATE_TOKEN_API = '/o/isValidToken';
// const GET_CLIENT_CONFIG_API = '/o/getclientconfig'
// const sid = config.clientId

// window.addEventListener('hashchange', function (e) {
//   alert('hash change')
//   initializeLoginPage()
//   // checkAuthentication()
// })

//  function checkAuthentication() {
//   if (!isLoginPage() && !isSessionPresent()) {
//     // means user is not authorize and trying to access unAuthorized pages
//     // alert('not login page session not present')
//     redirectToLogin()
//   }
//   if (isLoginPage() && isSessionPresent()) {
//     // alert(e.oldURL)
//     // alert('login page session present')
//     // redirect(e.oldURL)
//     redirect(returnUrl)
//   }
//  }

// window.addEventListener('load', function (e) {
//   if (isReturnUrlWithToken()) {
//     var token = getParameterByName('token')
//     setSession(token)
//   } else {
//     checkAuthentication()
//   }
// })

// function initializeLoginPage () {
//   var localloginBtn = document.getElementById('mkclSignIn')
//   // if (isLoginPage() && !isSesionPresent()) {
//   if (isLoginPage()) {
//     loginBtn = localloginBtn
//     returnUrl = localloginBtn.getAttribute('data-myReturnUrl')
//     // attaching listener on sign in clicked
//     // document.cookie = 'returnUrl=' + returnUrl
//     loginBtn.addEventListener('click', loginClicked)
//   }
// }

// function loginClicked () {
//   // alert('login clicked')
//   redirectToLogin()
// }

// function redirectToLogin () {
//   // var currentUrl = window.location.href
//   var loginUrlMKCLLoginUrl = MKCLLoginUrl + '?clientId=' + clientId
//   window.location.href = loginUrlMKCLLoginUrl
// }

function login() {
  // var currentUrl = window.location.href
  var MKCLLoginUrl = config.mkclLoginClientURL + '?clientId=' + config.clientId;
  // console.log(MKCLLoginUrl)
  loginWindow = window.open(MKCLLoginUrl, '_self');
}

function switchAppWithSingleSignOn(clientId) {
  // var currentUrl = window.location.href
  var MKCLLoginUrl = config.mkclLoginClientURL + '?clientId=' + clientId;
  // console.log(MKCLLoginUrl)
  loginWindow = window.open(MKCLLoginUrl, '_self');
}

function loginPoc() {
  // var currentUrl = window.location.href
  var MKCLLoginUrl = config.mkclLoginClientURL + '?clientId=' + config.clientId;
  alert(MKCLLoginUrl);
  loginWindow = window.open(MKCLLoginUrl, '_self');
  // window.location.href = MKCLLoginUrl
}
window.addEventListener('message', receiveMessage, false);

function receiveMessage(event) {
  // console.log(event.source.location.href)
  if (event.origin === 'http://10.4.1.248:8080') {
    alert('postmessage' + event.data);
    console.log(event);
  }
}
// function redirect (redirectTo) {
//   window.location.href = redirectTo
// }

// function getClientConfig () {
//   var executed = false
//   return new Promise((resolve, reject) => {
//     // alert('getclientconfig')
//     var getClientConfigUrl = config.mkclLoginServerURL + GET_CLIENT_CONFIG_API
//     if (!executed) {
//       axios.post(getClientConfigUrl, {
//         'clientId': clientConfig.clientId
//       }).then(function () {
//         resolve(true)
//       }).catch(function () {
//         reject(new Error('failed'))
//       })
//     }
//   })
// }
// function getClientConfig () {
//   // alert('getClientCOnfigCalled')
//   var executed = false
//   if (!executed) {
//     executed = true
//     var xmlhttp = new XMLHttpRequest()
//     var url = getClientConfigUrl
//     xmlhttp.onreadystatechange = function () {
//       if (this.readyState === 4 && this.status === 200) {
//         var responseData = JSON.parse(this.responseText)
//         // alert(responseData)
//         // console.log(responseData)
//         clientConfig = responseData
//         // sid = clientConfig.group.groupcode
//         //  alert('completed sid = '+ sid)
//       }
//     }
//     xmlhttp.open('POST', url, false)
//     xmlhttp.setRequestHeader('Content-type', 'application/json')
//     xmlhttp.send(JSON.stringify({'clientId': config.clientId}))
//   }
// }

// function isReturnUrlWithToken () {
//   var currentUrl = window.location.href
//   if (clientConfig !== undefined && clientConfig.purpose !== undefined) {
//     returnUrl = clientConfig.purpose.returnurl
//   }
//   // alert(returnUrl)
//   if (currentUrl.startsWith(returnUrl)) {
//     var token = getParameterByName('token', currentUrl)
//     if (isTokenNotNull(token)) {
//       return true
//     } else {
//       return false
//     }
//   } else {
//     return false
//   }
// }

// function isReturnUrl () {
//   var currentUrl = window.location.href
//   if (clientConfig !== undefined && clientConfig.purpose !== undefined) {
//     returnUrl = clientConfig.purpose.returnurl
//   }
//   // alert(returnUrl)
//   if (currentUrl.startsWith(returnUrl)) {
//     return true
//   } else {
//     return false
//   }
// }

// function getParameterByName (name, url) {
//   if (!url) url = window.location.href
//   name = name.replace(/[[]]/g, '\\$&')
//   var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
//   var results = regex.exec(url)
//   if (!results) return null
//   if (!results[2]) return ''
//   return decodeURIComponent(results[2].replace(/\+/g, ' '))
// }
function deleteAllCookies() {
  var cookies = document.cookie.split(';');

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf('=');
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }
}

function getCookieVal(offset) {
  var endstr = document.cookie.indexOf(';', offset);
  if (endstr === -1) {
    endstr = document.cookie.length;
  }
  return unescape(document.cookie.substring(offset, endstr));
}

function GetCookie(name) {
  var arg = name + '=';
  var alen = arg.length;
  var clen = document.cookie.length;
  var i = 0;
  while (i < clen) {
    var j = i + alen;
    if (document.cookie.substring(i, j) === arg) return getCookieVal(j);
    i = document.cookie.indexOf(' ', i) + 1;
    if (i === 0) break;
  }
  return null;
}
function removeToken() {
  deleteCookie(config.clientId);
}

function isSessionPresent() {
  var token = GetCookie(config.clientId);
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var validateTokenUrl = config.mkclLoginServerURL + VALIDATE_TOKEN_API;
    axios.post(validateTokenUrl, { 'clientId': config.clientId, 'token': token }).then(function (res) {
      resolve(res);
    }).catch(function (err) {
      removeToken();
      reject(err);
    });
  });
}

// function isLoginPage () {
//   var localloginBtn = document.getElementById('mkclSignIn')
//   if (localloginBtn != null) { return true } else { return false }
// }

// function setSession (token) {
//   if (isTokenNotNull(token)) {
//     // sessionStorage.setItem(sid, token)
//     document.cookie = sid + '=' + token
//   }
// }

function isLoggedIn() {
  // alert('function isLoggedIn()')
  var status = false;
  isSessionPresent().then(function () {
    status = true;
  }).catch(function () {
    status = false;
  });
  return status;
}

function deleteCookie(name) {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

// function isTokenNotNull (token) {
//   if (token === undefined || token === null || token === '' || token.length === 0) {
//     return false
//   }
//   return true
// }

// function removeGroupMembersCookies () {
//   console.log(clientConfig)
//   var groupmembers = clientConfig.group.groupmembers
//   for (var i = 0; i < groupmembers.length; i++) {
//     var sid = groupmembers[i]
//     // alert(groupmembers[i])
//     deleteCookie(sid)
//   }
// }
function logout() {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var logoutUrl = config.mkclLoginServerURL + LOGOUT_API;
    axios.get(logoutUrl).then(function () {
      // removeGroupMembersCookies()
      // deleteCookie(config.clientId)
      deleteAllCookies();
      resolve();
    }).catch(function (e) {
      reject(e);
    });
    // getClientConfig().then(function () {
    //   var logoutUrl = 'http://' + config.mkclLoginServerIp + LOGOUT_API
    //   axios.get(logoutUrl).then(function () {
    //     removeGroupMembersCookies()
    //     resolve()
    //   }).catch(function () {
    //     throw new Error('failed to logout')
    //   })
    // }).catch(function (e) {
    //   reject(e)
    // })
  });
}

function getToken() {
  return GetCookie(config.clientId);
}

// export {logout, isLoggedIn, getToken, login, isSessionPresent}

// var MKCLAPI = (function () {
//   return {
//     config: config,
//     getToken: getToken,
//     login: login,
//     logout: logout,
//     isLoggedIn: isLoggedIn,
//     isSessionPresent: isSessionPresent
//   }
// })()

function init(options) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(options).forEach(function (key) {
    config[key] = options[key];
  });
}

function getDecodedToken() {
  var token = getToken();
  if (token === undefined || token === null) {
    return null;
  }
  var decoded = jwtDecode(token);
  return decoded;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  config: config,
  init: init,
  getToken: getToken,
  login: login,
  logout: logout,
  deleteAllCookies: deleteAllCookies,
  isLoggedIn: isLoggedIn,
  isSessionPresent: isSessionPresent,
  loginPoc: loginPoc,
  getDecodedToken: getDecodedToken,
  switchAppWithSingleSignOn: switchAppWithSingleSignOn
});

/***/ }),

/***/ "g5EO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_personalDetails_vue__ = __webpack_require__("Bfae");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7503dbe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_personalDetails_vue__ = __webpack_require__("33HN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("+3+u")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_personalDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7503dbe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_personalDetails_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7503dbe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_personalDetails_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hCol":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i3Qj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_educationFieldDetails_vue__ = __webpack_require__("u0m+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_245bb070_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_educationFieldDetails_vue__ = __webpack_require__("qf8G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_educationFieldDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_245bb070_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_educationFieldDetails_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_245bb070_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_educationFieldDetails_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ipUw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_datepicker_vue__ = __webpack_require__("/c/L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_798fcdb8_hasScoped_true_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_datepicker_vue__ = __webpack_require__("xBa1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("S8pY")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-798fcdb8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_datepicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_798fcdb8_hasScoped_true_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_datepicker_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_798fcdb8_hasScoped_true_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_datepicker_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jeSg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");



var _mutations;






// initial state
var state = {
  user: {
    name: 'No :User Connected',
    loginId: '',
    userId: '',
    authorization: 'token',
    langPref: 'en',
    group: [],
    permission: 0
  }

  // getters
};var getters = {
  // getters
  getRolePerm: function getRolePerm(state) {
    return state.permission;
  },
  getRole: function getRole(state) {
    return state.group;
  },
  isUserValid: function isUserValid(state) {
    if (state.user.id === 0) {
      return false;
    }
    return true;
  },
  getLoginId: function getLoginId(state) {
    return state.user.loginId;
  },
  getuserId: function getuserId(state) {
    return state.user.userId;
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* STORE_LOGIN */], function (state, data) {
  state.user.authorization = data.headers.authorization;
  state.user.loginId = data.currentLoginId;
  // state.user.permission = data.permission
  state.user.group = data.group;
  __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ name: 'pathselector' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* STORE_SET_LANG_PREF */], function (state, opt) {
  state.user.langPref = opt;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* STORE_CLEAR_ALL */], function (state) {
  var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state);
  for (var i = 0; i < keys.length; i++) {
    state[keys[i]] = {};
  }
}), _mutations);

var actions = {
  validateUser: function validateUser(context, userObject) {
    userObject.appVersion = '1.0';
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(window.lcmsserver + '/o/lcmslogin/validateuser', userObject).then(function (response) {
      if (response != null && response.data === 'User_Not_Found') {
        __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].toasted.error('Hi, User not Found', {
          theme: 'bubble',
          duration: 6000
        });
        __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ name: 'login' });
      } else {
        response.currentLoginId = userObject.loginId;
        __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].toasted.success('Hi, Welcome to Lcms !', {
          theme: 'bubble',
          duration: 6000
        });
        context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* STORE_LOGIN */], response);
      }
    }).catch(function (e) {
      console.log(e);
      if (e.response.status === 417) {
        __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].toasted.error('Invalid UserName & Password..', {
          theme: 'bubble',
          duration: 6000
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].toasted.error(e, {
          theme: 'bubble',
          duration: 6000
        });
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "jtc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',[(_vm.showConfirmation)?_c('modal',{staticClass:"lg para-font",attrs:{"scroll":""},on:{"close":function($event){_vm.showConfirmation = false}}},[_c('h3',{slot:"header"},[_vm._v(_vm._s(_vm.$t('entry.confirmText'))+"\r\n          ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{slot:"body"},[_c('p',{staticClass:"para height alert alert-info"},[_vm._v("\r\n          "+_vm._s(_vm.instructions.startUpPara)+" \r\n      ")]),_vm._v(" "),_c('p',{staticClass:"p-bot"},[_vm._v("\r\n          "+_vm._s(_vm.$t('candidateProfile.agreement.lblUndertakes'))+"\r\n      ")]),_vm._v(" "),_c('ul',{staticClass:"para-font"},_vm._l((_vm.instructions.instructionList),function(item){return _c('li',[_vm._v(_vm._s(item.instructionMsg)+"\r\n                "),(item.subInstructions)?_c('ul',{staticClass:"subInstructionFont"},_vm._l((item.subInstructions),function(subItem){return _c('li',[_vm._v(_vm._s(subItem.instructionMsg)+" ")])})):_vm._e()])})),_vm._v(" "),_c('label',{staticClass:"c-wrap para-font ml-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedTermCondition),expression:"checkedTermCondition"}],attrs:{"type":"checkbox","id":"checkedTermCondition"},domProps:{"value":true,"checked":Array.isArray(_vm.checkedTermCondition)?_vm._i(_vm.checkedTermCondition,true)>-1:(_vm.checkedTermCondition)},on:{"__c":function($event){var $$a=_vm.checkedTermCondition,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedTermCondition=$$a.concat($$v))}else{$$i>-1&&(_vm.checkedTermCondition=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedTermCondition=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" \r\n              "),_c('strong',[_c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})]),_vm._v(" \r\n                "+_vm._s(_vm.$t('entry.lblcheckedTermCondition'))+"\r\n              ")])])]),_vm._v(" "),_c('div',{slot:"footer"},[_c('button',{staticClass:"btn btn btn-success-alt mr-3",attrs:{"type":"button","disabled":!_vm.checkedTermCondition},on:{"click":_vm.saveTermCondition}},[_vm._v(" "+_vm._s(_vm.$t('button.confirm')))]),_vm._v(" "),_c('p')])]):_vm._e()],1)])}
var staticRenderFns = []


/***/ }),

/***/ "k1mU":
/***/ (function(module, exports) {

module.exports = {"selectLanguage":"Select Language","footerBar":{"lblOrgnization":"2018 Maharashtra Knowledge Corporation Limited","lblPowerdBy":"Powered by MKCL's Core Platform v1.0.1"},"headerBar":{"lblLangEng":"English","lblLangMar":"Marathi","lblHello":"Hello,","lblUserMenu":"User Menu","lblLogout":"Logout","tostrLogout":"Logout Successfully."},"sideBar":{"lblRegistration":"Registration","lblLogout":"Logout","lblCopyRights":"2018 Maharashtra Knowledge Corporation Limited. All Rights Reserved.","tostrLogout":"Logout Successfully."},"login":{"lblHeading1":"MFS Admission Cell","lblHeading2":"Welcome back Please Login here"},"candidateProfile":{"agreement":{"lblCandidateAgreement":"This is an agreement between the student or candidate and the YCMOU which is entered into by virtue of the candidate for admission clicking on “ACCEPT” button on the online admission portal at the time of admission to a program using online admission process. In this agreement the term “candidate” is used to mean the person who proposes to take admission to a program in YCMOU and the term “student” is used to mean a person who has been admitted to a program of the YCMOU after fulfilling all the conditions thereof..","lblUndertakes":"The candidate undertakes that","lblRulesAgree":"I have read the prospectus and rules about admission, thus clicking the below ‘I Agree’ button.","btnIAgree":"I Agree"},"personalDetails":{"plceHoFullName":"Enter your fullname","plceHoNameOnCert":"Enter name as on Leaving Certifcate/Marksheet","plceHoGender":"Select gender","plceHoDOB":"Enter DOB","plceHoMaritalStatus":"Select marital status","plceHoMotherTongue":"Select mother tongue","plceHoAadhaarNo":"Enter Aadhaar number","plceHoPanNo":"Enter PAN number","toastrDeneidCameraAccess":"It seems, your application do not have permission to access camera","toastrNotSuitableCameraDevice":"It seems, no suitable camera device installed","toastrPageIsNotServed":"Page is not served over HTTPS (or localhost)","toastrCameraAlereadyInUse":"It seems, like camera is already in use by other application","toastrDontMatchAnyCamera":"Passed constraints don't match any camera.","toastrBrowserLackingFeatures":"Browser is probably lacking features (WebRTC, Canvas).","toastrEnterValidPanDetails":"Please Enter Valid Pan number","toastrAadhaarMustBe12Digits":"Aadhaar Number must be of 12 Digits","toastrEnterAadhaarDetails":"Please Enter Aadhaar number","toastrEnterNameOnLeavingCertificate":"Please Enter Name as on Leavning Ceriticate","toastrSelectMaritalStatus":"Please Select Marital Status","toastrSelectMotherTongue":"Please Select Mother Tongue","toastrEnterValidDOB":"Please Enter Valid Date of Birth","toastrSelectGender":"Please Select Gender","toastrEnterValidFullName":"Please Enter Valid Full Name","toastrEnterValidAadhaarDetails":"Please Enter Valid Aadhaar Number","toastrNotValidDOB":"You must be at least 17 years old to apply for MFS Programs.","msgScanAadhar":"I would like to scan my aadhaar card for adding information","noteAadhar":"Aadhaar card should not be laminated. You can download digital copy from the official website of UIDAI and scan the QR code via mobile. Scanning aadhaar card is not mandatory, you can fill below details manually too.","lblAadhar":"Scan aadhaar card","lblName":"My name is","lblGender":"and I am a","lblDob":"I was born on","lblMotherTongue":"I speak","lblMotherTongueSpeak":"language at home,","lblMarritalStatus":"Currently I am","lblNameOnLeavingCertificate":"The name on my leaving certificate is","lblAadharNumber":"My aadhaar number is ","lblPanNumber":"and PAN card number is  ","toastrAadhaarAlreadyExists":"Aadhaar Number already exists"},"contactDetails":{"lblCorrespondenceAddressPIN":"My correspondence address's pincode is","plceCorrespondancePIN":"Correspondence Address PIN","lblPermanentAddressPIN":"and permanent address's pincode is","plcePermanentAddressPIN":"Permanent Address PIN","lblContactDetails":"Contact Details","lblEmailID":"Contact me on my verified email address","plceEmailID":"Email ID","lblMobileNumber":"and mobile number","plceMobileNumber":"Mobile Number","lblSkypeID":"My skype ID is","plceSkypeID":"Skype ID","toastrEnterCorrespondanceAddress":"Please Enter Correspondance Address Pincode","toastrCorrespondancePinDigits":"Correspondance Address PIN must have 6 digits","toastrEnterPermanentAddress":"Please Enter Permanent Address Pincode","toastrPermanentPinDigits":"Permanent Address must have 6 digits","toastrEnterEmailID":"Please Enter Email ID","toastrInvalidEmailID":"Email ID is Invalid...Please Enter Valid Email ID","toastrEnterMobileNumber":"Please Enter Mobile Number","toastrMobileNumberDigits":"Mobile Number Must have 10 Digits"},"educationDetails":{"lblPassedOrAppeared":"I","lblIn":"In","lblExam":"exam","lblName":"Since you are not passed/apperred for HSC/Diploma so can not go Further","lblHscOrDiploma":"in HSC / Diploma","lblDiplomaTicketDoc":"Diploma Hall Ticket","lblHSCHallTicketDoc":"HSC Hall Ticket","plceQualification":"Qualification","plceQualificationStatus":"Qualification Status","toastrSelectQualification":"Please Select Any One Qualification","toastrSelectQualificationStatus":"Please Select Qualification Status","lblNoneOfAbove":"None of the above","lblHsc":"HSC","lblSelectHSCResult":"Select your HSC Result","lblAppearing":"Appearing","lblPassed":"Passed","lblOr":"OR","lblDiploma":"Diploma","lblSelectDiplomaResult":"Select your Diploma Result","lblAnyOfAbove":"Have you completed any of the above?","lblNo":"No","lblHSCAppeared":"HSC Appeared","lblDiplomaAppeared":"Diploma Appeared"},"certification":{"lblCertificationCompleted":"I have completed my IT literacy certification in","lblLearnerCode":"Learner Code","lblLearnerCodeIs":"and my learner code is","lblNotCompletedCertification":"I have not completed any IT literacy certifications like MS-CIT, BS-CIT, ...","lblAnyCertificate":"Do you have completed any of following certification?","plceHoLearnerCode":"Enter your learner code","plceHoITCertification":"MS-CIT","toastrErrorFetchingCertificationList":"Error While Fetching Certification List","toastrSelectCertification":"Please Select IT Certification","toastrLearnerCodeInvalid":"Learner Details of given learner code doest not exists","toastrEnterLearnerCode":"Please Enter Learner code"},"profileSummary":{"lblPersonalDetails":"Personal Details","lblName":" Hi, my name is ","lblGender":"I am a","lblDOB":"born on","lblMotherTounge":"My mother tongue is","lblAnd":"and","lblMaritalStatus":"I am currently","btnEditDetails":"Edit Details","lblContactDetails":"Contact Details ","lblMartialStatus":"Martial Status","lblAadharNo":"Aadhar No","lblPanNo":"Pan No","lblNameOnLeaving":"Name on leaving certificate","lblMobileNumber":"My verified mobile number is ","lblEmailID":"and email id is ","lblSkypeId":"My Skype id is","lblCorrespondanceAddress":"My correspondance address is ","lblPermanentAddress":"and permanent address is","lblRespectively":"respectively.","lblITCertification":"IT Literacy Certification","lblCompletedITCertification":"I have completed my IT certification in","lblLearnerCode":"My learner code is ","lblSkil":"I am skilled in","lblPreviousExperience":"My previous experience includes","lblITCertficationTechnology":"IT Technologies respectively.","lblKnownTechnologies":"Known Technological Languages","lblEducationDetails":"Educational Details","lblSSC":"SSC","lblHSC":"HSC","lblDiploma":"Diploma","lblDegree":"Degree","lblMarksheet":"Marksheet","lblCertificationNotCompleted":"I have not completed any Certification","lblNotEligible":"Since you have not Appeared/Passed HSC or Degree you are not eligible for this program.","toastrPermanentPinCodeNotFound":"Permanent Address For Given Pincode Not Found!","toastrcorrespondancePinCodeNotFound":"Correpondance Address For Given Pincode Not Found!"},"imageExtracter":{"toastrMessageAppender":"Please Enter ","toastrCertificationDetailsFeatchError":"Error while featch certificate details","toastrCertificationListFeatchError":"Error while featch certificate list'","lblCrop":"Crop","toastrImageNotAvailable":"Image Not Available"},"documentUpload":{"lblProfilePhoto":"Profile Photo","lblSscDoc":"SSC Documents","lblHscDoc":"HSC Documents","lblDiplomaDoc":"Diploma Documents","toastrFileAlreadyExists":"File Already Present on CDN","toastrNoResponse":"No response from CDN","toastrDocumentsUploadSuccess":"Documents details saved successfully","toastrFileDeleted":"File Deleted Successfully","toastrDataNotPresent":"Data Not Present in DB","toastrDocumentsUploadedSuccess":"Documents uploaded successfully","toastrDocumentsUploadError":"Please Upload All Documents","toastrDocumentsUploadSizeError":"Please Upload file less than 300 KB"}},"registration":{"fullName":"Full Name","dob":"DOB","email":"Email","mobile":"Mobile","username":"Username","password":"Password","lblMFSAdmissionCell":"MFS Admission Cell","lblSignUpToContinue":"Sign up to continue","lblSuggestedUsernames":"Suggested user names :","msgSignUpNote":"By signing up you agree to our Terms and Conditons","toastrPleaseEnterValidFullName":"Please Enter Valid Full Name","toastrUsernameRequired":"Please Enter Username","toastrPasswordRequired":"Please Enter Password","toastrEmailRequired":"Please Enter Email ID","toastrInvalidEmail":"Please Enter Valid Email ID","toastrMobileRequired":"Please Enter Mobile No","toastrInvalidMobile":"Mobile No must have 10 digits","toastrOTPRequired":"Please Enter OTP","toastrInvalidOTP":"OTP must have 6 digits","toastrVerifyMobileNumber":"Please Verify Mobile No","buttonType":{"register":"Register","cancel":"Cancel","verifyOTP":"Verify OTP","sendOTP":"Send OTP"},"placeholder":{"fullname":"Full Name","mobile":"Mobile Number","username":"Username","password":"Password","email":"Email"},"alerts":{"DATA_NOT_VALID":"Please Properly fill the data","REGISTRATION_FAIL":"Registration Failed","REGISTRATION_SUCCESS":"Registration Successful","FAIL_TO_FIND_USERNAME_AVAILABILITY":"Failed to find username availability","USERNAME_NOT_AVAILABLE":"Username is Not Available","USERNAME_NOT_VALID":"Email ID is Not Valid","USERNAME_ALREADY_EXIST":"Email ID already exist","OTP_SEND_SUCCESS":"OPT is sent to your mobile number please verify.","OTP_Send_Fail":"Fail to send OTP check Mobile Number/Email","ENTER_VALID_DETAILS":"Please Enter Valid Details","OTP_VERIFY_SUCCESS":"OTP verified Successfully","OTP_INVALID":"Invalid OTP","MOBILE_NUMBER_CHANGED":"Please Resend OTP to given Mobile Number","OTP_VERIFY_FAIL":"Fail To verify because of You changed Mobile no./Email"},"tabs":{"tabITLiteracy":"IT Literacy Certification","tabPersonalDetails":"Personal details","tabContactDetails":"Contact Details","tabEducationDetails":"Educational Details","tabDocumentUpload":"Documents Upload","tabProfileSummary":"Profile Summary","tabImageExtractor":"Qualification Details"}},"candidateApplications":{"title":"Course Selection","plceHoSearchBox":"Search Course/University","erorNotMatchFound":"There is no matching found.","toastrAppAlreadyExist":"Your have already applied for this Application."},"workPlace":{"toastrAddedInCart":"added in your list.","toastrExistData":"This workplace already selected.","plceHoWorkPlace":"Search workplace","toastrDelete":"removed from your list.","toastrSaveData":"Your Application Saved Successfully.","toastrWarningForSelection":"Please select workplace.","lblWorkPlace":"Select your workplace","erorNotMatchFound":"There is no matching found.","lblSelectedWorkPlace":"Selected workplaces","infoStatment1":"You have selected","infoStatment2":"as course at","erorNotSelected":"There is no workplace selected."},"entry":{"candidateAgreement":"Candidate / Student Agreement","toastrSelectAtLeastOne":"Please check at least one instruction"},"button":{"apply":"Apply","select":"Select","view":"View","save":"Save","update":"Update","delete":"Delete","remove":"Remove","Finish":"Confirm & Proceed","signUp":"Sign Up","login":"Login","back":"Back","next":"Next","cancel":"Cancel","confirm_proceed":"Confirm & Proceed"},"toastr":{"toastrPersonalDetailsSaved":"Personal Details Saved Successfully.","toastrAddressDetailsSaved":"Address Details Saved Successfully.","toastrContactDetailsSaved":"Contact Details Saved Successfully.","toastrEducationalDetailsSaved":"Educational Details Saved Successfully.","toastrCertificationDetailsSaved":"Certification Details Saved Successfully.","toastrSomethingWentWrong":"Ooops…Something went Wrong!","toastrDetailsSaved":"Details Saved Successfully","toastrAadhaarScanSuccess":"Aadhaar Scan Successful","toastrProfileCompleted":"Profile Completed","toastrIntrustionsSaved":"Instructions Saved"}}

/***/ }),

/***/ "kilQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lXA3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__ = __webpack_require__("KvPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__("hCol");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_modal_vue__ = __webpack_require__("yN8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import lodash from 'lodash'
var tus = __webpack_require__("Ivio");
/* harmony default export */ __webpack_exports__["a"] = ({
  components: { vueDropzone: __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default.a, modal: __WEBPACK_IMPORTED_MODULE_3__components_common_modal_vue__["a" /* default */] },
  data: function data() {
    return {
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 350,
        previewsContainer: false,
        maxFilesize: 1,
        maxFiles: 1,
        headers: { 'My-Awesome-Header': 'header value' },
        addRemoveLinks: true,
        uploadMultiple: false,
        acceptedFiles: 'image/*'
      },
      selectedFile: null,
      /* CDN_BUSINESS_HEADER: this.CDN_BUSINESS_HEADER,
      CDN_CLIENT_HEADER: this.CDN_CDN_CLIENT_HEADER, */
      documentdata: {
        filepath: '',
        thumbnailpath: ''
      },
      data: false,
      files: [],
      details: {},
      showHSC: false,
      showDiploma: false,
      showDiplomaHallTicket: false,
      showHSCHallTicket: false,
      filename: '',
      filepath: '',
      path: '',
      checkpath: '',
      cdnid: 'CDN_001',
      cdnid1: '',
      dbCheckFileResponse: '',
      // currentYear: (new Date()).getFullYear(),
      currentYear: '',
      fileUploadStatus: {
        'SSC': false,
        'HSCorDiploma': false,
        'HSCorDiplomaHallTicket': false,
        'profilePic': false
      },
      profilesrc: '',
      sscsrc: '',
      hscsrc: '',
      diplomasrc: '',
      diplomaHallTicketsrc: '',
      hscHallTicketsrc: '',
      showDocuments: false,
      processedName: '',
      processedPath: '',
      modalDiplomasrc: '',
      loading: false,
      fileCheckResponse: {},
      deleteFileResponse: {},
      showSSCModal: false,
      showHSCModal: false,
      showDiplomaModal: false
    };
  },

  methods: {
    nextTabFunc: function nextTabFunc() {
      this.documentStatus();
    },
    prevTabFunc: function prevTabFunc() {
      this.$router.push('educationalDetails');
    },
    UploadFile: function UploadFile(name, path) {
      var uploadForm = this;
      uploadForm.filepath = uploadForm.currentYear + '/documents/' + path;
      uploadForm.checkpath = uploadForm.currentYear + '/documents/' + path;
      for (var i = 0; i < uploadForm.files.length; i++) {
        uploadForm.selectedFile = uploadForm.files[i];
        var fileExtension = uploadForm.selectedFile.name.split('.').pop();
        fileExtension = '.' + fileExtension;
        uploadForm.filename = new Date().getTime() + name + fileExtension;
        // var filePathFromDB
        uploadForm.uploadFileOnCDN(name);
        /* uploadForm.checkFileInDB(name, uploadForm.filename).then(function (filePathDB) {
          filePathFromDB = filePathDB
          uploadForm.CheckFileOnCDN(filePathFromDB, name).then(function () {
            uploadForm.DeleteFileFromCDN(filePathFromDB).then(function () {
              uploadForm.uploadFileOnCDN(name)
            }).catch(function (error) {
              console.error('Error in DeleteFileFromCDN : ' + error)
            })
          }).catch(function (error) {
            console.error('Error in CheckFileOnCDN : ' + error)
          })
        }).catch(function (error) {
          console.error('Error in checkFileInDB : ' + error)
        }) */
      }
    },
    uploadFileOnCDN: function uploadFileOnCDN(name) {
      var uploadForm = this;
      var upload = new tus.Upload(uploadForm.selectedFile, {
        endpoint: uploadForm.CDN_LOAD_BALANCER_URL + '?res-o',
        chunkSize: 500000,
        metadata: {
          filename: uploadForm.filename
        },
        headers: {
          'Bussiness-Code': uploadForm.CDN_BUSINESS_HEADER,
          'Client-Code': uploadForm.CDN_CLIENT_HEADER,
          'Path': uploadForm.filepath
        },
        retryDelays: [0, 1000, 3000, 5000],
        onError: function onError(error) {
          uploadForm.$toasted.error(uploadForm.$t('candidateProfile.documentUpload.toastrFileAlreadyExists'), {
            duration: '2000', theme: 'bubble'
          });
          console.error(error);
        },
        onSuccess: function onSuccess() {
          if (upload._xhr.response !== '') {
            uploadForm.path = upload._xhr.response;
            uploadForm.uploadData(name);
            return;
          } else {
            uploadForm.$toasted.error(uploadForm.$t('candidateProfile.documentUpload.toastrNoResponse'), {
              duration: '2000', theme: 'bubble'
            });
            return;
          }
        }
      });
      // Start the upload
      upload.start();
      uploadForm.reset();
    },
    fileprocessing: function fileprocessing(fileid) {
      // this.loading = false
      var fileprocess = this;
      var profileName = fileprocess.$store.state.candidateProfile.profileUser;
      var processedName = '';
      var processedPath = '';
      if (fileid === 'Profile') {
        processedName = profileName + '_ProfilePicture';
        processedPath = 'profilepicture/' + profileName;
        fileprocess.UploadFile(processedName, processedPath);
      }
      if (fileid === 'SSC') {
        processedName = profileName + '_SSC';
        processedPath = 'Results/' + profileName;
        fileprocess.UploadFile(processedName, processedPath);
      }
      if (fileid === 'HSC') {
        processedName = profileName + '_HSC';
        processedPath = 'Results/' + profileName;
        fileprocess.UploadFile(processedName, processedPath);
      }
      if (fileid === 'Diploma') {
        processedName = profileName + '_Diploma';
        processedPath = 'Results/Diploma/' + profileName;
        fileprocess.UploadFile(processedName, processedPath);
      }
      if (fileid === 'DiplomaHallTicket') {
        processedName = profileName + '_DiplomaHallTicket';
        processedPath = 'Results/DiplomaHallTicket/' + profileName;
        fileprocess.UploadFile(processedName, processedPath);
      }
      if (fileid === 'HSCHallTicket') {
        processedName = profileName + '_HSCHallTicket';
        processedPath = 'Results/HSCHallTicket/' + profileName;
        fileprocess.UploadFile(processedName, processedPath);
      }
    },
    fileAdded: function fileAdded(doc, file) {
      if (file.size / 1024 <= 1024) {
        this.files.push(file);
        this.loading = true;
        this.fileprocessing(doc);
      } else {
        this.loading = false;
        this.$toasted.error(this.$t('candidateProfile.documentUpload.toastrDocumentsUploadSizeError'));
      }
    },
    uploadData: function uploadData(id) {
      var uploaddata = this;
      var profileName = uploaddata.$store.state.candidateProfile.profileUser;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('r/upload/' + profileName, { 'docId': id, 'docName': uploaddata.filename, 'docImage': uploaddata.path }).then(function (response) {
        uploaddata.data = response.data;
        var pfName = '';
        var pfNameArray = profileName.split('.');
        for (var item = 0; item < pfNameArray.length; item++) {
          pfName = pfName + pfNameArray[item];
        }
        var fileName = uploaddata.filename.split('.');
        var nameOfDoc = '';
        /* var printName = 'Documents' */
        for (var _item = 0; _item < fileName.length - 1; _item++) {
          nameOfDoc = nameOfDoc + fileName[_item];
        }
        if (uploaddata.data === true) {
          if (nameOfDoc === pfName + '_SSC') {
            uploaddata.fileUploadStatus.SSC = true;
            /*   uploaddata.$toasted.success('Documents' + uploaddata.$t('candidateProfile.documentUpload.toastrDocumentsUploadSuccess'), {
                duration: uploaddata.TOASTR_TIME, theme: 'bubble'
              }) */
          }
          if (nameOfDoc === pfName + '_HSC' || nameOfDoc === pfName + '_Diploma') {
            uploaddata.fileUploadStatus.HSCorDiploma = true;
            /* uploaddata.$toasted.success('Documents' + uploaddata.$t('candidateProfile.documentUpload.toastrDocumentsUploadSuccess'), {
              duration: uploaddata.TOASTR_TIME, theme: 'bubble'
            }) */
          }
          if (nameOfDoc === pfName + '_HSCHallTicket' || nameOfDoc === pfName + '_DiplomaHallTicket') {
            uploaddata.fileUploadStatus.HSCorDiplomaHallTicket = true;
          }
          if (nameOfDoc === pfName + '_ProfilePicture') {
            uploaddata.fileUploadStatus.profilePic = true;
            /* uploaddata.$toasted.success('Profile photo' + uploaddata.$t('candidateProfile.documentUpload.toastrDocumentsUploadSuccess'), {
              duration: uploaddata.TOASTR_TIME, theme: 'bubble'
            }) */
          }
          uploaddata.$toasted.success('Document' + uploaddata.$t('candidateProfile.documentUpload.toastrDocumentsUploadSuccess'), {
            duration: uploaddata.TOASTR_TIME, theme: 'bubble'
          });
          uploaddata.getEducationalDetails();
          uploaddata.loading = false;
          window.localStorage.clear();
        }
      }).catch(function () {
        uploaddata.loading = false;
      });
    },
    reset: function reset() {
      this.files = [];
    },
    CheckFileOnCDN: function CheckFileOnCDN(checkfilepath, name) {
      var checkfile = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(checkfile.CDN_URL + 'o/isfilepresent', { 'url': checkfilepath }, { headers: { 'Bussiness-Code': checkfile.CDN_BUSINESS_HEADER, 'Client-Code': checkfile.CDN_CLIENT_HEADER } }).then(function (Response) {
          checkfile.fileCheckResponse = Response.data;
          if (Response.status === 200) {
            if (checkfile.fileCheckResponse.filePresentFlag === true) {
              resolve();
            } else {
              checkfile.uploadFileOnCDN(name);
            }
          }
        }).catch(function () {
          reject();
        });
      });
    },
    DeleteFileFromCDN: function DeleteFileFromCDN(deletepath) {
      var deletefile = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(deletefile.CDN_URL + 'o/deletefile', { 'url': deletepath }, { headers: { 'Bussiness-Code': deletefile.CDN_BUSINESS_HEADER, 'Client-Code': deletefile.CDN_CLIENT_HEADER } }).then(function (Response) {
          deletefile.deleteFileResponse = Response.data;
          if (Response.status === 200) {
            if (deletefile.deleteFileResponse.fileDeleted === true) {
              resolve();
            } else {
              deletefile.$toasted.error(deletefile.$t('candidateProfile.documentUpload.toastrNoResponse'), {
                duration: deletefile.TOASTR_TIME, theme: 'bubble'
              });
            }
          }
          // return
        }).catch(function () {
          reject();
        });
      });
    },
    getEducationalDetails: function getEducationalDetails() {
      var sample = this;
      var userName = this.$store.state.candidateProfile.profileUser;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('r/fetchDetails', { userName: userName }).then(function (response) {
        sample.details = response.data;
        for (var item = 0; item < sample.details.documents.length; item++) {
          if (sample.details.documents[item].docId === userName + '_ProfilePicture') {
            sample.fileUploadStatus.profilePic = true;
          }
          if (sample.details.documents[item].docId === userName + '_SSC') {
            sample.fileUploadStatus.SSC = true;
          }
          if (sample.details.documents[item].docId === userName + '_HSC') {
            sample.fileUploadStatus.HSCorDiploma = true;
          }
          if (sample.details.documents[item].docId === userName + '_HSCHallTicket') {
            sample.fileUploadStatus.HSCorDiplomaHallTicket = true;
          }
          if (sample.details.documents[item].docId === userName + '_Diploma') {
            sample.fileUploadStatus.HSCorDiploma = true;
          }
          if (sample.details.documents[item].docId === userName + '_DiplomaHallTicket') {
            sample.fileUploadStatus.HSCorDiplomaHallTicket = true;
          }
        }
        sample.showHSC = sample.details.educationDetails.isHSCPassed;
        sample.showDiploma = sample.details.educationDetails.isDiplomaPassed;
        sample.showHSCHallTicket = sample.details.educationDetails.isHSCAppeared;
        sample.showDiplomaHallTicket = sample.details.educationDetails.isDiplomaAppeared;
        sample.getDocuments();
      });
    },
    fileRemoved: function fileRemoved(file, error, xhr) {
      for (var i = 0; i < this.files.length; i++) {
        if (this.files[i].upload.uuid === file.upload.uuid) {
          this.files.splice(i, 1);
          break;
        }
      }
    },
    checkFileInDB: function checkFileInDB(docid, name) {
      var db = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var userName = db.$store.state.candidateProfile.profileUser;
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('r/checkfile/' + userName, { 'docId': docid }).then(function (Response) {
          if (Response.status === 200) {
            db.dbCheckFileResponse = Response.data;
            if (db.dbCheckFileResponse === '') {
              db.uploadFileOnCDN(docid);
            } else {
              resolve(db.dbCheckFileResponse);
            }
          }
        }).catch(function (e) {
          reject(e);
          // db.$toasted.info(db.$t('candidateProfile.documentUpload.toastrDataNotPresent'), {
          //   duration: 1000, theme: 'bubble'
          // })
        });
      });
    },
    documentStatus: function documentStatus() {
      var status = this;
      if (status.fileUploadStatus.SSC === true && status.fileUploadStatus.profilePic === true && (status.fileUploadStatus.HSCorDiplomaHallTicket === true || status.fileUploadStatus.HSCorDiploma === true)) {
        /*  status.$toasted.success(status.$t('candidateProfile.documentUpload.toastrDocumentsUploadedSuccess'), {
           duration: status.TOASTR_TIME, theme: 'bubble'
         }) */
        var userName = this.$store.state.candidateProfile.profileUser;
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('r/savedocumentstatus/' + userName).then(function (response) {
          if (response.status === 200) {
            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('r/projectConfig/getAllProjectConfig').then(function (responses) {
              status.$toasted.success(status.$t('candidateProfile.documentUpload.toastrDocumentsUploadedSuccess'));
              if (responses.data.ocrConfig.required) {
                status.$router.push({ name: 'imageExtracter' });
              } else {
                status.$router.push({ name: 'qualificationDetails' });
              }
            }).catch(function (e) {
              console.log(e);
            });
          }
        }).catch(function (e) {
          status.$toasted.info(status.$t('candidateProfile.documentUpload.toastrFailToUpdateStatus'), {
            duration: status.TOASTR_TIME,
            theme: 'bubble'
          });
        });
      } else {
        status.$toasted.error(status.$t('candidateProfile.documentUpload.toastrDocumentsUploadError'), {
          duration: status.TOASTR_TIME, theme: 'bubble'
        });
      }
    },
    getDocuments: function getDocuments() {
      var doc = this;
      var profileUser = doc.$store.state.candidateProfile.profileUser;
      if (doc.details.documents.length === 0) {
        doc.showDocuments = false;
      } else {
        doc.showDocuments = true;
        var myarray = doc.details.documents;
        myarray.forEach(function (element) {
          if (element.docId === profileUser + '_ProfilePicture') {
            doc.profilesrc = element.docImage;
            doc.$store.commit('STORE_PROFILE_USER_PHOTO', doc.profilesrc);
          } else if (element.docId === profileUser + '_SSC') {
            doc.sscsrc = element.docImage;
          } else if (element.docId === profileUser + '_HSC') {
            doc.hscsrc = element.docImage;
          } else if (element.docId === profileUser + '_DiplomaHallTicket') {
            doc.diplomaHallTicketsrc = element.docImage;
            doc.modalDiplomasrc = element.docImage;
          } else if (element.docId === profileUser + '_HSCHallTicket') {
            doc.hscHallTicketsrc = element.docImage;
            doc.modalDiplomasrc = element.docImage;
          } else if (element.docId === profileUser + '_Diploma') {
            doc.diplomasrc = element.docImage;
            doc.modalDiplomasrc = element.docImage;
          } else {}
        });
      }
    },
    getAcademicYear: function getAcademicYear() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('o/projectConfig/getCurrentAcademicYear').then(function (response) {
        if (response.data) {
          _this.currentYear = response.data;
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    callLoader: function callLoader() {
      this.loader = true;
    }
  },
  created: function created() {
    if (this.$store.state.user.userDetails.confirmStatus) {
      this.$router.push({ name: 'entry' });
    } else {
      this.getEducationalDetails();
      this.getAcademicYear();
    }
  }
});

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "increment", function() { return increment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decrement", function() { return decrement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__("Du/2");


var increment = function increment(_ref) {
  var commit = _ref.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["j" /* STORE_INCREMENT */]);
};
var decrement = function decrement(_ref2) {
  var commit = _ref2.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["k" /* STORE_DECREMENT */]);
};

/***/ }),

/***/ "nB+O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"header"}},[_c('b-navbar',{attrs:{"toggleable":"","type":"light","toggle-breakpoint":"md"}},[_c('b-nav-toggle',{attrs:{"target":"nav_collapse"}}),_vm._v(" "),_c('div',{staticClass:"navbar-brand"},[_c('img',{attrs:{"id":"header-logo","src":"static/assets/images/mfs-logo.png","alt":"MKCL ERA"}})]),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-lg-4 offset-md-8 text-right"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLanguage),expression:"selectedLanguage"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedLanguage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changeLanguage]}},[_c('option',{attrs:{"disabled":""}},[_vm._v(_vm._s(_vm.$t('selectLanguage')))]),_vm._v(" "),_c('option',[_vm._v(_vm._s(_vm.$t(_vm.headerBar.lblLangEng)))]),_vm._v(" "),_c('option',[_vm._v(_vm._s(_vm.$t(_vm.headerBar.lblLangMar)))])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 offset-md-8 text-right"},[_c('b-dropdown',{staticClass:"box-profile"},[_c('span',{slot:"text"},[_c('div',{staticClass:"profile-text"},[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.headerBar.lblHello)))]),_vm._v(_vm._s(_vm.username)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"profile-image"},[_c('img',{attrs:{"src":_vm.docImagePath,"alt":""}}),_vm._v(" "),_c('i',{staticClass:"mdi mdi-chevron-down"})])]),_vm._v(" "),_c('b-dropdown-item',[_vm._v(_vm._s(_vm.$t(_vm.headerBar.lblUserMenu)))]),_vm._v(" "),_c('b-dropdown-divider'),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.logout()}}},[_vm._v(_vm._s(_vm.$t(_vm.headerBar.lblLogout)))])],1)],1)])])])],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "nSpO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"workPlaceSelection",attrs:{"id":"workPlaceSelection"}},[_c('div',{},[_c('div',{staticClass:"card-alt-body"},[_c('div',{staticClass:"page-header"},[_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col"},[_c('h2',{staticClass:"page-title mb-2"},[_vm._v(_vm._s(_vm.$t('workPlace.lblWorkPlace')))])])])]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"alert alert-success"},[_c('small',[_vm._v(" "+_vm._s(_vm.$t('workPlace.infoStatment1'))+" "),_c('b',[_vm._v(_vm._s(_vm.courseUniObj.courseName))]),_vm._v(" "+_vm._s(_vm.$t('workPlace.infoStatment2'))+" "),_c('b',[_vm._v(_vm._s(_vm.courseUniObj.uniName))]),_vm._v(". ")])]),_vm._v(" "),_c('div',{staticClass:"download-card"},[_c('div',{staticClass:"download-card-header"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-lg-6"},[_c('h3',{staticClass:"instruction-title"},[_vm._v(_vm._s(_vm.$t('workPlace.lblInstruction')))])]),_vm._v(" "),(_vm.instructions.pdfURL)?_c('div',{staticClass:"col-lg-2 col-sm-4 text-center"},[_c('a',{staticClass:"btn btn-xs btn-default btn-circle",attrs:{"href":_vm.instructions.pdfURL,"download":"","target":"_blank"}},[_c('i',{staticClass:"mdi mdi-file"})]),_vm._v(" "),_c('p',{staticClass:"btn-text"},[_vm._v("Download pdf")])]):_vm._e(),_vm._v(" "),(_vm.instructions.audioURL)?_c('div',{staticClass:"col-lg-2 col-sm-4 text-center"},[_c('button',{staticClass:"btn btn-xs btn-default btn-circle",attrs:{"type":"button"},on:{"click":_vm.playInstructionAudio}},[_c('i',{staticClass:"mdi mdi-headphones-settings"})]),_vm._v(" "),_c('p',{staticClass:"btn-text"},[_vm._v("Play Audio")])]):_vm._e(),_vm._v(" "),(_vm.instructions.videoURL)?_c('div',{staticClass:"col-lg-2 col-sm-4 text-center"},[_c('button',{staticClass:"btn btn-xs btn-default btn-circle",attrs:{"type":"button"},on:{"click":_vm.playInstructionVideo}},[_c('i',{staticClass:"mdi mdi-video"})]),_vm._v(" "),_c('p',{staticClass:"btn-text"},[_vm._v("Play Video")])]):_vm._e()])]),_vm._v(" "),_c('div',[_c('b-modal',{ref:"instrAudioModalRef",attrs:{"size":"md","hide-footer":"","title":_vm.$t('workPlace.lblInstruction')},on:{"hidden":_vm.hideAudioModal}},[_c('div',{staticClass:"d-block text-left"},[_c('audio',{ref:"audioRef",attrs:{"src":"","id":"audio-container","type":"audio/mpeg","width":"100%","controls":""}})])]),_vm._v(" "),_c('b-modal',{ref:"instrVideoModalRef",attrs:{"size":"lg","hide-footer":"","title":_vm.$t('workPlace.lblInstruction')},on:{"hidden":_vm.hideInstructionVideoModal}},[_c('div',{staticClass:"d-block text-left"},[_c('div',{attrs:{"id":"app"}},[_c('iframe',{ref:"instrVideoRef",attrs:{"src":"","id":"video-container","width":"100%","height":"450"}})])])])],1),_vm._v(" "),_c('div',{staticClass:"download-card-body"},[_c('div',{staticClass:"text-content "},[_c('ul',{staticClass:"instructions height"},_vm._l((_vm.instructions.instructionList),function(item){return _c('li',[_vm._v(_vm._s(item.instructionMsg)+"\n              "),(item.subInstructions)?_c('ul',{staticClass:"subInstructionFont"},_vm._l((item.subInstructions),function(subItem){return _c('li',[_vm._v(_vm._s(subItem.instructionMsg)+" ")])})):_vm._e()])}))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row wrap"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel__heading mt-3 mb-3 pr-3"},[_c('div',{staticClass:"input-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchBox),expression:"searchBox"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('workPlace.plceHoWorkPlace'),"aria-describedby":"Select places for workplace"},domProps:{"value":(_vm.searchBox)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchBox=$event.target.value}}})])]),_vm._v(" "),_c('div',{directives:[{name:"bar",rawName:"v-bar"}]},[_c('div',[_c('div',{staticClass:"list-wrap"},[_c('transition-group',{staticClass:"pr-3",attrs:{"name":"sleek","tag":"div"}},_vm._l((_vm.orderBy(_vm.filterWorkPlaceList, 'districtName')),function(item){return _c('div',{key:item.districtID,staticClass:"list-css"},[_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col text-left align-self-center"},[_vm._v(" "+_vm._s(item.districtName))]),_vm._v(" "),_c('div',{staticClass:"col-auto text-right"},[_c('div',{staticClass:"btn btn-info-alt btn-sm text-right",on:{"click":function($event){_vm.copyWorkPlace(item)}}},[_vm._v(_vm._s(_vm.$t('button.select')))])])])])})),_vm._v(" "),(_vm.filterWorkPlaceList.length < 1)?_c('div',{staticClass:"red"},[_vm._v("\n                    "+_vm._s(_vm.$t('workPlace.erorNotMatchFound'))+"\n                  ")]):_vm._e()],1)])])])]),_vm._v(" "),_c('div',{staticClass:"col pl-2"},[_c('div',{staticClass:"panel selectedItem"},[_c('div',{staticClass:"panel__heading"},[_c('h4',{staticClass:"pt-4 mb-4"},[_vm._v(_vm._s(_vm.$t('workPlace.lblSelectedWorkPlace')))])]),_vm._v(" "),(_vm.selectedWorkPlaceList.length < 1)?_c('div',{staticClass:"grey panel__heading"},[_c('h5',{staticClass:"bigtext text-center"},[_vm._v(_vm._s(_vm.$t('workPlace.erorNotSelected')))])]):_vm._e(),_vm._v(" "),(_vm.selectedWorkPlaceList.length > 0)?_c('div',{staticClass:"right-list-wraper"},[_c('div',{directives:[{name:"bar",rawName:"v-bar"}]},[_c('div',[_c('div',{staticClass:"list-wrap"},[_c('transition-group',{staticClass:"pr-3",attrs:{"name":"slide","tag":"div"}},_vm._l((_vm.selectedWorkPlaceList),function(item,index){return _c('div',{key:item.districtID,staticClass:"list-checked"},[_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col-8 text-left"},[_c('b',[_vm._v(" "+_vm._s(item.sequence)+".  ")]),_vm._v("   "+_vm._s(item.districtName)+"     "),_c('i',{staticClass:"mdi mdi-checkbox-marked-circle"})]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col-4"},[(index != 0)?_c('i',{staticClass:"mdi mdi-chevron-up",attrs:{"title":"Move Up"},on:{"click":function($event){_vm.upSequence(item)}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-4"},[(index != _vm.selectedWorkPlaceList.length - 1)?_c('i',{staticClass:"mdi mdi-chevron-down",attrs:{"title":"Move Down"},on:{"click":function($event){_vm.downSequence(item)}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('i',{staticClass:"mdi mdi-delete btn btn-sm",attrs:{"title":"Delete"},on:{"click":function($event){_vm.removeWorkPlace(item)}}})])])])])])}))],1)])])]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center mt-5"},[_c('div',{staticClass:"col-12 text-right"},[_c('button',{staticClass:"btn btn-orange",on:{"click":function($event){_vm.showConfirmation = true}}},[_vm._v(_vm._s(_vm.$t('button.save')))])])])]),_vm._v(" "),(_vm.showConfirmation)?_c('modal',{staticClass:"sm",on:{"close":function($event){_vm.showConfirmation = false}}},[_c('h3',{slot:"header"},[_vm._v("Please verify order of your Work Place preference form before you save.")]),_vm._v(" "),_c('div',{slot:"body"},[_c('div',{staticClass:"row justify-content-center"},[_c('button',{staticClass:"btn btn btn-success-alt mr-3",attrs:{"type":"button"},on:{"click":function($event){_vm.save()}}},[_vm._v(" "+_vm._s(_vm.$t('button.confirm')))]),_vm._v(" "),_c('button',{staticClass:"btn btn btn-danger-alt mr-3",attrs:{"type":"button"},on:{"click":function($event){_vm.showConfirmation = false}}},[_vm._v(" "+_vm._s(_vm.$t('button.cancel')))])])]),_vm._v(" "),_c('div',{slot:"footer"})]):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon",attrs:{"id":"search"}},[_c('i',{staticClass:"mdi mdi-magnify"})])}]


/***/ }),

/***/ "o+41":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_videoUpload_vue__ = __webpack_require__("IoCR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6638ace8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_videoUpload_vue__ = __webpack_require__("8/Kq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("zayz")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_videoUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6638ace8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_videoUpload_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6638ace8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_videoUpload_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ob0k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "obgm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_documentsupload_vue__ = __webpack_require__("lXA3");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fbfa0b1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_documentsupload_vue__ = __webpack_require__("aiFg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("PsLs")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_documentsupload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fbfa0b1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_documentsupload_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fbfa0b1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_documentsupload_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "omub":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p/2+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p8Mm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_candidateApplication_vue__ = __webpack_require__("8KH/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76054302_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_candidateApplication_vue__ = __webpack_require__("uUKX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("4ZrY")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_candidateApplication_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76054302_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_candidateApplication_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76054302_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_candidateApplication_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pLS5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-header"},[_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col-10 text-left"},[(_vm.currentEduType == 'Diploma' || _vm.currentEduType == 'SSC' || _vm.currentEduType == 'HSC')?_c('h2',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.currentEduType)+" "+_vm._s(_vm.$t('candidateProfile.qualificationDetails.lblDetails')))]):_vm._e(),_vm._v(" "),(_vm.currentEduType == 'HSCHallTicket')?_c('h2',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t('candidateProfile.qualificationDetails.lblHSCHallTicketDetails'))+" "+_vm._s(_vm.$t('candidateProfile.qualificationDetails.lblDetails')))]):_vm._e(),_vm._v(" "),(_vm.currentEduType == 'DiplomaHallTicket')?_c('h2',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t('candidateProfile.qualificationDetails.lblDiplomaHallTicketDetails'))+" "+_vm._s(_vm.$t('candidateProfile.qualificationDetails.lblDetails')))]):_vm._e()]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('form',{staticClass:"row justify-content-center p-details",attrs:{"action":"POST","data-vv-scope":"form-1"},on:{"submit":function($event){$event.preventDefault();_vm.save('form-1')}}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-10 pt-3"},[_c('div',{staticClass:"para alert alert-success"},[_c('strong',[_vm._v(_vm._s(_vm.$t('candidateProfile.qualificationDetails.lblNote')))]),_vm._v(" "),(_vm.currentEduType == 'Diploma' || _vm.currentEduType == 'SSC' || _vm.currentEduType == 'HSC')?_c('span',[_vm._v(_vm._s(_vm.$t('candidateProfile.qualificationDetails.noteMarksheet')))]):_vm._e(),(_vm.currentEduType == 'HSCHallTicket')?_c('span',[_vm._v(_vm._s(_vm.$t('candidateProfile.qualificationDetails.noteHSCHallticket')))]):_vm._e(),(_vm.currentEduType == 'DiplomaHallTicket')?_c('span',[_vm._v(_vm._s(_vm.$t('candidateProfile.qualificationDetails.noteDiplomaHallticket')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-2 text-center"},[_c('img',{staticClass:"dpics documentImg img-fluid img-thumbnail ml-2",attrs:{"src":_vm.marksheetUrl},on:{"click":function($event){_vm.showModal = true}}}),_vm._v(" "),_c('span',{staticClass:"pcss input-group-addon",attrs:{"title":_vm.$t('candidateProfile.qualificationDetails.tooltipViewDoc')}},[_c('div',{staticClass:"title para green-note text-center "},[_c('i',[(_vm.currentEduType == 'Diploma' || _vm.currentEduType == 'SSC' || _vm.currentEduType == 'HSC')?_c('span',[_vm._v(_vm._s(_vm.currentEduType)+" "+_vm._s(_vm.$t('candidateProfile.qualificationDetails.lblMarksheet')))]):_vm._e(),(_vm.currentEduType == 'HSCHallTicket')?_c('span',[_vm._v(_vm._s(_vm.$t('candidateProfile.qualificationDetails.lblHSCHallTicketDetails')))]):_vm._e(),(_vm.currentEduType == 'DiplomaHallTicket')?_c('span',[_vm._v(_vm._s(_vm.$t('candidateProfile.qualificationDetails.lblDiplomaHallTicketDetails')))]):_vm._e()])])])])]),_vm._v(" "),((_vm.currentEduType === 'SSC' || _vm.currentEduType == 'HSC' || _vm.currentEduType == 'Diploma'))?_c('div',{staticClass:"form-group custom-input pb-5 pt-0"},[_c('div',{staticClass:"para"},[_vm._v(_vm._s(_vm.$t('candidateProfile.qualificationDetails.lblIHaveCompleted'))+" "+_vm._s(_vm.currentEduType)+" "+_vm._s(_vm.$t('candidateProfile.qualificationDetails.lblFrom')))]),_vm._v(" "),_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required|not_in:Select'),expression:"'required|not_in:Select'"}],class:{'form-error': _vm.errors.has('board')},attrs:{"label":"boardName","options":_vm.boardList,"error-messages":_vm.errors.collect('board'),"data-vv-name":"board","name":"board","placeholder":_vm.$t('candidateProfile.qualificationDetails.plceHoSelectBoard'),"required":""},model:{value:(_vm.selectedBoard),callback:function ($$v) {_vm.selectedBoard=$$v},expression:"selectedBoard"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(" "+_vm._s(_vm.$t('candidateProfile.qualificationDetails.lblDateOfExam'))+"\n                    "),_c('date-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required|not_in:Select'),expression:"'required|not_in:Select'"}],class:{'form-error': _vm.errors.has('dateofResult'),'input': true, 'is-danger': _vm.errors.collect('dateofResult') },attrs:{"name":"dateofResult","data-vv-name":"dateofResult","data-vv-validate-on":"change","lang":"en"},model:{value:(_vm.startTime),callback:function ($$v) {_vm.startTime=$$v},expression:"startTime"}})],1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(_vm._s(_vm.$t('candidateProfile.qualificationDetails.lblRollSeatNo'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.educationDetails.seatNumber),expression:"educationDetails.seatNumber"},{name:"validate",rawName:"v-validate",value:('required|regex:^([A-Za-z0-9-_]+)$'),expression:"'required|regex:^([A-Za-z0-9-_]+)$'"}],staticClass:"form-control-alt col-3 uppercase",class:{'form-error': _vm.errors.has('form-1.Seat No'),'input': true, 'is-danger': _vm.errors.has('form-1.Seat No') },attrs:{"name":"Seat No","id":"namelc","maxlength":"18","oninput":"this.value=this.value.slice(0,this.maxLength||1/1);this.value=(this.value   < 0) ? (1/1) : this.value;","type":"text","placeholder":_vm.$t('candidateProfile.qualificationDetails.plceHoRollSeatNo')},domProps:{"value":(_vm.educationDetails.seatNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.educationDetails.seatNumber=$event.target.value}}}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(_vm._s(_vm.$t('candidateProfile.qualificationDetails.lblMarksheetNo'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|regex:^([A-Za-z0-9-_]+)$'),expression:"'required|regex:^([A-Za-z0-9-_]+)$'"},{name:"model",rawName:"v-model",value:(_vm.educationDetails.marksheetNo),expression:"educationDetails.marksheetNo"}],staticClass:"form-control-alt col-3 uppercase",class:{'form-error': _vm.errors.has('form-1.Marksheet No'),'input': true, 'is-danger': _vm.errors.has('form-1.Marksheet No') },attrs:{"name":"Marksheet No","id":"panNo","maxlength":"18","oninput":"this.value=this.value.slice(0,this.maxLength||1/1);this.value=(this.value   < 0) ? (1/1) : this.value;","type":"text","placeholder":_vm.$t('candidateProfile.qualificationDetails.plceHoMarksheetNo')},domProps:{"value":(_vm.educationDetails.marksheetNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.educationDetails.marksheetNo=$event.target.value}}}),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(_vm._s(_vm.$t('candidateProfile.qualificationDetails.lblWith'))+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.educationDetails.totalMarksObtained),expression:"educationDetails.totalMarksObtained"},{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],staticClass:"form-control-alt col-3 uppercase",class:{'form-error': _vm.errors.has('form-1.Total Mark'),'input': true, 'is-danger': _vm.errors.has('form-1.Total Mark') },attrs:{"name":"Total Mark","id":"totalMark","type":"number","placeholder":_vm.$t('candidateProfile.qualificationDetails.plceHoWith')},domProps:{"value":(_vm.educationDetails.totalMarksObtained)},on:{"input":function($event){if($event.target.composing){ return; }_vm.educationDetails.totalMarksObtained=$event.target.value}}}),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"para"},[_vm._v(_vm._s(_vm.$t('candidateProfile.qualificationDetails.lblOutOf')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.educationDetails.outOf),expression:"educationDetails.outOf"},{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],staticClass:"form-control-alt col-3 uppercase",class:{'form-error': _vm.errors.has('form-1.Out Of'), 'input': true, 'is-danger': _vm.errors.has('form-1.Out Of') },attrs:{"name":"Out Of","id":"outOf","min":_vm.educationDetails.totalMarksObtained,"type":"number","placeholder":_vm.$t('candidateProfile.qualificationDetails.plceHoOutOf')},domProps:{"value":(_vm.educationDetails.outOf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.educationDetails.outOf=$event.target.value}}}),_vm._v(" "),_vm._m(6)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:" row text-center p-3 pt-4"},[_c('button',{staticClass:"btn btn btn-info-alt mr-3",attrs:{"type":"button"},on:{"click":_vm.prevTabFunc}},[_vm._v(" "+_vm._s(_vm.$t('button.back')))]),_vm._v(" "),_c('button',{staticClass:"btn btn btn-orange ml-auto",attrs:{"type":"button"},on:{"click":_vm.save}},[_vm._v(" "+_vm._s(_vm.$t('button.next')))])])])]),_vm._v(" "),(_vm.showModal)?_c('modal',{staticClass:"lg",on:{"close":function($event){_vm.showModal = false}}},[(_vm.currentEduType == 'Diploma' || _vm.currentEduType == 'SSC' || _vm.currentEduType == 'HSC')?_c('h3',{slot:"header"},[_vm._v(_vm._s(_vm.currentEduType)+" "+_vm._s(_vm.$t('candidateProfile.qualificationDetails.lblDocument')))]):_vm._e(),_vm._v(" "),(_vm.currentEduType == 'HSCHallTicket')?_c('h3',{slot:"header"},[_vm._v(_vm._s(_vm.$t('candidateProfile.qualificationDetails.lblHSCHallTicketDetails'))+" "+_vm._s(_vm.$t('candidateProfile.qualificationDetails.lblDocument')))]):_vm._e(),_vm._v(" "),(_vm.currentEduType == 'DiplomaHallTicket')?_c('h3',{slot:"header"},[_vm._v(_vm._s(_vm.$t('candidateProfile.qualificationDetails.lblDiplomaHallTicketDetails'))+" "+_vm._s(_vm.$t('candidateProfile.qualificationDetails.lblDocument')))]):_vm._e(),_vm._v(" "),_c('div',{slot:"body"},[_c('img',{attrs:{"src":_vm.marksheetUrl,"width":"100%"}})])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2 lighten text-right"},[_c('h2',{staticClass:"page-title"},[_vm._v("80%")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])}]


/***/ }),

/***/ "qFyN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qf8G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.educationStatus.isSSCPassed),expression:"educationStatus.isSSCPassed"}],staticClass:"accordian-css",attrs:{"role":"tablist"}},[_c('div',{attrs:{"role":"tab col"}},[_c('div',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion1",modifiers:{"accordion1":true}}],staticClass:"title-css",attrs:{"href":"#","variant":"info"}},[_vm._v("1. SSC\r\n                        "),_c('span',[_vm._v("Click to view")])])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion1","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('ssc-details')],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.educationStatus.isHSCPassed),expression:"educationStatus.isHSCPassed"}],staticClass:"accordian-css",attrs:{"role":"tablist"}},[_c('div',{attrs:{"role":"tab col"}},[_c('div',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion2",modifiers:{"accordion2":true}}],staticClass:"title-css",attrs:{"href":"#","variant":"info"}},[_vm._v("2. HSC\r\n                        "),_c('span',[_vm._v("Click to view")])])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion2","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('hsc-details')],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.educationStatus.isDiplomaPassed),expression:"educationStatus.isDiplomaPassed"}],staticClass:"accordian-css",attrs:{"role":"tablist"}},[_c('div',{attrs:{"role":"tab col"}},[_c('div',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion3",modifiers:{"accordion3":true}}],staticClass:"title-css",attrs:{"href":"#","variant":"info"}},[_vm._v("3. Diploma\r\n                        "),_c('span',[_vm._v("Click to view")])])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion3","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('diploma-details')],1)],1)])}
var staticRenderFns = []


/***/ }),

/***/ "r1po":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rFqI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hscDetails_vue__ = __webpack_require__("USeP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cd4fa20_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hscDetails_vue__ = __webpack_require__("8imL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("XYOV")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hscDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cd4fa20_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hscDetails_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cd4fa20_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hscDetails_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rIof":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sign_up_vue__ = __webpack_require__("YDR2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_673ceed6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sign_up_vue__ = __webpack_require__("FiF/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("kilQ")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sign_up_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_673ceed6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sign_up_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_673ceed6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sign_up_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rb2e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ruvP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_termsConditions_vue__ = __webpack_require__("/AnM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c2f354b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_termsConditions_vue__ = __webpack_require__("Z0ny");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("CBuF")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_termsConditions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c2f354b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_termsConditions_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c2f354b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_termsConditions_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sEYM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workPlace_vue__ = __webpack_require__("dTzQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_367f9b17_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_workPlace_vue__ = __webpack_require__("nSpO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("8Y/r")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workPlace_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_367f9b17_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_workPlace_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_367f9b17_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_workPlace_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tudI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreement",attrs:{"id":"entry"}},[_c('div',{staticClass:"card-alt mt-0"},[_c('div',{staticClass:"card-alt-body"},[_c('div',{staticClass:"row "},[_c('div',{staticClass:"col-md-12"},[_c('div',{},[_c('div',{staticClass:"row mb-0"},[_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"page-header"},[_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col"},[_c('h2',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t('entry.candidateAgreement')))])])])])]),_vm._v(" "),(_vm.instructions.pdfURL)?_c('div',{staticClass:"col-lg-2 col-sm-4 text-center"},[_c('a',{staticClass:"btn btn-xs btn-default btn-circle",attrs:{"href":_vm.instructions.pdfURL,"download":"","target":"_blank"}},[_c('i',{staticClass:"mdi mdi-file"})]),_vm._v(" "),_c('p',{staticClass:"btn-text"},[_c('small',[_c('strong',[_vm._v(_vm._s(_vm.$t('instructions.btnPDF')))])])])]):_vm._e(),_vm._v(" "),(_vm.instructions.audioURL)?_c('div',{staticClass:"col-lg-2 col-sm-4 text-center"},[_c('button',{staticClass:"btn btn-xs btn-default btn-circle",attrs:{"type":"button"},on:{"click":_vm.playInstructionAudio}},[_c('i',{staticClass:"mdi mdi-headphones-settings"})]),_vm._v(" "),_c('p',{staticClass:"btn-text"},[_c('small',[_c('strong',[_vm._v(_vm._s(_vm.$t('instructions.btnAudio')))])])])]):_vm._e(),_vm._v(" "),(_vm.instructions.videoURL)?_c('div',{staticClass:"col-lg-2 col-sm-4 text-center"},[_c('button',{staticClass:"btn btn-xs btn-default btn-circle",attrs:{"type":"button"},on:{"click":_vm.playInstructionVideo}},[_c('i',{staticClass:"mdi mdi-video"})]),_vm._v(" "),_c('p',{staticClass:"btn-text"},[_c('small',[_c('strong',[_vm._v(_vm._s(_vm.$t('instructions.btnVideo')))])])])]):_vm._e()])]),_vm._v(" "),_c('div',[_c('b-modal',{ref:"instrAudioModalRef",attrs:{"size":"md","hide-footer":"","title":_vm.$t('instructions.lblAudioInstruction')},on:{"hidden":_vm.hideAudioModal}},[_c('div',{staticClass:"d-block text-left"},[_c('audio',{ref:"audioRef",attrs:{"src":"","id":"audio-container","type":"audio/mpeg","width":"100%","controls":""}})])]),_vm._v(" "),_c('b-modal',{ref:"instrVideoModalRef",attrs:{"size":"lg","hide-footer":"","title":_vm.$t('instructions.lblVideoInstruction')},on:{"hidden":_vm.hideInstructionVideoModal}},[_c('div',{staticClass:"d-block text-left"},[_c('div',{attrs:{"id":"app"}},[_c('iframe',{ref:"instrVideoRef",attrs:{"src":"","id":"video-container","width":"100%","height":"450"}})])])])],1)])]),_vm._v(" "),_c('p',{staticClass:"para height alert alert-info"},[_vm._v("\n        "+_vm._s(_vm.instructions.startUpPara)+"\n      ")]),_vm._v(" "),_c('p',{staticClass:"p-bot"},[_vm._v("\n        "+_vm._s(_vm.$t('candidateProfile.agreement.lblUndertakes'))+"\n      ")]),_vm._v(" "),_c('ul',_vm._l((_vm.undertakingsList),function(agreementIntrustion,index){return _c('li',{key:agreementIntrustion.instructionId},[_c('div',{staticClass:"row"},[(agreementIntrustion.checkRequired)?_c('div',{staticClass:"col-auto wrap-cb"},[_c('label',{staticClass:"c-wrap"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(agreementIntrustion.agree),expression:"agreementIntrustion.agree"}],attrs:{"type":"checkbox","checked":"checked","true-value":true,"false-value":false,"id":agreementIntrustion.instructionId},domProps:{"checked":Array.isArray(agreementIntrustion.agree)?_vm._i(agreementIntrustion.agree,null)>-1:(agreementIntrustion.agree)},on:{"change":function($event){_vm.selectionChanged(agreementIntrustion)},"__c":function($event){var $$a=agreementIntrustion.agree,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(agreementIntrustion.agree=$$a.concat($$v))}else{$$i>-1&&(agreementIntrustion.agree=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{agreementIntrustion.agree=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-9 para"},[_vm._v("\n              "+_vm._s(index + 1)+". "+_vm._s(agreementIntrustion.description)+"\n            ")])])])})),_vm._v(" "),_c('div',{staticClass:"wrap-cb"},[_c('label',{staticClass:"c-wrap"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agreeCondition),expression:"agreeCondition"}],attrs:{"type":"checkbox","checked":"checked"},domProps:{"value":true,"checked":Array.isArray(_vm.agreeCondition)?_vm._i(_vm.agreeCondition,true)>-1:(_vm.agreeCondition)},on:{"__c":function($event){var $$a=_vm.agreeCondition,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.agreeCondition=$$a.concat($$v))}else{$$i>-1&&(_vm.agreeCondition=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.agreeCondition=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('b',{staticClass:"para"},[_vm._m(0),_vm._v(_vm._s(_vm.$t('candidateProfile.agreement.lblRulesAgree')))])])]),_vm._v(" "),_c('div',{staticClass:"text-right "},[_c('button',{staticClass:"btn  btn btn-orange",attrs:{"type":"button","value":"I Agree","disabled":!_vm.agreeCondition},on:{"click":_vm.saveData}},[_vm._v(" "+_vm._s(_vm.$t('candidateProfile.agreement.btnIAgree')))])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('i',{staticClass:"mdi mdi-star text-danger"})])}]


/***/ }),

/***/ "u0m+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sscDetails_vue__ = __webpack_require__("yvjm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hscDetails_vue__ = __webpack_require__("rFqI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__diplomaDetails_vue__ = __webpack_require__("BGyx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EducationFieldDetails',
  components: {
    sscDetails: __WEBPACK_IMPORTED_MODULE_0__sscDetails_vue__["a" /* default */],
    hscDetails: __WEBPACK_IMPORTED_MODULE_1__hscDetails_vue__["a" /* default */],
    diplomaDetails: __WEBPACK_IMPORTED_MODULE_2__diplomaDetails_vue__["a" /* default */]
  },
  data: function data() {
    return {
      educationStatus: {}
    };
  },

  methods: {
    getEducationDetails: function getEducationDetails() {
      var self = this;
      var profileUser = this.$store.state.candidateProfile.profileUser;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('r/candidateProfile/getQualificationDetails/' + profileUser).then(function (response) {
        if (response.status === 200) {
          console.log('resp');
          self.educationStatus = response.data;
          // self.certificationList.push(self.defaultObj)
        }
      }).catch(function () {
        self.$toasted.error('Error while featch education details', {
          theme: 'bubble',
          duration: 2000
        });
      });
    }
  },
  created: function created() {
    this.getEducationDetails();
  }
});

/***/ }),

/***/ "uUKX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"courseSelect",attrs:{"id":"courseSelect"}},[_c('div',{},[_c('div',{staticClass:"card-alt-body"},[_c('div',{staticClass:"page-header"},[_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col-md-6"},[_c('h2',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t('candidateApplications.title')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 blue-color"},[_c('small',[_c('strong',[_vm._v("( "+_vm._s(_vm.$t('candidateApplications.instruction1'))+" )")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:" card-sec"},[_c('div',{staticClass:"input-group col-md-12 mb-3"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchBox),expression:"searchBox"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('candidateApplications.plceHoSearchBox'),"id":"searchBox"},domProps:{"value":(_vm.searchBox)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchBox=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.filterCourseUnivList),function(item){return _c('div',{key:item.courseID + item.uniID,staticClass:"col-md-6"},[_c('div',{staticClass:"card-course"},[_c('img',{staticClass:"course-icon",attrs:{"src":_vm.getLogoUrl(item.abbr),"alt":item.abbr,"width":"70px"}}),_vm._v(" "),_c('div',{staticClass:"card-data"},[_c('div',{staticClass:"ctitle"},[_vm._v(_vm._s(item.courseName))]),_vm._v(" "),_c('div',{staticClass:"utitle"},[_vm._v(_vm._s(item.uniName))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-success-alt",on:{"click":function($event){_vm.showConfirmation = true;_vm.courseObj = item}}},[_vm._v(_vm._s(_vm.$t('button.apply')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-info-alt",attrs:{"href":item.courseInfoUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('button.view')))])])])])})),_vm._v(" "),(_vm.filterCourseUnivList.length < 1)?_c('div',{staticClass:"red"},[_vm._v("\n                "+_vm._s(_vm.$t('candidateApplications.erorNotMatchFound'))+"\n              ")]):_vm._e()])])]),_vm._v(" "),(_vm.showConfirmation)?_c('modal',{staticClass:"sm",on:{"close":function($event){_vm.showConfirmation = false}}},[_c('h3',{slot:"header"},[_vm._v(_vm._s(_vm.$t('candidateApplications.confirmText'))+"\n        ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{slot:"body"},[_vm._v("\n          "+_vm._s(_vm.courseObj.courseName)+" "+_vm._s(_vm.$t('candidateApplications.atlbl'))+" "+_vm._s(_vm.courseObj.uniName)+"\n         ")]),_vm._v(" "),_c('div',{slot:"footer"},[_c('button',{staticClass:"btn btn btn-success-alt mr-3",attrs:{"type":"button"},on:{"click":function($event){_vm.apply(_vm.courseObj)}}},[_vm._v(" "+_vm._s(_vm.$t('button.confirm')))]),_vm._v(" "),_c('button',{staticClass:"btn btn btn-danger-alt mr-3",attrs:{"type":"button"},on:{"click":function($event){_vm.showConfirmation = false}}},[_vm._v(" "+_vm._s(_vm.$t('button.cancel')))])])]):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon",attrs:{"id":"search"}},[_c('i',{staticClass:"mdi mdi-magnify"})])}]


/***/ }),

/***/ "ua1h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mfs-header',
  props: ['menu'],
  data: function data() {
    return {
      username: '',
      docImagePath: 'static/assets/images/dummy.png',
      selectedLanguage: this.$t('selectLanguage')
    };
  },
  mounted: function mounted() {
    this.getUserDetails();
  },

  methods: {
    getUserDetails: function getUserDetails() {
      var _this = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/r/entry/getUserDetails/' + this.$store.state.candidateProfile.profileUser).then(function (response) {
        if (response.data !== null) {
          _this.$store.commit('STORE_PROFILE_USER_DETAILS', response.data);
          if (_this.$store.state.user.userDetails.personalDetails !== undefined) {
            for (var docImage = 0; docImage < _this.$store.state.user.userDetails.documents.length; docImage++) {
              if (_this.$store.state.user.userDetails.documents[docImage].docId === _this.$store.state.candidateProfile.profileUser + '_ProfilePicture') {
                _this.docImagePath = _this.$store.state.user.userDetails.documents[docImage].docImage;
                break;
              } else {
                _this.docImagePath = 'static/assets/images/dummy.png';
              }
            }
            _this.username = _this.$store.state.user.userDetails.personalDetails.fullName;
          }
        }
      }).catch(function (e) {
        _this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: _this.TOASTR_TIME
        });
      });
    },
    gotToMFS: function gotToMFS() {
      window.MKCLAPI.switchAppWithSingleSignOn(this.MFS_CLIENT_ID);
    },
    changeLanguage: function changeLanguage() {
      if (this.selectedLanguage === 'English') {
        this.$i18n.set('en');
      } else if (this.selectedLanguage === 'Marathi') {
        this.$i18n.set('mr');
      }
    },
    logout: function logout() {
      window.MKCLAPI.logout();
      this.$toasted.success(this.$t('headerBar.tostrLogout'), { theme: 'bubble', duration: this.TOASTR_TIME });
      this.$router.push('/');
      // window.location.href('http://localhost:8088/?#/')
    }
    // logout () {
    //   axios
    //     .post('/r/c/lcmslogin/logout')
    //     .then(response => {
    //       // console.log('response = ' + JSON.stringify(response))
    //       // if (response != null && !response.data) {
    //       //   console.log('Err while logout')
    //       //   this.$toasted.error('Oops! Something went wrong, Please Try again.', { theme: 'bubble', duration: 6000 })
    //       // } else {
    //       Vue.toasted.success('Logout succesfully!', { theme: 'bubble', duration: 6000 })
    //       this.$store.commit('STORE_CLEAR_ALL')
    //       sessionStorage.removeItem('authorization')
    //       this.$router.push({ name: 'Logout' })
    //       // }
    //     })
    //     .catch(e => {
    //       console.log(e)
    //       // this.$toasted.error('Oops! Something went wrong, Please Try again.', { theme: 'bubble', duration: 6000 })
    //       Vue.toasted.error('Oops! Something went wrong, Please Try again.', { theme: 'bubble', duration: 6000 })
    //       this.$store.commit('STORE_CLEAR_ALL')
    //       sessionStorage.removeItem('authorization')
    //       this.$router.push({ name: 'Logout' })
    //     })
    // }

  }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uxIY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_datepicker__ = __webpack_require__("VrvJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_modal_vue__ = __webpack_require__("yN8m");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'QualificationDetails',
  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_0_vue2_datepicker___default.a, modal: __WEBPACK_IMPORTED_MODULE_3__components_common_modal_vue__["a" /* default */]
  },
  data: function data() {
    return {
      days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
      placeholder: {
        date: 'Select Passing Date',
        dateRange: 'Select Date Range'
      },
      start: new Date(1960, 2, 1),
      end: new Date(2001, 8, 1),
      startTime: '',
      disabledDates: {
        to: new Date(2001, 8, 1),
        from: new Date(1960, 2, 1)
        /* daysOfMonth: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] */
      },
      educationDetails: {},
      selectedBoard: null,
      boardList: [],
      documentList: [],
      educationStatus: {},
      currentEduType: 'SSC',
      marksheetUrl: '',
      showModal: false
    };
  },

  methods: {
    validateMarks: function validateMarks() {
      if (parseInt(this.educationDetails.totalMarksObtained) > parseInt(this.educationDetails.outOf)) {
        return true;
      } else {
        return false;
      }
    },
    prevTabFunc: function prevTabFunc() {
      var _this = this;

      var self = this;
      if (this.currentEduType === 'SSC') {
        this.$router.push('documentsupload');
      } else {
        this.$validator.validate().then(function (results) {
          if (results) {
            _this.currentEduType = 'SSC';
            _this.clearObject();
          } else {
            _this.$toasted.error(self.$t('candidateProfile.qualificationDetails.toastrInvalidData'));
          }
        }).catch(function (e) {
          _this.$toasted.error(self.$t('toastr.toastrSomethingWentWrongs'));
        });
      }
    },
    clearObject: function clearObject(type) {
      // currentEduType = 'SSC',this.currentEduType = type
      this.marksheetUrl = '';
      this.startTime = '';
      this.selectedBoard = null;
      this.educationDetails = {};
      if (this.currentEduType === 'SSC' || this.currentEduType === 'HSC' || this.currentEduType === 'Diploma') {
        this.getUserSSCDetails();
      }
      this.getDocumentDetails();
      this.$validator.clean();
    },
    getBoardDetails: function getBoardDetails() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('r/candidateProfile/getBoardDetails').then(function (response) {
        if (response.status === 200) {
          self.boardList = response.data;
          self.getUserSSCDetails();
          // self.certificationList.push(self.defaultObj)
        }
      }).catch(function () {
        self.$toasted.error(self.$t('candidateProfile.certification.toastrErrorFetchingCertificationList'));
      });
    },
    getUserSSCDetails: function getUserSSCDetails() {
      var self = this;
      var profileUser = this.$store.state.candidateProfile.profileUser;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('r/candidateProfile/get' + this.currentEduType + 'Details/' + profileUser).then(function (response) {
        if (response.status === 200) {
          self.educationDetails = response.data;
          for (var i in self.boardList) {
            if (self.boardList[i].boardName === self.educationDetails.board) {
              self.selectedBoard = self.boardList[i];
            }
          }
          if (self.educationDetails.dateOfResult !== undefined && self.educationDetails.dateOfResult !== null && self.educationDetails.dateOfResult !== '') {
            var dateArray = self.educationDetails.dateOfResult.split('/');
            var supportDate = dateArray[2].concat('-').concat(dateArray[1]).concat('-').concat(dateArray[0]);
            self.startTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(String(supportDate)).format('YYYY-MM-DD');
          }
        }
      }).catch(function () {
        /*  self.$toasted.error(self.$t('candidateProfile.certification.toastrErrorFetchingCertificationList'), {
           theme: 'bubble',
           duration: 2000
         }) */
      });
    },
    save: function save() {
      var _this2 = this;

      var profileUser = this.$store.state.candidateProfile.profileUser;
      var self = this;
      if (this.currentEduType === 'SSC' || this.currentEduType === 'HSC' || this.currentEduType === 'Diploma') {
        if (parseInt(this.educationDetails.totalMarksObtained) > parseInt(this.educationDetails.outOf)) {
          this.$toasted.error(this.$t('candidateProfile.qualificationDetails.toastrMarkNotValid'));
          return false;
        }
        this.$validator.validate().then(function (result) {
          if (result) {
            _this2.educationDetails.board = _this2.selectedBoard.boardName;
            _this2.educationDetails.percent = (parseInt(_this2.educationDetails.totalMarksObtained) * 100 / parseInt(_this2.educationDetails.outOf)).toPrecision(4);
            _this2.educationDetails.seatNumber = _this2.educationDetails.seatNumber.toUpperCase();
            _this2.educationDetails.marksheetNo = _this2.educationDetails.marksheetNo.toUpperCase();
            _this2.educationDetails.dateOfResult = __WEBPACK_IMPORTED_MODULE_2_moment___default()(String(_this2.startTime)).format('DD/MM/YYYY');
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('r/candidateProfile/save' + _this2.currentEduType + 'Details/' + profileUser, _this2.educationDetails).then(function (response) {
              if (response.status === 200) {
                _this2.$toasted.success(_this2.currentEduType + self.$t('toastr.toastrDetailsSaved'));
                if (_this2.currentEduType === 'SSC') {
                  if (_this2.educationStatus.isHSCPassed) {
                    _this2.currentEduType = 'HSC';
                  } else if (_this2.educationStatus.isDiplomaPassed) {
                    _this2.currentEduType = 'Diploma';
                  } else if (_this2.educationStatus.isHSCAppeared) {
                    _this2.currentEduType = 'HSCHallTicket';
                  } else if (_this2.educationStatus.isDiplomaAppeared) {
                    _this2.currentEduType = 'DiplomaHallTicket';
                  } else {
                    _this2.$router.push('profileSummary');
                  }
                  _this2.clearObject();
                  return true;
                } else {
                  _this2.$router.push('profileSummary');
                }
              }
            }).catch(function (e) {
              console.log(e);
              return false;
            });
          } else {
            _this2.$toasted.error(self.$t('candidateProfile.qualificationDetails.toastrInvalidData'));
          }
        }).catch(function (e) {
          _this2.$toasted.error(self.$t('toastr.toastrSomethingWentWrongs'));
        });
      } else if (this.currentEduType === 'DiplomaHallTicket' || this.currentEduType === 'HSCHallTicket') {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('r/candidateProfile/SaveQualificationDetailsStatus/' + profileUser).then(function (response) {
          if (response.status === 200 && response.data) {
            self.$router.push('profileSummary');
          }
        }).catch(function () {
          self.$toasted.error(self.$t('toastr.toastrSomethingWentWrongs'));
        });
      }
    },
    getEducationDetails: function getEducationDetails() {
      var self = this;
      var profileUser = this.$store.state.candidateProfile.profileUser;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('r/candidateProfile/getQualificationDetails/' + profileUser).then(function (response) {
        if (response.status === 200) {
          self.educationStatus = response.data;
        }
      }).catch(function () {
        self.$toasted.error('Error while featch education details');
      });
    },
    getDocumentDetails: function getDocumentDetails() {
      var profileUser = this.$store.state.candidateProfile.profileUser;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('r/ocr/documents/' + profileUser).then(function (response) {
        if (response.status === 200) {
          self.documentList = response.data;
          for (var i in self.documentList) {
            if (self.documentList[i].documentKey === self.currentEduType) {
              self.marksheetUrl = self.documentList[i].marksheetUrl;
              break;
            }
          }
        }
      }).catch(function (e) {
        console.error(e);
        self.$toasted.error(self.$('candidateProfile.imageExtracter.toastrCertificationDetailsFeatchError'));
      });
    }
  },
  created: function created() {
    if (this.$store.state.user.userDetails.confirmStatus) {
      this.$router.push({ name: 'entry' });
    } else {
      this.getDocumentDetails();
      this.getEducationDetails();
      this.getBoardDetails();
    }
  }
});

/***/ }),

/***/ "vsuI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_modal_vue__ = __webpack_require__("yN8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_2_axios___default.a.default.baseURL = '';
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EducationalDetails',
  components: {
    modal: __WEBPACK_IMPORTED_MODULE_1__components_common_modal_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showModal: false,
      student: {},
      qualification: '',
      qualificationStatus: null,
      qualificationList: [],
      filterQualificationList: [],
      qualificationStatusList: [{
        'id': 1,
        'name': 'have passed'
      }, {
        'id': 2,
        'name': 'am appearing'
      }, {
        'id': 8,
        'name': 'never appeared'
      }]
    };
  },

  methods: {
    nextTabFunc: function nextTabFunc() {
      this.saveDetails();
    },
    prevTabFunc: function prevTabFunc() {
      this.$router.push('address');
    },

    changeStatusSelection: function changeStatusSelection(item) {
      if (item == null) {
        return false;
      }
      if (item.id === 8) {
        this.qualificationStatus = this.qualificationStatusList[0];
        for (var i in this.qualificationList) {
          if (this.qualificationList[i].qualificationTypeID === item.id) {
            this.qualification = this.qualificationList[i];
          }
        }
      }
    },
    changeSelection: function changeSelection(item) {
      if (item == null) {
        return false;
      }
      if (item.qualificationTypeID === 8) {
        this.qualificationStatus = this.qualificationStatusList[0];
      }
    },
    saveDetails: function saveDetails(scope) {
      var _this = this;

      var self = this;
      return this.$validator.validate().then(function (result) {
        if (result) {
          if (_this.qualification.qualificationTypeID !== 8) {
            _this.student.isSSCPassed = true;
            _this.student.isEligibile = true;
            if (_this.qualification.qualificationTypeID === 2 && _this.qualificationStatus.id === 1) {
              _this.student.isHSCPassed = true;
              _this.student.isDiplomaPassed = false;
              _this.student.neverAppeared = false;
              _this.student.isHSCAppeared = false;
              _this.student.isDiplomaAppeared = false;
            } else if (_this.qualification.qualificationTypeID === 2 && _this.qualificationStatus.id === 2) {
              _this.student.isHSCPassed = false;
              _this.student.isDiplomaPassed = false;
              _this.student.neverAppeared = false;
              _this.student.isHSCAppeared = true;
              _this.student.isDiplomaAppeared = false;
            } else if (_this.qualification.qualificationTypeID === 3 && _this.qualificationStatus.id === 1) {
              _this.student.isHSCPassed = false;
              _this.student.isHSCAppeared = false;
              _this.student.isDiplomaPassed = true;
              _this.student.neverAppeared = false;
              _this.student.isDiplomaAppeared = false;
            } else if (_this.qualification.qualificationTypeID === 3 && _this.qualificationStatus.id === 2) {
              _this.student.isHSCPassed = false;
              _this.student.isHSCAppeared = false;
              _this.student.isDiplomaPassed = false;
              _this.student.neverAppeared = false;
              _this.student.isDiplomaAppeared = true;
            }
          } else {
            _this.student.isSSCPassed = false;
            _this.student.isHSCPassed = false;
            _this.student.isDiplomaPassed = false;
            _this.student.isEligibile = false;
            _this.student.isDiplomaAppeared = false;
            _this.student.isHSCAppeared = false;
            _this.student.neverAppeared = true;
          }
          if (_this.student.isEligibile !== false) {
            var profileUser = _this.$store.state.candidateProfile.profileUser;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/r/candidateProfile/updateEducationDetails/' + profileUser, _this.student).then(function (response) {
              if (response.data !== null && response.data === 'true') {
                _this.$toasted.success(self.$t('toastr.toastrEducationalDetailsSaved'), {
                  theme: 'bubble',
                  duration: _this.TOASTR_TIME
                });
                _this.$router.push('documentsupload');
                return true;
              } else {
                _this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
                  theme: 'bubble',
                  duration: _this.TOASTR_TIME
                });
                return false;
              }
            }).catch(function (e) {
              _this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
                theme: 'bubble',
                duration: _this.TOASTR_TIME
              });
              console.error(e);
              return false;
            });
          } else {
            _this.showModal = true;
          }
        }
        if (_this.qualification === undefined || _this.qualification === null || _this.qualification === '') {
          _this.$toasted.error(self.$t('candidateProfile.educationDetails.toastrSelectQualification'), {
            theme: 'bubble',
            duration: _this.TOASTR_TIME
          });
        } else if ((_this.qualificationStatus === undefined || _this.qualificationStatus === null || _this.qualificationStatus === '') && _this.qualification.qualificationTypeID !== 8) {
          _this.$toasted.error(self.$t('candidateProfile.educationDetails.toastrSelectQualificationStatus'), {
            theme: 'bubble',
            duration: _this.TOASTR_TIME
          });
        }
        return false;
      }).catch(function (e) {
        console.error(e);
        return false;
      });
    },
    getPreviousQualificationDetails: function getPreviousQualificationDetails() {
      var _this2 = this;

      var self = this;
      var profileUser = this.$store.state.candidateProfile.profileUser;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/r/candidateProfile/getQualificationDetails/' + profileUser).then(function (response) {
        if (response.data !== null) {
          _this2.student = response.data;
          if (_this2.student.isHSCPassed === true || _this2.student.isHSCAppeared === true) {
            for (var index = 0; index < _this2.qualificationList.length; index++) {
              if (_this2.qualificationList[index].qualificationTypeID === 2) {
                _this2.qualification = _this2.qualificationList[index];
                break;
              }
            }
            _this2.qualificationStatus = _this2.qualificationStatusList[0];
            if (_this2.student.isHSCAppeared === true) {
              _this2.qualificationStatus = _this2.qualificationStatusList[1];
            }
          } else if (_this2.student.isDiplomaPassed === true || _this2.student.isDiplomaAppeared === true) {
            for (var _index = 0; _index < _this2.qualificationList.length; _index++) {
              if (_this2.qualificationList[_index].qualificationTypeID === 3) {
                _this2.qualification = _this2.qualificationList[_index];
                break;
              }
            }
            _this2.qualificationStatus = _this2.qualificationStatusList[0];
            if (_this2.student.isDiplomaAppeared === true) {
              _this2.qualificationStatus = _this2.qualificationStatusList[1];
            }
          } else if (_this2.student.neverAppeared === true) {
            for (var _index2 = _this2.qualificationList.length - 1; _index2 >= 0; _index2--) {
              if (_this2.qualificationList[_index2].qualificationTypeID === 8) {
                _this2.qualification = _this2.qualificationList[_index2];
                break;
              }
            }
          }
        }
      }).catch(function (e) {
        _this2.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: _this2.TOASTR_TIME
        });
        console.error(e);
      });
    },
    fetchEducationLevel: function fetchEducationLevel() {
      var _this3 = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/r/getEducationLevel').then(function (response) {
        var _filterQualificationL;

        _this3.qualificationList = response.data;
        (_filterQualificationL = _this3.filterQualificationList).push.apply(_filterQualificationL, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this3.qualificationList));
        for (var i in _this3.filterQualificationList) {
          if (_this3.filterQualificationList[i].qualificationTypeID === 8) {
            delete _this3.filterQualificationList[i];
          }
        }
        _this3.getPreviousQualificationDetails();
      }).catch(function (e) {
        _this3.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: _this3.TOASTR_TIME
        });
        console.error(e);
      });
    }
  },
  created: function created() {
    if (this.$store.state.user.userDetails.confirmStatus) {
      this.$router.push({ name: 'entry' });
    } else {
      this.fetchEducationLevel();
    }
  }
});

/***/ }),

/***/ "xBa1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cov-vue-date",class:_vm.option.wrapperClass ? _vm.option.wrapperClass : {}},[_c('div',{staticClass:"datepickbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"cov-datepicker",class:_vm.option.inputClass ? _vm.option.inputClass : {},style:(_vm.option.inputStyle ? _vm.option.inputStyle : {}),attrs:{"type":"text","title":"input date","readonly":"readonly","placeholder":_vm.option.placeholder,"required":_vm.required},domProps:{"value":(_vm.value)},on:{"click":_vm.showCheck,"focus":_vm.showCheck,"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})]),_vm._v(" "),(_vm.showInfo.check)?_c('div',{staticClass:"datepicker-overlay",style:({'background' : _vm.option.overlayOpacity? 'rgba(0,0,0,'+_vm.option.overlayOpacity+')' : 'rgba(0,0,0,0.5)'}),on:{"click":function($event){_vm.dismiss($event)}}},[_c('div',{staticClass:"cov-date-body",class:_vm.option.dateBodyClass ? _vm.option.dateBodyClass : {},style:({'background-color': _vm.option.color ? _vm.option.color.header : '#3f51b5'})},[_c('div',{staticClass:"cov-date-monthly"},[_c('div',{staticClass:"cov-date-previous",on:{"click":function($event){_vm.nextMonth('pre')}}},[_vm._v("«")]),_vm._v(" "),_c('div',{staticClass:"cov-date-caption",style:({'color': _vm.option.color ? _vm.option.color.headerText : '#fff'})},[_c('span',{on:{"click":_vm.showYear}},[_c('small',[_vm._v(_vm._s(_vm.checked.year))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{on:{"click":_vm.showMonth}},[_vm._v(_vm._s(_vm.displayInfo.month))])]),_vm._v(" "),_c('div',{staticClass:"cov-date-next",on:{"click":function($event){_vm.nextMonth('next')}}},[_vm._v("»")])]),_vm._v(" "),(_vm.showInfo.day)?_c('div',{staticClass:"cov-date-box"},[_c('div',{staticClass:"cov-picker-box"},[_c('div',{staticClass:"week"},[_c('ul',_vm._l((_vm.library.week),function(weekie){return _c('li',[_vm._v(_vm._s(weekie))])}))]),_vm._v(" "),_vm._l((_vm.dayList),function(day,index){return _c('div',{key:index,staticClass:"day",class:{'checked':day.checked,'unavailable':day.unavailable,'passive-day': !(day.inMonth)},style:(day.checked ? (_vm.option.color && _vm.option.color.checkedDay ? { background: _vm.option.color.checkedDay } : { background: '#F50057' }) : {}),on:{"click":function($event){_vm.checkDay(day)}}},[_vm._v(_vm._s(day.value))])})],2)]):_vm._e(),_vm._v(" "),(_vm.showInfo.year)?_c('div',{staticClass:"cov-date-box list-box"},[_c('div',{staticClass:"cov-picker-box date-list",attrs:{"id":"yearList"}},_vm._l((_vm.library.year),function(yearItem,index){return _c('div',{key:index,staticClass:"date-item",on:{"click":function($event){_vm.setYear(yearItem)}}},[_vm._v(_vm._s(yearItem))])}))]):_vm._e(),_vm._v(" "),(_vm.showInfo.month)?_c('div',{staticClass:"cov-date-box list-box"},[_c('div',{staticClass:"cov-picker-box date-list"},_vm._l((_vm.library.month),function(monthItem,index){return _c('div',{key:index,staticClass:"date-item",on:{"click":function($event){_vm.setMonth(monthItem)}}},[_vm._v(_vm._s(monthItem))])}))]):_vm._e(),_vm._v(" "),(_vm.showInfo.hour)?_c('div',{staticClass:"cov-date-box list-box"},[_c('div',{staticClass:"cov-picker-box date-list"},[_c('div',{staticClass:"watch-box"},[_c('div',{staticClass:"hour-box"},[_c('div',{staticClass:"mui-pciker-rule mui-pciker-rule-ft"}),_vm._v(" "),_c('ul',_vm._l((_vm.hours),function(hitem){return _c('li',{staticClass:"hour-item",class:{'active':hitem.checked},on:{"click":function($event){_vm.setTime('hour', hitem, _vm.hours)}}},[_vm._v(_vm._s(hitem.value))])}))]),_vm._v(" "),_c('div',{staticClass:"min-box"},[_c('div',{staticClass:"mui-pciker-rule mui-pciker-rule-ft"}),_vm._v(" "),_vm._l((_vm.mins),function(mitem){return _c('div',{staticClass:"min-item",class:{'active':mitem.checked},on:{"click":function($event){_vm.setTime('min',mitem, _vm.mins)}}},[_vm._v(_vm._s(mitem.value))])})],2)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"button-box"},[_c('span',{staticClass:"button-cancel",on:{"click":function($event){_vm.showInfo.check=false}}},[_vm._v(_vm._s(_vm.option.buttons? _vm.option.buttons.cancel : 'Cancel'))]),_vm._v(" "),_c('span',{staticClass:"button-ok",on:{"click":_vm.picked}},[_vm._v(_vm._s(_vm.option.buttons? _vm.option.buttons.ok : 'Ok'))])])])]):_vm._e()])}
var staticRenderFns = []


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_mfs_header_vue__ = __webpack_require__("BlQR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_mfs_footer_vue__ = __webpack_require__("WYlY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_sidebar__ = __webpack_require__("47bd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_loader__ = __webpack_require__("DXrT");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: { mfsHeader: __WEBPACK_IMPORTED_MODULE_0__components_common_mfs_header_vue__["a" /* default */], mfsFooter: __WEBPACK_IMPORTED_MODULE_1__components_common_mfs_footer_vue__["a" /* default */], Sidebar: __WEBPACK_IMPORTED_MODULE_2__components_common_sidebar__["a" /* default */], Loader: __WEBPACK_IMPORTED_MODULE_3__components_common_loader__["a" /* default */] },
  data: function data() {
    return {};
  },

  computed: {
    isNormalPage: function isNormalPage() {
      if (this.$route.path === '/' || this.$route.path === '/login' || this.$route.path === '/logout' || this.$route.path === '/signup') {
        return false;
      }
      return true;
    }
  }
});

/***/ }),

/***/ "xtL+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_address_vue__ = __webpack_require__("LR9A");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22dd606f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_address_vue__ = __webpack_require__("N8GI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_address_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22dd606f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_address_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22dd606f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_address_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yN8m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__("Y+0M");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8056ada_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__ = __webpack_require__("aCnX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("K0Fx")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8056ada_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8056ada_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yvjm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sscDetails_vue__ = __webpack_require__("YUUT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_537cf75e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sscDetails_vue__ = __webpack_require__("d9E2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("DNzp")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sscDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_537cf75e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sscDetails_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_537cf75e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sscDetails_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zayz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.de9a3f329c5732b9ba7c.js